webpackJsonp([145402879059425],{

/***/ 410:
/***/ (function(module, exports) {

	module.exports = {"O_RDONLY":0,"O_WRONLY":1,"O_RDWR":2,"S_IFMT":61440,"S_IFREG":32768,"S_IFDIR":16384,"S_IFCHR":8192,"S_IFBLK":24576,"S_IFIFO":4096,"S_IFLNK":40960,"S_IFSOCK":49152,"O_CREAT":512,"O_EXCL":2048,"O_NOCTTY":131072,"O_TRUNC":1024,"O_APPEND":8,"O_DIRECTORY":1048576,"O_NOFOLLOW":256,"O_SYNC":128,"O_SYMLINK":2097152,"O_NONBLOCK":4,"S_IRWXU":448,"S_IRUSR":256,"S_IWUSR":128,"S_IXUSR":64,"S_IRWXG":56,"S_IRGRP":32,"S_IWGRP":16,"S_IXGRP":8,"S_IRWXO":7,"S_IROTH":4,"S_IWOTH":2,"S_IXOTH":1,"E2BIG":7,"EACCES":13,"EADDRINUSE":48,"EADDRNOTAVAIL":49,"EAFNOSUPPORT":47,"EAGAIN":35,"EALREADY":37,"EBADF":9,"EBADMSG":94,"EBUSY":16,"ECANCELED":89,"ECHILD":10,"ECONNABORTED":53,"ECONNREFUSED":61,"ECONNRESET":54,"EDEADLK":11,"EDESTADDRREQ":39,"EDOM":33,"EDQUOT":69,"EEXIST":17,"EFAULT":14,"EFBIG":27,"EHOSTUNREACH":65,"EIDRM":90,"EILSEQ":92,"EINPROGRESS":36,"EINTR":4,"EINVAL":22,"EIO":5,"EISCONN":56,"EISDIR":21,"ELOOP":62,"EMFILE":24,"EMLINK":31,"EMSGSIZE":40,"EMULTIHOP":95,"ENAMETOOLONG":63,"ENETDOWN":50,"ENETRESET":52,"ENETUNREACH":51,"ENFILE":23,"ENOBUFS":55,"ENODATA":96,"ENODEV":19,"ENOENT":2,"ENOEXEC":8,"ENOLCK":77,"ENOLINK":97,"ENOMEM":12,"ENOMSG":91,"ENOPROTOOPT":42,"ENOSPC":28,"ENOSR":98,"ENOSTR":99,"ENOSYS":78,"ENOTCONN":57,"ENOTDIR":20,"ENOTEMPTY":66,"ENOTSOCK":38,"ENOTSUP":45,"ENOTTY":25,"ENXIO":6,"EOPNOTSUPP":102,"EOVERFLOW":84,"EPERM":1,"EPIPE":32,"EPROTO":100,"EPROTONOSUPPORT":43,"EPROTOTYPE":41,"ERANGE":34,"EROFS":30,"ESPIPE":29,"ESRCH":3,"ESTALE":70,"ETIME":101,"ETIMEDOUT":60,"ETXTBSY":26,"EWOULDBLOCK":35,"EXDEV":18,"SIGHUP":1,"SIGINT":2,"SIGQUIT":3,"SIGILL":4,"SIGTRAP":5,"SIGABRT":6,"SIGIOT":6,"SIGBUS":10,"SIGFPE":8,"SIGKILL":9,"SIGUSR1":30,"SIGSEGV":11,"SIGUSR2":31,"SIGPIPE":13,"SIGALRM":14,"SIGTERM":15,"SIGCHLD":20,"SIGCONT":19,"SIGSTOP":17,"SIGTSTP":18,"SIGTTIN":21,"SIGTTOU":22,"SIGURG":16,"SIGXCPU":24,"SIGXFSZ":25,"SIGVTALRM":26,"SIGPROF":27,"SIGWINCH":28,"SIGIO":23,"SIGSYS":12,"SSL_OP_ALL":2147486719,"SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION":262144,"SSL_OP_CIPHER_SERVER_PREFERENCE":4194304,"SSL_OP_CISCO_ANYCONNECT":32768,"SSL_OP_COOKIE_EXCHANGE":8192,"SSL_OP_CRYPTOPRO_TLSEXT_BUG":2147483648,"SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS":2048,"SSL_OP_EPHEMERAL_RSA":0,"SSL_OP_LEGACY_SERVER_CONNECT":4,"SSL_OP_MICROSOFT_BIG_SSLV3_BUFFER":32,"SSL_OP_MICROSOFT_SESS_ID_BUG":1,"SSL_OP_MSIE_SSLV2_RSA_PADDING":0,"SSL_OP_NETSCAPE_CA_DN_BUG":536870912,"SSL_OP_NETSCAPE_CHALLENGE_BUG":2,"SSL_OP_NETSCAPE_DEMO_CIPHER_CHANGE_BUG":1073741824,"SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG":8,"SSL_OP_NO_COMPRESSION":131072,"SSL_OP_NO_QUERY_MTU":4096,"SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION":65536,"SSL_OP_NO_SSLv2":16777216,"SSL_OP_NO_SSLv3":33554432,"SSL_OP_NO_TICKET":16384,"SSL_OP_NO_TLSv1":67108864,"SSL_OP_NO_TLSv1_1":268435456,"SSL_OP_NO_TLSv1_2":134217728,"SSL_OP_PKCS1_CHECK_1":0,"SSL_OP_PKCS1_CHECK_2":0,"SSL_OP_SINGLE_DH_USE":1048576,"SSL_OP_SINGLE_ECDH_USE":524288,"SSL_OP_SSLEAY_080_CLIENT_DH_BUG":128,"SSL_OP_SSLREF2_REUSE_CERT_TYPE_BUG":0,"SSL_OP_TLS_BLOCK_PADDING_BUG":512,"SSL_OP_TLS_D5_BUG":256,"SSL_OP_TLS_ROLLBACK_BUG":8388608,"ENGINE_METHOD_DSA":2,"ENGINE_METHOD_DH":4,"ENGINE_METHOD_RAND":8,"ENGINE_METHOD_ECDH":16,"ENGINE_METHOD_ECDSA":32,"ENGINE_METHOD_CIPHERS":64,"ENGINE_METHOD_DIGESTS":128,"ENGINE_METHOD_STORE":256,"ENGINE_METHOD_PKEY_METHS":512,"ENGINE_METHOD_PKEY_ASN1_METHS":1024,"ENGINE_METHOD_ALL":65535,"ENGINE_METHOD_NONE":0,"DH_CHECK_P_NOT_SAFE_PRIME":2,"DH_CHECK_P_NOT_PRIME":1,"DH_UNABLE_TO_CHECK_GENERATOR":4,"DH_NOT_SUITABLE_GENERATOR":8,"NPN_ENABLED":1,"RSA_PKCS1_PADDING":1,"RSA_SSLV23_PADDING":2,"RSA_NO_PADDING":3,"RSA_PKCS1_OAEP_PADDING":4,"RSA_X931_PADDING":5,"RSA_PKCS1_PSS_PADDING":6,"POINT_CONVERSION_COMPRESSED":2,"POINT_CONVERSION_UNCOMPRESSED":4,"POINT_CONVERSION_HYBRID":6,"F_OK":0,"R_OK":4,"W_OK":2,"X_OK":1,"UV_UDP_REUSEADDR":4}

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Jump = factory());
	}(this, (function () { 'use strict';
	
	// Robert Penner's easeInOutQuad
	
	// find the rest of his easing functions here: http://robertpenner.com/easing/
	// find them exported for ES6 consumption here: https://github.com/jaxgeller/ez.js
	
	var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
	  t /= d / 2;
	  if (t < 1) return c / 2 * t * t + b;
	  t--;
	  return -c / 2 * (t * (t - 2) - 1) + b;
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var jumper = function jumper() {
	  // private variable cache
	  // no variables are created during a jump, preventing memory leaks
	
	  var element = void 0; // element to scroll to                   (node)
	
	  var start = void 0; // where scroll starts                    (px)
	  var stop = void 0; // where scroll stops                     (px)
	
	  var offset = void 0; // adjustment from the stop position      (px)
	  var easing = void 0; // easing function                        (function)
	  var a11y = void 0; // accessibility support flag             (boolean)
	
	  var distance = void 0; // distance of scroll                     (px)
	  var duration = void 0; // scroll duration                        (ms)
	
	  var timeStart = void 0; // time scroll started                    (ms)
	  var timeElapsed = void 0; // time spent scrolling thus far          (ms)
	
	  var next = void 0; // next scroll position                   (px)
	
	  var callback = void 0; // to call when done scrolling            (function)
	
	  // scroll position helper
	
	  function location() {
	    return window.scrollY || window.pageYOffset;
	  }
	
	  // element offset helper
	
	  function top(element) {
	    return element.getBoundingClientRect().top + start;
	  }
	
	  // rAF loop helper
	
	  function loop(timeCurrent) {
	    // store time scroll started, if not started already
	    if (!timeStart) {
	      timeStart = timeCurrent;
	    }
	
	    // determine time spent scrolling so far
	    timeElapsed = timeCurrent - timeStart;
	
	    // calculate next scroll position
	    next = easing(timeElapsed, start, distance, duration);
	
	    // scroll to it
	    window.scrollTo(0, next);
	
	    // check progress
	    timeElapsed < duration ? window.requestAnimationFrame(loop) // continue scroll loop
	    : done(); // scrolling is done
	  }
	
	  // scroll finished helper
	
	  function done() {
	    // account for rAF time rounding inaccuracies
	    window.scrollTo(0, start + distance);
	
	    // if scrolling to an element, and accessibility is enabled
	    if (element && a11y) {
	      // add tabindex indicating programmatic focus
	      element.setAttribute('tabindex', '-1');
	
	      // focus the element
	      element.focus();
	    }
	
	    // if it exists, fire the callback
	    if (typeof callback === 'function') {
	      callback();
	    }
	
	    // reset time for next jump
	    timeStart = false;
	  }
	
	  // API
	
	  function jump(target) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    // resolve options, or use defaults
	    duration = options.duration || 1000;
	    offset = options.offset || 0;
	    callback = options.callback; // "undefined" is a suitable default, and won't be called
	    easing = options.easing || easeInOutQuad;
	    a11y = options.a11y || false;
	
	    // cache starting position
	    start = location();
	
	    // resolve target
	    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
	      // scroll from current position
	      case 'number':
	        element = undefined; // no element to scroll to
	        a11y = false; // make sure accessibility is off
	        stop = start + target;
	        break;
	
	      // scroll to element (node)
	      // bounding rect is relative to the viewport
	      case 'object':
	        element = target;
	        stop = top(element);
	        break;
	
	      // scroll to element (selector)
	      // bounding rect is relative to the viewport
	      case 'string':
	        element = document.querySelector(target);
	        stop = top(element);
	        break;
	    }
	
	    // resolve scroll distance, accounting for offset
	    distance = stop - start + offset;
	
	    // resolve duration
	    switch (_typeof(options.duration)) {
	      // number in ms
	      case 'number':
	        duration = options.duration;
	        break;
	
	      // function passed the distance of the scroll
	      case 'function':
	        duration = options.duration(distance);
	        break;
	    }
	
	    // start the loop
	    window.requestAnimationFrame(loop);
	  }
	
	  // expose only the jump method
	  return jump;
	};
	
	// export singleton
	
	var singleton = jumper();
	
	return singleton;
	
	})));


/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"object"==typeof navigator&&function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("Plyr",t):e.Plyr=t()}(this,function(){"use strict";"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self&&self;var e,t,i=(function(e,t){var i;i=function(){var e=function(){},t={},i={},n={};function s(e,t){if(e){var s=n[e];if(i[e]=t,s)for(;s.length;)s[0](e,t),s.splice(0,1)}}function a(t,i){t.call&&(t={success:t}),i.length?(t.error||e)(i):(t.success||e)(t)}function r(t,i,n,s){var a,l,o=document,c=n.async,u=(n.numRetries||0)+1,d=n.before||e,p=t.replace(/^(css|img)!/,"");s=s||0,/(^css!|\.css$)/.test(t)?(a=!0,(l=o.createElement("link")).rel="stylesheet",l.href=p):/(^img!|\.(png|gif|jpg|svg)$)/.test(t)?(l=o.createElement("img")).src=p:((l=o.createElement("script")).src=t,l.async=void 0===c||c),l.onload=l.onerror=l.onbeforeload=function(e){var o=e.type[0];if(a&&"hideFocus"in l)try{l.sheet.cssText.length||(o="e")}catch(e){o="e"}if("e"==o&&(s+=1)<u)return r(t,i,n,s);i(t,o,e.defaultPrevented)},!1!==d(t,l)&&o.head.appendChild(l)}function l(e,i,n){var l,o;if(i&&i.trim&&(l=i),o=(l?n:i)||{},l){if(l in t)throw"LoadJS";t[l]=!0}!function(e,t,i){var n,s,a=(e=e.push?e:[e]).length,l=a,o=[];for(n=function(e,i,n){if("e"==i&&o.push(e),"b"==i){if(!n)return;o.push(e)}--a||t(o)},s=0;s<l;s++)r(e[s],n,i)}(e,function(e){a(o,e),s(l,e)},o)}return l.ready=function(e,t){return function(e,t){e=e.push?e:[e];var s,a,r,l=[],o=e.length,c=o;for(s=function(e,i){i.length&&l.push(e),--c||t(l)};o--;)a=e[o],(r=i[a])?s(a,r):(n[a]=n[a]||[]).push(s)}(e,function(e){a(t,e)}),l},l.done=function(e){s(e,[])},l.reset=function(){t={},i={},n={}},l.isDefined=function(e){return e in t},l},e.exports=i()}(e={exports:{}},e.exports),e.exports),n=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},s=function(){function e(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,i,n){return i&&e(t.prototype,i),n&&e(t,n),t}}(),a=function(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e},r=function(){return function(e,t){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return function(e,t){var i=[],n=!0,s=!1,a=void 0;try{for(var r,l=e[Symbol.iterator]();!(n=(r=l.next()).done)&&(i.push(r.value),!t||i.length!==t);n=!0);}catch(e){s=!0,a=e}finally{try{!n&&l.return&&l.return()}finally{if(s)throw a}}return i}(e,t);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),l=function(){function e(t){n(this,e),this.enabled=t.config.storage.enabled,this.key=t.config.storage.key}return s(e,[{key:"get",value:function(t){if(!e.supported||!this.enabled)return null;var i=window.localStorage.getItem(this.key);if(u.is.empty(i))return null;var n=JSON.parse(i);return u.is.string(t)&&t.length?n[t]:n}},{key:"set",value:function(t){if(e.supported&&this.enabled&&u.is.object(t)){var i=this.get();u.is.empty(i)&&(i={}),u.extend(i,t),window.localStorage.setItem(this.key,JSON.stringify(i))}}}],[{key:"supported",get:function(){try{if(!("localStorage"in window))return!1;return window.localStorage.setItem("___test","___test"),window.localStorage.removeItem("___test"),!0}catch(e){return!1}}}]),e}(),o={html5:"html5",youtube:"youtube",vimeo:"vimeo"},c={audio:"audio",video:"video"},u={is:{object:function(e){return this.getConstructor(e)===Object},number:function(e){return this.getConstructor(e)===Number&&!Number.isNaN(e)},string:function(e){return this.getConstructor(e)===String},boolean:function(e){return this.getConstructor(e)===Boolean},function:function(e){return this.getConstructor(e)===Function},array:function(e){return!this.nullOrUndefined(e)&&Array.isArray(e)},weakMap:function(e){return this.instanceof(e,WeakMap)},nodeList:function(e){return this.instanceof(e,NodeList)},element:function(e){return this.instanceof(e,Element)},textNode:function(e){return this.getConstructor(e)===Text},event:function(e){return this.instanceof(e,Event)},cue:function(e){return this.instanceof(e,window.TextTrackCue)||this.instanceof(e,window.VTTCue)},track:function(e){return this.instanceof(e,TextTrack)||!this.nullOrUndefined(e)&&this.string(e.kind)},url:function(e){return!this.nullOrUndefined(e)&&/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/.test(e)},nullOrUndefined:function(e){return null==e},empty:function(e){return this.nullOrUndefined(e)||(this.string(e)||this.array(e)||this.nodeList(e))&&!e.length||this.object(e)&&!Object.keys(e).length},instanceof:function(e,t){return Boolean(e&&t&&e instanceof t)},getConstructor:function(e){return this.nullOrUndefined(e)?null:e.constructor}},getBrowser:function(){return{isIE:!!document.documentMode,isWebkit:"WebkitAppearance"in document.documentElement.style&&!/Edge/.test(navigator.userAgent),isIPhone:/(iPhone|iPod)/gi.test(navigator.platform),isIos:/(iPad|iPhone|iPod)/gi.test(navigator.platform)}},fetch:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"text";return new Promise(function(i,n){try{var s=new XMLHttpRequest;if(!("withCredentials"in s))return;s.addEventListener("load",function(){if("text"===t)try{i(JSON.parse(s.responseText))}catch(e){i(s.responseText)}else i(s.response)}),s.addEventListener("error",function(){throw new Error(s.statusText)}),s.open("GET",e,!0),s.responseType=t,s.send()}catch(e){n(e)}})},loadImage:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;return new Promise(function(i,n){var s=new Image,a=function(){delete s.onload,delete s.onerror,(s.naturalWidth>=t?i:n)(s)};Object.assign(s,{onload:a,onerror:a,src:e})})},loadScript:function(e){return new Promise(function(t,n){i(e,{success:t,error:n})})},loadSprite:function(e,t){if(u.is.string(e)){var i=u.is.string(t),n=function(){return document.querySelectorAll("#"+t).length};if(!i||!n()){var s=l.supported,a=document.createElement("div");if(u.toggleHidden(a,!0),i&&a.setAttribute("id",t),s){var r=window.localStorage.getItem("cache-"+t);if(null!==r){var o=JSON.parse(r);return void c.call(a,o.content)}}u.fetch(e).then(function(e){u.is.empty(e)||(s&&window.localStorage.setItem("cache-"+t,JSON.stringify({content:e})),c.call(a,e))}).catch(function(){})}}function c(e){i&&n()||(this.innerHTML=e,document.body.insertBefore(this,document.body.childNodes[0]))}},generateId:function(e){return e+"-"+Math.floor(1e4*Math.random())},wrap:function(e,t){var i=e.length?e:[e];Array.from(i).reverse().forEach(function(e,i){var n=i>0?t.cloneNode(!0):t,s=e.parentNode,a=e.nextSibling;n.appendChild(e),a?s.insertBefore(n,a):s.appendChild(n)})},createElement:function(e,t,i){var n=document.createElement(e);return u.is.object(t)&&u.setAttributes(n,t),u.is.string(i)&&(n.innerText=i),n},insertAfter:function(e,t){t.parentNode.insertBefore(e,t.nextSibling)},insertElement:function(e,t,i,n){t.appendChild(u.createElement(e,i,n))},removeElement:function(e){u.is.nodeList(e)||u.is.array(e)?Array.from(e).forEach(u.removeElement):u.is.element(e)&&u.is.element(e.parentNode)&&e.parentNode.removeChild(e)},emptyElement:function(e){for(var t=e.childNodes.length;t>0;)e.removeChild(e.lastChild),t-=1},replaceElement:function(e,t){return u.is.element(t)&&u.is.element(t.parentNode)&&u.is.element(e)?(t.parentNode.replaceChild(e,t),e):null},setAttributes:function(e,t){u.is.element(e)&&!u.is.empty(t)&&Object.entries(t).forEach(function(t){var i=r(t,2),n=i[0],s=i[1];e.setAttribute(n,s)})},getAttributesFromSelector:function(e,t){if(!u.is.string(e)||u.is.empty(e))return{};var i={},n=t;return e.split(",").forEach(function(e){var t=e.trim(),s=t.replace(".",""),a=t.replace(/[[\]]/g,"").split("="),r=a[0],l=a.length>1?a[1].replace(/["']/g,""):"";switch(t.charAt(0)){case".":u.is.object(n)&&u.is.string(n.class)&&(n.class+=" "+s),i.class=s;break;case"#":i.id=t.replace("#","");break;case"[":i[r]=l}}),i},toggleHidden:function(e,t){if(u.is.element(e)){var i=t;u.is.boolean(i)||(i=!e.hasAttribute("hidden")),i?e.setAttribute("hidden",""):e.removeAttribute("hidden")}},toggleClass:function(e,t,i){if(u.is.element(e)){var n="toggle";return void 0!==i&&(n=i?"add":"remove"),e.classList[n](t),e.classList.contains(t)}return null},hasClass:function(e,t){return u.is.element(e)&&e.classList.contains(t)},matches:function(e,t){var i={Element:Element};var n=i.matches||i.webkitMatchesSelector||i.mozMatchesSelector||i.msMatchesSelector||function(){return Array.from(document.querySelectorAll(t)).includes(this)};return n.call(e,t)},getElements:function(e){return this.elements.container.querySelectorAll(e)},getElement:function(e){return this.elements.container.querySelector(e)},getFocusElement:function(){var e=document.activeElement;return e=e&&e!==document.body?document.querySelector(":focus"):null},trapFocus:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(u.is.element(e)){var i=u.getElements.call(this,"button:not(:disabled), input:not(:disabled), [tabindex]"),n=i[0],s=i[i.length-1],a=function(e){if("Tab"===e.key&&9===e.keyCode){var t=u.getFocusElement();t!==s||e.shiftKey?t===n&&e.shiftKey&&(s.focus(),e.preventDefault()):(n.focus(),e.preventDefault())}};t?u.on(this.elements.container,"keydown",a,!1):u.off(this.elements.container,"keydown",a,!1)}},toggleListener:function(e,t,i){var n=arguments.length>3&&void 0!==arguments[3]&&arguments[3],s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],a=arguments.length>5&&void 0!==arguments[5]&&arguments[5];if(!u.is.empty(e)&&!u.is.empty(t)&&u.is.function(i))if(u.is.nodeList(e)||u.is.array(e))Array.from(e).forEach(function(e){e instanceof Node&&u.toggleListener.call(null,e,t,i,n,s,a)});else{var r=t.split(" "),l=a;d.passiveListeners&&(l={passive:s,capture:a}),r.forEach(function(t){e[n?"addEventListener":"removeEventListener"](t,i,l)})}},on:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments[2],n=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],s=arguments.length>4&&void 0!==arguments[4]&&arguments[4];u.toggleListener(e,t,i,!0,n,s)},off:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments[2],n=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],s=arguments.length>4&&void 0!==arguments[4]&&arguments[4];u.toggleListener(e,t,i,!1,n,s)},dispatchEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments.length>2&&void 0!==arguments[2]&&arguments[2],n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};if(u.is.element(e)&&!u.is.empty(t)){var s=new CustomEvent(t,{bubbles:i,detail:Object.assign({},n,{plyr:this})});e.dispatchEvent(s)}},toggleState:function(e,t){if(u.is.array(e)||u.is.nodeList(e))Array.from(e).forEach(function(e){return u.toggleState(e,t)});else if(u.is.element(e)){var i="true"===e.getAttribute("aria-pressed"),n=u.is.boolean(t)?t:!i;e.setAttribute("aria-pressed",n)}},format:function(e){for(var t=arguments.length,i=Array(t>1?t-1:0),n=1;n<t;n++)i[n-1]=arguments[n];return u.is.empty(e)?e:e.toString().replace(/{(\d+)}/g,function(e,t){return u.is.string(i[t])?i[t]:""})},getPercentage:function(e,t){return 0===e||0===t||Number.isNaN(e)||Number.isNaN(t)?0:(e/t*100).toFixed(2)},getHours:function(e){return parseInt(e/60/60%60,10)},getMinutes:function(e){return parseInt(e/60%60,10)},getSeconds:function(e){return parseInt(e%60,10)},formatTime:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!u.is.number(e))return this.formatTime(null,t,i);var n=function(e){return("0"+e).slice(-2)},s=this.getHours(e),a=this.getMinutes(e),r=this.getSeconds(e);return t||s>0?s+=":":s="",(i?"-":"")+s+n(a)+":"+n(r)},replaceAll:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"";return e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g,"\\$1"),"g"),i.toString())},toTitleCase:function(){return(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString().replace(/\w\S*/g,function(e){return e.charAt(0).toUpperCase()+e.substr(1).toLowerCase()})},toPascalCase:function(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString();return e=u.replaceAll(e,"-"," "),e=u.replaceAll(e,"_"," "),e=u.toTitleCase(e),u.replaceAll(e," ","")},toCamelCase:function(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString();return(e=u.toPascalCase(e)).charAt(0).toLowerCase()+e.slice(1)},extend:function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length,i=Array(t>1?t-1:0),n=1;n<t;n++)i[n-1]=arguments[n];if(!i.length)return e;var s=i.shift();return u.is.object(s)?(Object.keys(s).forEach(function(t){u.is.object(s[t])?(Object.keys(e).includes(t)||Object.assign(e,a({},t,{})),u.extend(e[t],s[t])):Object.assign(e,a({},t,s[t]))}),u.extend.apply(u,[e].concat(function(e){if(Array.isArray(e)){for(var t=0,i=Array(e.length);t<e.length;t++)i[t]=e[t];return i}return Array.from(e)}(i)))):e},dedupe:function(e){return u.is.array(e)?e.filter(function(t,i){return e.indexOf(t)===i}):e},cloneDeep:function(e){return JSON.parse(JSON.stringify(e))},closest:function(e,t){return u.is.array(e)&&e.length?e.reduce(function(e,i){return Math.abs(i-t)<Math.abs(e-t)?i:e}):null},getProviderByUrl:function(e){return/^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/.test(e)?o.youtube:/^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e)?o.vimeo:null},parseYouTubeId:function(e){if(u.is.empty(e))return null;return e.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/)?RegExp.$2:e},parseVimeoId:function(e){if(u.is.empty(e))return null;if(u.is.number(Number(e)))return e;return e.match(/^.*(vimeo.com\/|video\/)(\d+).*/)?RegExp.$2:e},parseUrl:function(e){var t=document.createElement("a");return t.href=e,t},getUrlParams:function(e){var t=e;(e.startsWith("http://")||e.startsWith("https://"))&&(t=this.parseUrl(e).search);return this.is.empty(t)?null:t.slice(t.indexOf("?")+1).split("&").reduce(function(e,t){var i=t.split("="),n=r(i,2),s=n[0],l=n[1];return Object.assign(e,a({},s,decodeURIComponent(l)))},{})},buildUrlParams:function(e){return u.is.object(e)?Object.keys(e).map(function(t){return encodeURIComponent(t)+"="+encodeURIComponent(e[t])}).join("&"):""},stripHTML:function(e){var t=document.createDocumentFragment(),i=document.createElement("div");return t.appendChild(i),i.innerHTML=e,t.firstChild.innerText},getAspectRatio:function(e,t){var i=function e(t,i){return 0===i?t:e(i,t%i)}(e,t);return e/i+":"+t/i},get transitionEndEvent(){var e=document.createElement("span"),t={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"},i=Object.keys(t).find(function(t){return void 0!==e.style[t]});return!!u.is.string(i)&&t[i]},repaint:function(e){setTimeout(function(){u.toggleHidden(e,!0),e.offsetHeight,u.toggleHidden(e,!1)},0)}},d={audio:"canPlayType"in document.createElement("audio"),video:"canPlayType"in document.createElement("video"),check:function(e,t,i){var n=!1,s=!1,a=u.getBrowser(),r=a.isIPhone&&i&&d.playsinline;switch(t+":"+e){case"html5:video":s=(n=d.video)&&d.rangeInput&&(!a.isIPhone||r);break;case"html5:audio":s=(n=d.audio)&&d.rangeInput;break;case"youtube:video":case"vimeo:video":n=!0,s=d.rangeInput&&(!a.isIPhone||r);break;default:s=(n=d.audio&&d.video)&&d.rangeInput}return{api:n,ui:s}},pip:!u.getBrowser().isIPhone&&u.is.function(u.createElement("video").webkitSetPresentationMode),airplay:u.is.function(window.WebKitPlaybackTargetAvailabilityEvent),playsinline:"playsInline"in document.createElement("video"),mime:function(e){var t=this.media;try{if(!this.isHTML5||!u.is.function(t.canPlayType))return!1;if(e.includes("codecs="))return t.canPlayType(e).replace(/no/,"");if(this.isVideo)switch(e){case"video/webm":return t.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/no/,"");case"video/mp4":return t.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"').replace(/no/,"");case"video/ogg":return t.canPlayType('video/ogg; codecs="theora"').replace(/no/,"");default:return!1}else if(this.isAudio)switch(e){case"audio/mpeg":return t.canPlayType("audio/mpeg;").replace(/no/,"");case"audio/ogg":return t.canPlayType('audio/ogg; codecs="vorbis"').replace(/no/,"");case"audio/wav":return t.canPlayType('audio/wav; codecs="1"').replace(/no/,"");default:return!1}}catch(e){return!1}return!1},textTracks:"textTracks"in document.createElement("video"),passiveListeners:function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){return e=!0,null}});window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(e){}return e}(),rangeInput:(t=document.createElement("input"),t.type="range","range"===t.type),touch:"ontouchstart"in document.documentElement,transitions:!1!==u.transitionEndEvent,reducedMotion:"matchMedia"in window&&window.matchMedia("(prefers-reduced-motion)").matches},p={getSources:function(){return this.isHTML5?this.media.querySelectorAll("source"):null},getQualityOptions:function(){if(!this.isHTML5)return null;var e=p.getSources.call(this);if(u.is.empty(e))return null;var t=Array.from(e).filter(function(e){return!u.is.empty(e.getAttribute("size"))});return u.is.empty(t)?null:u.dedupe(t.map(function(e){return Number(e.getAttribute("size"))}))},extend:function(){if(this.isHTML5){var e=this;Object.defineProperty(e.media,"quality",{get:function(){var t=p.getSources.call(e);if(u.is.empty(t))return null;var i=Array.from(t).filter(function(t){return t.getAttribute("src")===e.source});return u.is.empty(i)?null:Number(i[0].getAttribute("size"))},set:function(t){var i=p.getSources.call(e);if(!u.is.empty(i)){var n=Array.from(i).filter(function(e){return Number(e.getAttribute("size"))===t});if(!u.is.empty(n)){var s=n.filter(function(t){return d.mime.call(e,t.getAttribute("type"))});if(!u.is.empty(s)){u.dispatchEvent.call(e,e.media,"qualityrequested",!1,{quality:t});var a=e.currentTime,r=e.playing;e.media.src=s[0].getAttribute("src"),e.media.load(),r&&e.play(),e.currentTime=a,u.dispatchEvent.call(e,e.media,"qualitychange",!1,{quality:t})}}}}})}},cancelRequests:function(){this.isHTML5&&(u.removeElement(p.getSources()),this.media.setAttribute("src",this.config.blankVideo),this.media.load(),this.debug.log("Cancelled network requests"))}},h=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(u.is.empty(e)||u.is.empty(t)||!Object.keys(t.i18n).includes(e))return"";var i=t.i18n[e],n={"{seektime}":t.seekTime,"{title}":t.title};return Object.entries(n).forEach(function(e){var t=r(e,2),n=t[0],s=t[1];i=u.replaceAll(i,n,s)}),i},m=u.getBrowser(),g={getIconUrl:function(){var e=new URL(this.config.iconUrl,window.location).host!==window.location.host||m.isIE&&!window.svg4everybody;return{url:this.config.iconUrl,cors:e}},findElements:function(){try{return this.elements.controls=u.getElement.call(this,this.config.selectors.controls.wrapper),this.elements.buttons={play:u.getElements.call(this,this.config.selectors.buttons.play),pause:u.getElement.call(this,this.config.selectors.buttons.pause),restart:u.getElement.call(this,this.config.selectors.buttons.restart),rewind:u.getElement.call(this,this.config.selectors.buttons.rewind),fastForward:u.getElement.call(this,this.config.selectors.buttons.fastForward),mute:u.getElement.call(this,this.config.selectors.buttons.mute),pip:u.getElement.call(this,this.config.selectors.buttons.pip),airplay:u.getElement.call(this,this.config.selectors.buttons.airplay),settings:u.getElement.call(this,this.config.selectors.buttons.settings),captions:u.getElement.call(this,this.config.selectors.buttons.captions),fullscreen:u.getElement.call(this,this.config.selectors.buttons.fullscreen)},this.elements.progress=u.getElement.call(this,this.config.selectors.progress),this.elements.inputs={seek:u.getElement.call(this,this.config.selectors.inputs.seek),volume:u.getElement.call(this,this.config.selectors.inputs.volume)},this.elements.display={buffer:u.getElement.call(this,this.config.selectors.display.buffer),currentTime:u.getElement.call(this,this.config.selectors.display.currentTime),duration:u.getElement.call(this,this.config.selectors.display.duration)},u.is.element(this.elements.progress)&&(this.elements.display.seekTooltip=this.elements.progress.querySelector("."+this.config.classNames.tooltip)),!0}catch(e){return this.debug.warn("It looks like there is a problem with your custom controls HTML",e),this.toggleNativeControls(!0),!1}},createIcon:function(e,t){var i=g.getIconUrl.call(this),n=(i.cors?"":i.url)+"#"+this.config.iconPrefix,s=document.createElementNS("http://www.w3.org/2000/svg","svg");u.setAttributes(s,u.extend(t,{role:"presentation",focusable:"false"}));var a=document.createElementNS("http://www.w3.org/2000/svg","use"),r=n+"-"+e;return"href"in a?a.setAttributeNS("http://www.w3.org/1999/xlink","href",r):a.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href",r),s.appendChild(a),s},createLabel:function(e,t){var i=h(e,this.config),n=Object.assign({},t);switch(e){case"pip":i="PIP";break;case"airplay":i="AirPlay"}return"class"in n?n.class+=" "+this.config.classNames.hidden:n.class=this.config.classNames.hidden,u.createElement("span",n,i)},createBadge:function(e){if(u.is.empty(e))return null;var t=u.createElement("span",{class:this.config.classNames.menu.value});return t.appendChild(u.createElement("span",{class:this.config.classNames.menu.badge},e)),t},createButton:function(e,t){var i=u.createElement("button"),n=Object.assign({},t),s=u.toCamelCase(e),a=!1,r=void 0,l=void 0,o=void 0,c=void 0;switch("type"in n||(n.type="button"),"class"in n?n.class.includes(this.config.classNames.control)&&(n.class+=" "+this.config.classNames.control):n.class=this.config.classNames.control,e){case"play":a=!0,r="play",o="pause",l="play",c="pause";break;case"mute":a=!0,r="mute",o="unmute",l="volume",c="muted";break;case"captions":a=!0,r="enableCaptions",o="disableCaptions",l="captions-off",c="captions-on";break;case"fullscreen":a=!0,r="enterFullscreen",o="exitFullscreen",l="enter-fullscreen",c="exit-fullscreen";break;case"play-large":n.class+=" "+this.config.classNames.control+"--overlaid",s="play",r="play",l="play";break;default:r=s,l=e}return a?(i.appendChild(g.createIcon.call(this,c,{class:"icon--pressed"})),i.appendChild(g.createIcon.call(this,l,{class:"icon--not-pressed"})),i.appendChild(g.createLabel.call(this,o,{class:"label--pressed"})),i.appendChild(g.createLabel.call(this,r,{class:"label--not-pressed"})),n["aria-pressed"]=!1):(i.appendChild(g.createIcon.call(this,l)),i.appendChild(g.createLabel.call(this,r))),u.extend(n,u.getAttributesFromSelector(this.config.selectors.buttons[s],n)),u.setAttributes(i,n),"play"===s?(u.is.array(this.elements.buttons[s])||(this.elements.buttons[s]=[]),this.elements.buttons[s].push(i)):this.elements.buttons[s]=i,i},createRange:function(e,t){var i=u.createElement("label",{for:t.id,id:t.id+"-label",class:this.config.classNames.hidden},h(e,this.config)),n=u.createElement("input",u.extend(u.getAttributesFromSelector(this.config.selectors.inputs[e]),{type:"range",min:0,max:100,step:.01,value:0,autocomplete:"off",role:"slider","aria-labelledby":t.id+"-label","aria-valuemin":0,"aria-valuemax":100,"aria-valuenow":0},t));return this.elements.inputs[e]=n,g.updateRangeFill.call(this,n),{label:i,input:n}},createProgress:function(e,t){var i=u.createElement("progress",u.extend(u.getAttributesFromSelector(this.config.selectors.display[e]),{min:0,max:100,value:0,role:"presentation","aria-hidden":!0},t));if("volume"!==e){i.appendChild(u.createElement("span",null,"0"));var n="";switch(e){case"played":n=h("played",this.config);break;case"buffer":n=h("buffered",this.config)}i.innerText="% "+n.toLowerCase()}return this.elements.display[e]=i,i},createTime:function(e){var t=u.getAttributesFromSelector(this.config.selectors.display[e]),i=u.createElement("div",u.extend(t,{class:"plyr__time "+t.class,"aria-label":h(e,this.config)}),"00:00");return this.elements.display[e]=i,i},createMenuItem:function(e,t,i,n){var s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:null,a=arguments.length>5&&void 0!==arguments[5]&&arguments[5],r=u.createElement("li"),l=u.createElement("label",{class:this.config.classNames.control}),o=u.createElement("input",u.extend(u.getAttributesFromSelector(this.config.selectors.inputs[i]),{type:"radio",name:"plyr-"+i,value:e,checked:a,class:"plyr__sr-only"})),c=u.createElement("span",{hidden:""});l.appendChild(o),l.appendChild(c),l.insertAdjacentHTML("beforeend",n),u.is.element(s)&&l.appendChild(s),r.appendChild(l),t.appendChild(r)},updateTimeDisplay:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(u.is.element(e)&&u.is.number(t)){var n=u.getHours(this.duration)>0;e.innerText=u.formatTime(t,n,i)}},updateVolume:function(){this.supported.ui&&(u.is.element(this.elements.inputs.volume)&&g.setRange.call(this,this.elements.inputs.volume,this.muted?0:this.volume),u.is.element(this.elements.buttons.mute)&&u.toggleState(this.elements.buttons.mute,this.muted||0===this.volume))},setRange:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;u.is.element(e)&&(e.value=t,g.updateRangeFill.call(this,e))},updateProgress:function(e){var t=this;if(this.supported.ui&&u.is.event(e)){var i=0;if(e)switch(e.type){case"timeupdate":case"seeking":case"seeked":i=u.getPercentage(this.currentTime,this.duration),"timeupdate"===e.type&&g.setRange.call(this,this.elements.inputs.seek,i);break;case"playing":case"progress":!function(e,i){var n=u.is.number(i)?i:0,s=u.is.element(e)?e:t.elements.display.buffer;if(u.is.element(s)){s.value=n;var a=s.getElementsByTagName("span")[0];u.is.element(a)&&(a.childNodes[0].nodeValue=n)}}(this.elements.display.buffer,100*this.buffered)}}},updateRangeFill:function(e){var t=u.is.event(e)?e.target:e;u.is.element(t)&&"range"===t.getAttribute("type")&&(t.setAttribute("aria-valuenow",t.value),m.isWebkit&&t.style.setProperty("--value",t.value/t.max*100+"%"))},updateSeekTooltip:function(e){var t=this;if(this.config.tooltips.seek&&u.is.element(this.elements.inputs.seek)&&u.is.element(this.elements.display.seekTooltip)&&0!==this.duration){var i=0,n=this.elements.progress.getBoundingClientRect(),s=this.config.classNames.tooltip+"--visible",a=function(e){u.toggleClass(t.elements.display.seekTooltip,s,e)};if(this.touch)a(!1);else{if(u.is.event(e))i=100/n.width*(e.pageX-n.left);else{if(!u.hasClass(this.elements.display.seekTooltip,s))return;i=parseFloat(this.elements.display.seekTooltip.style.left,10)}i<0?i=0:i>100&&(i=100),g.updateTimeDisplay.call(this,this.elements.display.seekTooltip,this.duration/100*i),this.elements.display.seekTooltip.style.left=i+"%",u.is.event(e)&&["mouseenter","mouseleave"].includes(e.type)&&a("mouseenter"===e.type)}}},timeUpdate:function(e){var t=!u.is.element(this.elements.display.duration)&&this.config.invertTime;g.updateTimeDisplay.call(this,this.elements.display.currentTime,t?this.duration-this.currentTime:this.currentTime,t),e&&"timeupdate"===e.type&&this.media.seeking||g.updateProgress.call(this,e)},durationUpdate:function(){if(this.supported.ui&&(this.config.invertTime||!this.currentTime)){var e=u.is.element(this.elements.display.duration);!e&&this.config.displayDuration&&this.paused&&g.updateTimeDisplay.call(this,this.elements.display.currentTime,this.duration),e&&g.updateTimeDisplay.call(this,this.elements.display.duration,this.duration),g.updateSeekTooltip.call(this)}},toggleTab:function(e,t){u.toggleHidden(this.elements.settings.tabs[e],!t)},setQualityMenu:function(e){var t=this;if(u.is.element(this.elements.settings.panes.quality)){var i=this.elements.settings.panes.quality.querySelector("ul");u.is.array(e)&&(this.options.quality=e.filter(function(e){return t.config.quality.options.includes(e)}));var n=!u.is.empty(this.options.quality)&&this.options.quality.length>1;if(g.toggleTab.call(this,"quality",n),g.checkMenu.call(this),n){u.emptyElement(i);this.options.quality.sort(function(e,i){var n=t.config.quality.options;return n.indexOf(e)>n.indexOf(i)?1:-1}).forEach(function(e){var n=g.getLabel.call(t,"quality",e);g.createMenuItem.call(t,e,i,"quality",n,function(e){var i="";switch(e){case 2160:i="4K";break;case 1440:case 1080:case 720:i="HD";break;case 576:case 480:i="SD"}return i.length?g.createBadge.call(t,i):null}(e))}),g.updateSetting.call(this,"quality",i)}}},getLabel:function(e,t){switch(e){case"speed":return 1===t?h("normal",this.config):t+"&times;";case"quality":return u.is.number(t)?t+"p":u.toTitleCase(t);case"captions":return f.getLabel.call(this);default:return null}},updateSetting:function(e,t,i){var n=this.elements.settings.panes[e],s=null,a=t;switch(e){case"captions":s=this.captions.active?this.options.captions.length>2||!this.options.captions.some(function(e){return"enabled"===e})?this.captions.language:"enabled":"";break;default:if(s=u.is.empty(i)?this[e]:i,u.is.empty(s)&&(s=this.config[e].default),!u.is.empty(this.options[e])&&!this.options[e].includes(s))return void this.debug.warn("Unsupported value of '"+s+"' for "+e);if(!this.config[e].options.includes(s))return void this.debug.warn("Disabled value of '"+s+"' for "+e)}if(u.is.element(a)||(a=n&&n.querySelector("ul")),u.is.element(a)){this.elements.settings.tabs[e].querySelector("."+this.config.classNames.menu.value).innerHTML=g.getLabel.call(this,e,s);var r=a&&a.querySelector('input[value="'+s+'"]');u.is.element(r)&&(r.checked=!0)}},setCaptionsMenu:function(){var e=this,t=this.elements.settings.panes.captions.querySelector("ul"),i=f.getTracks.call(this).length;if(g.toggleTab.call(this,"captions",i),u.emptyElement(t),g.checkMenu.call(this),i){var n=f.getTracks.call(this).map(function(t){return{language:u.is.empty(t.language)?"enabled":t.language,label:f.getLabel.call(e,t)}});n.unshift({language:"",label:h("disabled",this.config)}),n.forEach(function(i){g.createMenuItem.call(e,i.language,t,"language",i.label,"enabled"!==i.language?g.createBadge.call(e,i.language.toUpperCase()):null,i.language.toLowerCase()===e.captions.language.toLowerCase())}),this.options.captions=n.map(function(e){return e.language}),g.updateSetting.call(this,"captions",t)}},setSpeedMenu:function(e){var t=this;if(this.config.controls.includes("settings")&&this.config.settings.includes("speed")&&u.is.element(this.elements.settings.panes.speed)){u.is.array(e)?this.options.speed=e:(this.isHTML5||this.isVimeo)&&(this.options.speed=[.5,.75,1,1.25,1.5,1.75,2]),this.options.speed=this.options.speed.filter(function(e){return t.config.speed.options.includes(e)});var i=!u.is.empty(this.options.speed)&&this.options.speed.length>1;if(g.toggleTab.call(this,"speed",i),g.checkMenu.call(this),i){var n=this.elements.settings.panes.speed.querySelector("ul");u.emptyElement(n),this.options.speed.forEach(function(e){var i=g.getLabel.call(t,"speed",e);g.createMenuItem.call(t,e,n,"speed",i)}),g.updateSetting.call(this,"speed",n)}}},checkMenu:function(){var e=this.elements.settings.tabs,t=!u.is.empty(e)&&Object.values(e).some(function(e){return!e.hidden});u.toggleHidden(this.elements.settings.menu,!t)},toggleMenu:function(e){var t=this.elements.settings.form,i=this.elements.buttons.settings;if(u.is.element(t)&&u.is.element(i)){var n=u.is.boolean(e)?e:u.is.element(t)&&t.hasAttribute("hidden");if(u.is.event(e)){var s=u.is.element(t)&&t.contains(e.target),a=e.target===this.elements.buttons.settings;if(s||!s&&!a&&n)return;a&&e.stopPropagation()}u.is.element(i)&&i.setAttribute("aria-expanded",n),u.is.element(t)&&(u.toggleHidden(t,!n),u.toggleClass(this.elements.container,this.config.classNames.menu.open,n),n?t.removeAttribute("tabindex"):t.setAttribute("tabindex",-1))}},getTabSize:function(e){var t=e.cloneNode(!0);t.style.position="absolute",t.style.opacity=0,t.removeAttribute("hidden"),Array.from(t.querySelectorAll("input[name]")).forEach(function(e){var t=e.getAttribute("name");e.setAttribute("name",t+"-clone")}),e.parentNode.appendChild(t);var i=t.scrollWidth,n=t.scrollHeight;return u.removeElement(t),{width:i,height:n}},showTab:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=this.elements.settings.menu,i=document.getElementById(e);if(u.is.element(i)&&"tabpanel"===i.getAttribute("role")){var n=t.querySelector('[role="tabpanel"]:not([hidden])'),s=n.parentNode;if(Array.from(t.querySelectorAll('[aria-controls="'+n.getAttribute("id")+'"]')).forEach(function(e){e.setAttribute("aria-expanded",!1)}),d.transitions&&!d.reducedMotion){s.style.width=n.scrollWidth+"px",s.style.height=n.scrollHeight+"px";var a=g.getTabSize.call(this,i);u.on(s,u.transitionEndEvent,function e(t){t.target===s&&["width","height"].includes(t.propertyName)&&(s.style.width="",s.style.height="",u.off(s,u.transitionEndEvent,e))}),s.style.width=a.width+"px",s.style.height=a.height+"px"}u.toggleHidden(n,!0),n.setAttribute("tabindex",-1),u.toggleHidden(i,!1);var r=u.getElements.call(this,'[aria-controls="'+e+'"]');Array.from(r).forEach(function(e){e.setAttribute("aria-expanded",!0)}),i.removeAttribute("tabindex"),i.querySelectorAll("button:not(:disabled), input:not(:disabled), [tabindex]")[0].focus()}},create:function(e){var t=this;if(u.is.empty(this.config.controls))return null;var i=u.createElement("div",u.getAttributesFromSelector(this.config.selectors.controls.wrapper));if(this.config.controls.includes("restart")&&i.appendChild(g.createButton.call(this,"restart")),this.config.controls.includes("rewind")&&i.appendChild(g.createButton.call(this,"rewind")),this.config.controls.includes("play")&&i.appendChild(g.createButton.call(this,"play")),this.config.controls.includes("fast-forward")&&i.appendChild(g.createButton.call(this,"fast-forward")),this.config.controls.includes("progress")){var n=u.createElement("div",u.getAttributesFromSelector(this.config.selectors.progress)),s=g.createRange.call(this,"seek",{id:"plyr-seek-"+e.id});if(n.appendChild(s.label),n.appendChild(s.input),n.appendChild(g.createProgress.call(this,"buffer")),this.config.tooltips.seek){var a=u.createElement("span",{class:this.config.classNames.tooltip},"00:00");n.appendChild(a),this.elements.display.seekTooltip=a}this.elements.progress=n,i.appendChild(this.elements.progress)}if(this.config.controls.includes("current-time")&&i.appendChild(g.createTime.call(this,"currentTime")),this.config.controls.includes("duration")&&i.appendChild(g.createTime.call(this,"duration")),this.config.controls.includes("mute")&&i.appendChild(g.createButton.call(this,"mute")),this.config.controls.includes("volume")){var r=u.createElement("div",{class:"plyr__volume"}),l={max:1,step:.05,value:this.config.volume},o=g.createRange.call(this,"volume",u.extend(l,{id:"plyr-volume-"+e.id}));r.appendChild(o.label),r.appendChild(o.input),this.elements.volume=r,i.appendChild(r)}if(this.config.controls.includes("captions")&&i.appendChild(g.createButton.call(this,"captions")),this.config.controls.includes("settings")&&!u.is.empty(this.config.settings)){var c=u.createElement("div",{class:"plyr__menu",hidden:""});c.appendChild(g.createButton.call(this,"settings",{id:"plyr-settings-toggle-"+e.id,"aria-haspopup":!0,"aria-controls":"plyr-settings-"+e.id,"aria-expanded":!1}));var m=u.createElement("form",{class:"plyr__menu__container",id:"plyr-settings-"+e.id,hidden:"","aria-labelled-by":"plyr-settings-toggle-"+e.id,role:"tablist",tabindex:-1}),f=u.createElement("div"),y=u.createElement("div",{id:"plyr-settings-"+e.id+"-home","aria-labelled-by":"plyr-settings-toggle-"+e.id,role:"tabpanel"}),v=u.createElement("ul",{role:"tablist"});this.config.settings.forEach(function(i){var n=u.createElement("li",{role:"tab",hidden:""}),s=u.createElement("button",u.extend(u.getAttributesFromSelector(t.config.selectors.buttons.settings),{type:"button",class:t.config.classNames.control+" "+t.config.classNames.control+"--forward",id:"plyr-settings-"+e.id+"-"+i+"-tab","aria-haspopup":!0,"aria-controls":"plyr-settings-"+e.id+"-"+i,"aria-expanded":!1}),h(i,t.config)),a=u.createElement("span",{class:t.config.classNames.menu.value});a.innerHTML=e[i],s.appendChild(a),n.appendChild(s),v.appendChild(n),t.elements.settings.tabs[i]=n}),y.appendChild(v),f.appendChild(y),this.config.settings.forEach(function(i){var n=u.createElement("div",{id:"plyr-settings-"+e.id+"-"+i,hidden:"","aria-labelled-by":"plyr-settings-"+e.id+"-"+i+"-tab",role:"tabpanel",tabindex:-1}),s=u.createElement("button",{type:"button",class:t.config.classNames.control+" "+t.config.classNames.control+"--back","aria-haspopup":!0,"aria-controls":"plyr-settings-"+e.id+"-home","aria-expanded":!1},h(i,t.config));n.appendChild(s);var a=u.createElement("ul");n.appendChild(a),f.appendChild(n),t.elements.settings.panes[i]=n}),m.appendChild(f),c.appendChild(m),i.appendChild(c),this.elements.settings.form=m,this.elements.settings.menu=c}return this.config.controls.includes("pip")&&d.pip&&i.appendChild(g.createButton.call(this,"pip")),this.config.controls.includes("airplay")&&d.airplay&&i.appendChild(g.createButton.call(this,"airplay")),this.config.controls.includes("fullscreen")&&i.appendChild(g.createButton.call(this,"fullscreen")),this.config.controls.includes("play-large")&&this.elements.container.appendChild(g.createButton.call(this,"play-large")),this.elements.controls=i,this.isHTML5&&g.setQualityMenu.call(this,p.getQualityOptions.call(this)),g.setSpeedMenu.call(this),i},inject:function(){var e=this;if(this.config.loadSprite){var t=g.getIconUrl.call(this);t.cors&&u.loadSprite(t.url,"sprite-plyr")}this.id=Math.floor(1e4*Math.random());var i=null;this.elements.controls=null;var n={id:this.id,seektime:this.config.seekTime,title:this.config.title},s=!0;u.is.string(this.config.controls)||u.is.element(this.config.controls)?i=this.config.controls:u.is.function(this.config.controls)?i=this.config.controls.call(this,n):(i=g.create.call(this,{id:this.id,seektime:this.config.seekTime,speed:this.speed,quality:this.quality,captions:f.getLabel.call(this)}),s=!1);var a=function(e){var t=e;return Object.entries(n).forEach(function(e){var i=r(e,2),n=i[0],s=i[1];t=u.replaceAll(t,"{"+n+"}",s)}),t};s&&(u.is.string(this.config.controls)?i=a(i):u.is.element(i)&&(i.innerHTML=a(i.innerHTML)));var l=void 0;if(u.is.string(this.config.selectors.controls.container)&&(l=document.querySelector(this.config.selectors.controls.container)),u.is.element(l)||(l=this.elements.container),u.is.element(i)?l.appendChild(i):i&&l.insertAdjacentHTML("beforeend",i),u.is.element(this.elements.controls)||g.findElements.call(this),window.navigator.userAgent.includes("Edge")&&u.repaint(l),this.config.tooltips.controls){var o=u.getElements.call(this,[this.config.selectors.controls.wrapper," ",this.config.selectors.labels," .",this.config.classNames.hidden].join(""));Array.from(o).forEach(function(t){u.toggleClass(t,e.config.classNames.hidden,!1),u.toggleClass(t,e.config.classNames.tooltip,!0),t.setAttribute("role","tooltip")})}}},f={setup:function(){if(this.supported.ui){var e=this.storage.get("language");if(u.is.empty(e)||(this.captions.language=e),u.is.empty(this.captions.language)&&(this.captions.language=this.config.captions.language.toLowerCase()),!u.is.boolean(this.captions.active)){var t=this.storage.get("captions");u.is.boolean(t)?this.captions.active=t:this.captions.active=this.config.captions.active}if(!this.isVideo||this.isYouTube||this.isHTML5&&!d.textTracks)u.is.array(this.config.controls)&&this.config.controls.includes("settings")&&this.config.settings.includes("captions")&&g.setCaptionsMenu.call(this);else{u.is.element(this.elements.captions)||(this.elements.captions=u.createElement("div",u.getAttributesFromSelector(this.config.selectors.captions)),u.insertAfter(this.elements.captions,this.elements.wrapper)),u.toggleClass(this.elements.container,this.config.classNames.captions.enabled,!u.is.empty(f.getTracks.call(this)));var i=f.getTracks.call(this);if(!u.is.empty(i)){if(u.getBrowser().isIE&&window.URL){var n=this.media.querySelectorAll("track");Array.from(n).forEach(function(e){var t=e.getAttribute("src"),i=u.parseUrl(t);i.hostname!==window.location.href.hostname&&["http:","https:"].includes(i.protocol)&&u.fetch(t,"blob").then(function(t){e.setAttribute("src",window.URL.createObjectURL(t))}).catch(function(){u.removeElement(e)})})}f.setLanguage.call(this),f.show.call(this),u.is.array(this.config.controls)&&this.config.controls.includes("settings")&&this.config.settings.includes("captions")&&g.setCaptionsMenu.call(this)}}}},setLanguage:function(){var e=this;if(this.isHTML5&&this.isVideo){f.getTracks.call(this).forEach(function(t){u.on(t,"cuechange",function(t){return f.setCue.call(e,t)}),t.mode="hidden"});var t=f.getCurrentTrack.call(this);u.is.track(t)&&Array.from(t.activeCues||[]).length&&f.setCue.call(this,t)}else this.isVimeo&&this.captions.active&&this.embed.enableTextTrack(this.language)},getTracks:function(){return u.is.nullOrUndefined(this.media)?[]:Array.from(this.media.textTracks||[]).filter(function(e){return["captions","subtitles"].includes(e.kind)})},getCurrentTrack:function(){var e=this,t=f.getTracks.call(this);if(!t.length)return null;var i=t.find(function(t){return t.language.toLowerCase()===e.language});(i||(i=u.getElement.call(this,"track[default]")),i)||(i=r(t,1)[0]);return i},getLabel:function(e){var t=e;return!u.is.track(t)&&d.textTracks&&this.captions.active&&(t=f.getCurrentTrack.call(this)),u.is.track(t)?u.is.empty(t.label)?u.is.empty(t.language)?h("enabled",this.config):e.language.toUpperCase():t.label:h("disabled",this.config)},setCue:function(e){var t=u.is.event(e)?e.target:e,i=t.activeCues,n=i.length&&i[0];t===f.getCurrentTrack.call(this)&&(u.is.cue(n)?f.setText.call(this,n.getCueAsHTML()):f.setText.call(this,null),u.dispatchEvent.call(this,this.media,"cuechange"))},setText:function(e){if(this.supported.ui)if(u.is.element(this.elements.captions)){var t=u.createElement("span");u.emptyElement(this.elements.captions);var i=u.is.nullOrUndefined(e)?"":e;u.is.string(i)?t.innerText=i.trim():t.appendChild(i),this.elements.captions.appendChild(t)}else this.debug.warn("No captions element to render to")},show:function(){var e=this.storage.get("captions");u.is.boolean(e)?this.captions.active=e:e=this.config.captions.active,e&&(u.toggleClass(this.elements.container,this.config.classNames.captions.active,!0),u.toggleState(this.elements.buttons.captions,!0))}},y=function(){},v=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];n(this,e),this.enabled=window.console&&t,this.enabled&&this.log("Debugging enabled")}return s(e,[{key:"log",get:function(){return this.enabled?Function.prototype.bind.call(console.log,console):y}},{key:"warn",get:function(){return this.enabled?Function.prototype.bind.call(console.warn,console):y}},{key:"error",get:function(){return this.enabled?Function.prototype.bind.call(console.error,console):y}}]),e}(),b={enabled:!0,title:"",debug:!1,autoplay:!1,autopause:!0,seekTime:10,volume:1,muted:!1,duration:null,displayDuration:!0,invertTime:!0,toggleInvert:!0,ratio:"16:9",clickToPlay:!0,hideControls:!0,resetOnEnd:!1,disableContextMenu:!0,loadSprite:!0,iconPrefix:"plyr",iconUrl:"https://cdn.plyr.io/3.3.9/plyr.svg",blankVideo:"https://cdn.plyr.io/static/blank.mp4",quality:{default:576,options:[4320,2880,2160,1440,1080,720,576,480,360,240,"default"]},loop:{active:!1},speed:{selected:1,options:[.5,.75,1,1.25,1.5,1.75,2]},keyboard:{focused:!0,global:!1},tooltips:{controls:!1,seek:!0},captions:{active:!1,language:(navigator.language||navigator.userLanguage).split("-")[0]},fullscreen:{enabled:!0,fallback:!0,iosNative:!1},storage:{enabled:!0,key:"plyr"},controls:["play-large","play","progress","current-time","mute","volume","captions","settings","pip","airplay","fullscreen"],settings:["captions","quality","speed"],i18n:{restart:"Restart",rewind:"Rewind {seektime}s",play:"Play",pause:"Pause",fastForward:"Forward {seektime}s",seek:"Seek",played:"Played",buffered:"Buffered",currentTime:"Current time",duration:"Duration",volume:"Volume",mute:"Mute",unmute:"Unmute",enableCaptions:"Enable captions",disableCaptions:"Disable captions",enterFullscreen:"Enter fullscreen",exitFullscreen:"Exit fullscreen",frameTitle:"Player for {title}",captions:"Captions",settings:"Settings",speed:"Speed",normal:"Normal",quality:"Quality",loop:"Loop",start:"Start",end:"End",all:"All",reset:"Reset",disabled:"Disabled",enabled:"Enabled",advertisement:"Ad"},urls:{vimeo:{sdk:"https://player.vimeo.com/api/player.js",iframe:"https://player.vimeo.com/video/{0}?{1}",api:"https://vimeo.com/api/v2/video/{0}.json"},youtube:{sdk:"https://www.youtube.com/iframe_api",api:"https://www.googleapis.com/youtube/v3/videos?id={0}&key={1}&fields=items(snippet(title))&part=snippet"},googleIMA:{sdk:"https://imasdk.googleapis.com/js/sdkloader/ima3.js"}},listeners:{seek:null,play:null,pause:null,restart:null,rewind:null,fastForward:null,mute:null,volume:null,captions:null,fullscreen:null,pip:null,airplay:null,speed:null,quality:null,loop:null,language:null},events:["ended","progress","stalled","playing","waiting","canplay","canplaythrough","loadstart","loadeddata","loadedmetadata","timeupdate","volumechange","play","pause","error","seeking","seeked","emptied","ratechange","cuechange","enterfullscreen","exitfullscreen","captionsenabled","captionsdisabled","languagechange","controlshidden","controlsshown","ready","statechange","qualitychange","qualityrequested","adsloaded","adscontentpause","adscontentresume","adstarted","adsmidpoint","adscomplete","adsallcomplete","adsimpression","adsclick"],selectors:{editable:"input, textarea, select, [contenteditable]",container:".plyr",controls:{container:null,wrapper:".plyr__controls"},labels:"[data-plyr]",buttons:{play:'[data-plyr="play"]',pause:'[data-plyr="pause"]',restart:'[data-plyr="restart"]',rewind:'[data-plyr="rewind"]',fastForward:'[data-plyr="fast-forward"]',mute:'[data-plyr="mute"]',captions:'[data-plyr="captions"]',fullscreen:'[data-plyr="fullscreen"]',pip:'[data-plyr="pip"]',airplay:'[data-plyr="airplay"]',settings:'[data-plyr="settings"]',loop:'[data-plyr="loop"]'},inputs:{seek:'[data-plyr="seek"]',volume:'[data-plyr="volume"]',speed:'[data-plyr="speed"]',language:'[data-plyr="language"]',quality:'[data-plyr="quality"]'},display:{currentTime:".plyr__time--current",duration:".plyr__time--duration",buffer:".plyr__progress--buffer",played:".plyr__progress--played",loop:".plyr__progress--loop",volume:".plyr__volume--display"},progress:".plyr__progress",captions:".plyr__captions",menu:{quality:".js-plyr__menu__list--quality"}},classNames:{type:"plyr--{0}",provider:"plyr--{0}",video:"plyr__video-wrapper",embed:"plyr__video-embed",embedContainer:"plyr__video-embed__container",poster:"plyr__poster",posterEnabled:"plyr__poster-enabled",ads:"plyr__ads",control:"plyr__control",playing:"plyr--playing",paused:"plyr--paused",stopped:"plyr--stopped",loading:"plyr--loading",hover:"plyr--hover",tooltip:"plyr__tooltip",cues:"plyr__cues",hidden:"plyr__sr-only",hideControls:"plyr--hide-controls",isIos:"plyr--is-ios",isTouch:"plyr--is-touch",uiSupported:"plyr--full-ui",noTransition:"plyr--no-transition",menu:{value:"plyr__menu__value",badge:"plyr__badge",open:"plyr--menu-open"},captions:{enabled:"plyr--captions-enabled",active:"plyr--captions-active"},fullscreen:{enabled:"plyr--fullscreen-enabled",fallback:"plyr--fullscreen-fallback"},pip:{supported:"plyr--pip-supported",active:"plyr--pip-active"},airplay:{supported:"plyr--airplay-supported",active:"plyr--airplay-active"},tabFocus:"plyr__tab-focus"},attributes:{embed:{provider:"data-plyr-provider",id:"data-plyr-embed-id"}},keys:{google:null},ads:{enabled:!1,publisherId:""}},k=u.getBrowser();function w(){if(this.enabled){var e=this.player.elements.buttons.fullscreen;u.is.element(e)&&u.toggleState(e,this.active),u.dispatchEvent.call(this.player,this.target,this.active?"enterfullscreen":"exitfullscreen",!0),k.isIos||u.trapFocus.call(this.player,this.target,this.active)}}function E(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];e?this.scrollPosition={x:window.scrollX||0,y:window.scrollY||0}:window.scrollTo(this.scrollPosition.x,this.scrollPosition.y),document.body.style.overflow=e?"hidden":"",u.toggleClass(this.target,this.player.config.classNames.fullscreen.fallback,e),w.call(this)}var T=function(){function e(t){var i=this;n(this,e),this.player=t,this.prefix=e.prefix,this.property=e.property,this.scrollPosition={x:0,y:0},u.on(document,"ms"===this.prefix?"MSFullscreenChange":this.prefix+"fullscreenchange",function(){w.call(i)}),u.on(this.player.elements.container,"dblclick",function(e){u.is.element(i.player.elements.controls)&&i.player.elements.controls.contains(e.target)||i.toggle()}),this.update()}return s(e,[{key:"update",value:function(){this.enabled?this.player.debug.log((e.native?"Native":"Fallback")+" fullscreen enabled"):this.player.debug.log("Fullscreen not supported and fallback disabled"),u.toggleClass(this.player.elements.container,this.player.config.classNames.fullscreen.enabled,this.enabled)}},{key:"enter",value:function(){this.enabled&&(k.isIos&&this.player.config.fullscreen.iosNative?this.player.playing&&this.target.webkitEnterFullscreen():e.native?this.prefix?u.is.empty(this.prefix)||this.target[this.prefix+"Request"+this.property]():this.target.requestFullscreen():E.call(this,!0))}},{key:"exit",value:function(){if(this.enabled)if(k.isIos&&this.player.config.fullscreen.iosNative)this.target.webkitExitFullscreen(),this.player.play();else if(e.native)if(this.prefix){if(!u.is.empty(this.prefix)){var t="moz"===this.prefix?"Cancel":"Exit";document[""+this.prefix+t+this.property]()}}else(document.cancelFullScreen||document.exitFullscreen).call(document);else E.call(this,!1)}},{key:"toggle",value:function(){this.active?this.exit():this.enter()}},{key:"enabled",get:function(){return(e.native||this.player.config.fullscreen.fallback)&&this.player.config.fullscreen.enabled&&this.player.supported.ui&&this.player.isVideo}},{key:"active",get:function(){return!!this.enabled&&(e.native?(this.prefix?document[""+this.prefix+this.property+"Element"]:document.fullscreenElement)===this.target:u.hasClass(this.target,this.player.config.classNames.fullscreen.fallback))}},{key:"target",get:function(){return k.isIos&&this.player.config.fullscreen.iosNative?this.player.media:this.player.elements.container}}],[{key:"native",get:function(){return!!(document.fullscreenEnabled||document.webkitFullscreenEnabled||document.mozFullScreenEnabled||document.msFullscreenEnabled)}},{key:"prefix",get:function(){if(u.is.function(document.exitFullscreen))return"";var e="";return["webkit","moz","ms"].some(function(t){return!(!u.is.function(document[t+"ExitFullscreen"])&&!u.is.function(document[t+"CancelFullScreen"]))&&(e=t,!0)}),e}},{key:"property",get:function(){return"moz"===this.prefix?"FullScreen":"Fullscreen"}}]),e}(),A=u.getBrowser(),C={addStyleHook:function(){u.toggleClass(this.elements.container,this.config.selectors.container.replace(".",""),!0),u.toggleClass(this.elements.container,this.config.classNames.uiSupported,this.supported.ui)},toggleNativeControls:function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&this.isHTML5?this.media.setAttribute("controls",""):this.media.removeAttribute("controls")},build:function(){var e=this;if(this.listeners.media(),!this.supported.ui)return this.debug.warn("Basic support only for "+this.provider+" "+this.type),void C.toggleNativeControls.call(this,!0);u.is.element(this.elements.controls)||(g.inject.call(this),this.listeners.controls()),C.toggleNativeControls.call(this),f.setup.call(this),this.volume=null,this.muted=null,this.speed=null,this.loop=null,this.quality=null,g.updateVolume.call(this),g.timeUpdate.call(this),C.checkPlaying.call(this),u.toggleClass(this.elements.container,this.config.classNames.pip.supported,d.pip&&this.isHTML5&&this.isVideo),u.toggleClass(this.elements.container,this.config.classNames.airplay.supported,d.airplay&&this.isHTML5),u.toggleClass(this.elements.container,this.config.classNames.isIos,A.isIos),u.toggleClass(this.elements.container,this.config.classNames.isTouch,this.touch),this.ready=!0,setTimeout(function(){u.dispatchEvent.call(e,e.media,"ready")},0),C.setTitle.call(this),this.poster&&this.elements.poster&&!this.elements.poster.style.backgroundImage&&C.setPoster.call(this,this.poster)},setTitle:function(){var e=h("play",this.config);if(u.is.string(this.config.title)&&!u.is.empty(this.config.title)&&(e+=", "+this.config.title,this.elements.container.setAttribute("aria-label",this.config.title)),u.is.nodeList(this.elements.buttons.play)&&Array.from(this.elements.buttons.play).forEach(function(t){t.setAttribute("aria-label",e)}),this.isEmbed){var t=u.getElement.call(this,"iframe");if(!u.is.element(t))return;var i=u.is.empty(this.config.title)?"video":this.config.title,n=h("frameTitle",this.config);t.setAttribute("title",n.replace("{title}",i))}},togglePoster:function(e){u.toggleClass(this.elements.container,this.config.classNames.posterEnabled,e)},setPoster:function(e){var t=this;if(this.media.setAttribute("poster",e),!u.is.element(this.elements.poster))return Promise.reject();var i=u.loadImage(e).then(function(){return t.elements.poster.style.backgroundImage="url('"+e+"')",Object.assign(t.elements.poster.style,{backgroundImage:"url('"+e+"')",backgroundSize:""}),C.togglePoster.call(t,!0),e});return i.catch(function(){return C.togglePoster.call(t,!1)}),i},checkPlaying:function(e){u.toggleClass(this.elements.container,this.config.classNames.playing,this.playing),u.toggleClass(this.elements.container,this.config.classNames.paused,this.paused),u.toggleClass(this.elements.container,this.config.classNames.stopped,this.stopped),u.toggleState(this.elements.buttons.play,this.playing),u.is.event(e)&&"timeupdate"===e.type||C.toggleControls.call(this)},checkLoading:function(e){var t=this;this.loading=["stalled","waiting"].includes(e.type),clearTimeout(this.timers.loading),this.timers.loading=setTimeout(function(){u.toggleClass(t.elements.container,t.config.classNames.loading,t.loading),C.toggleControls.call(t)},this.loading?250:0)},toggleControls:function(e){var t=this.elements.controls;t&&this.config.hideControls&&this.toggleControls(Boolean(e||this.loading||this.paused||t.pressed||t.hover))}},S=u.getBrowser(),P=function(){function e(t){n(this,e),this.player=t,this.lastKey=null,this.handleKey=this.handleKey.bind(this),this.toggleMenu=this.toggleMenu.bind(this),this.firstTouch=this.firstTouch.bind(this)}return s(e,[{key:"handleKey",value:function(e){var t=this,i=e.keyCode?e.keyCode:e.which,n="keydown"===e.type,s=n&&i===this.lastKey;if(!(e.altKey||e.ctrlKey||e.metaKey||e.shiftKey)&&u.is.number(i)){if(n){var a=u.getFocusElement();if(u.is.element(a)&&u.matches(a,this.player.config.selectors.editable))return;switch([48,49,50,51,52,53,54,56,57,32,75,38,40,77,39,37,70,67,73,76,79].includes(i)&&(e.preventDefault(),e.stopPropagation()),i){case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:s||(t.player.currentTime=t.player.duration/10*(i-48));break;case 32:case 75:s||this.player.togglePlay();break;case 38:this.player.increaseVolume(.1);break;case 40:this.player.decreaseVolume(.1);break;case 77:s||(this.player.muted=!this.player.muted);break;case 39:this.player.forward();break;case 37:this.player.rewind();break;case 70:this.player.fullscreen.toggle();break;case 67:s||this.player.toggleCaptions();break;case 76:this.player.loop=!this.player.loop}!this.player.fullscreen.enabled&&this.player.fullscreen.active&&27===i&&this.player.fullscreen.toggle(),this.lastKey=i}else this.lastKey=null}}},{key:"toggleMenu",value:function(e){g.toggleMenu.call(this.player,e)}},{key:"firstTouch",value:function(){this.player.touch=!0,u.toggleClass(this.player.elements.container,this.player.config.classNames.isTouch,!0),u.off(document.body,"touchstart",this.firstTouch)}},{key:"global",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.player.config.keyboard.global&&u.toggleListener(window,"keydown keyup",this.handleKey,e,!1),u.toggleListener(document.body,"click",this.toggleMenu,e),u.on(document.body,"touchstart",this.firstTouch)}},{key:"container",value:function(){var e=this;!this.player.config.keyboard.global&&this.player.config.keyboard.focused&&u.on(this.player.elements.container,"keydown keyup",this.handleKey,!1),u.on(this.player.elements.container,"focusout",function(t){u.toggleClass(t.target,e.player.config.classNames.tabFocus,!1)}),u.on(this.player.elements.container,"keydown",function(t){9===t.keyCode&&setTimeout(function(){u.toggleClass(u.getFocusElement(),e.player.config.classNames.tabFocus,!0)},0)}),u.on(this.player.elements.container,"mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen",function(t){var i=e.player.elements.controls;"enterfullscreen"===t.type&&(i.pressed=!1,i.hover=!1);var n=0;["touchstart","touchmove","mousemove"].includes(t.type)&&(C.toggleControls.call(e.player,!0),n=e.player.touch?3e3:2e3),clearTimeout(e.player.timers.controls),e.player.timers.controls=setTimeout(function(){return C.toggleControls.call(e.player,!1)},n)})}},{key:"media",value:function(){var e=this;if(u.on(this.player.media,"timeupdate seeking seeked",function(t){return g.timeUpdate.call(e.player,t)}),u.on(this.player.media,"durationchange loadeddata loadedmetadata",function(t){return g.durationUpdate.call(e.player,t)}),u.on(this.player.media,"loadeddata",function(){u.toggleHidden(e.player.elements.volume,!e.player.hasAudio),u.toggleHidden(e.player.elements.buttons.mute,!e.player.hasAudio)}),u.on(this.player.media,"ended",function(){e.player.isHTML5&&e.player.isVideo&&e.player.config.resetOnEnd&&e.player.restart()}),u.on(this.player.media,"progress playing seeking seeked",function(t){return g.updateProgress.call(e.player,t)}),u.on(this.player.media,"volumechange",function(t){return g.updateVolume.call(e.player,t)}),u.on(this.player.media,"playing play pause ended emptied timeupdate",function(t){return C.checkPlaying.call(e.player,t)}),u.on(this.player.media,"waiting canplay seeked playing",function(t){return C.checkLoading.call(e.player,t)}),u.on(this.player.media,"playing",function(){e.player.ads&&e.player.ads.enabled&&!e.player.ads.initialized&&e.player.ads.managerPromise.then(function(){return e.player.ads.play()}).catch(function(){return e.player.play()})}),this.player.supported.ui&&this.player.config.clickToPlay&&!this.player.isAudio){var t=u.getElement.call(this.player,"."+this.player.config.classNames.video);if(!u.is.element(t))return;u.on(t,"click",function(){e.player.config.hideControls&&e.player.touch&&!e.player.paused||(e.player.paused?e.player.play():e.player.ended?(e.player.restart(),e.player.play()):e.player.pause())})}this.player.supported.ui&&this.player.config.disableContextMenu&&u.on(this.player.elements.wrapper,"contextmenu",function(e){e.preventDefault()},!1),u.on(this.player.media,"volumechange",function(){e.player.storage.set({volume:e.player.volume,muted:e.player.muted})}),u.on(this.player.media,"ratechange",function(){g.updateSetting.call(e.player,"speed"),e.player.storage.set({speed:e.player.speed})}),u.on(this.player.media,"qualityrequested",function(t){e.player.storage.set({quality:t.detail.quality})}),u.on(this.player.media,"qualitychange",function(t){g.updateSetting.call(e.player,"quality",null,t.detail.quality)}),u.on(this.player.media,"languagechange",function(){g.updateSetting.call(e.player,"captions"),e.player.storage.set({language:e.player.language})}),u.on(this.player.media,"captionsenabled captionsdisabled",function(){g.updateSetting.call(e.player,"captions"),e.player.storage.set({captions:e.player.captions.active})}),u.on(this.player.media,this.player.config.events.concat(["keyup","keydown"]).join(" "),function(t){var i={};"error"===t.type&&(i=e.player.media.error),u.dispatchEvent.call(e.player,e.player.elements.container,t.type,!0,i)})}},{key:"controls",value:function(){var e=this,t=S.isIE?"change":"input",i=function(t,i,n){var s=e.player.config.listeners[n],a=!0;u.is.function(s)&&(a=s.call(e.player,t)),a&&u.is.function(i)&&i.call(e.player,t)},n=function(t,n,s,a){var r=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],l=e.player.config.listeners[a],o=u.is.function(l);u.on(t,n,function(e){return i(e,s,a)},r&&!o)};n(this.player.elements.buttons.play,"click",this.player.togglePlay,"play"),n(this.player.elements.buttons.restart,"click",this.player.restart,"restart"),n(this.player.elements.buttons.rewind,"click",this.player.rewind,"rewind"),n(this.player.elements.buttons.fastForward,"click",this.player.forward,"fastForward"),n(this.player.elements.buttons.mute,"click",function(){e.player.muted=!e.player.muted},"mute"),n(this.player.elements.buttons.captions,"click",this.player.toggleCaptions),n(this.player.elements.buttons.fullscreen,"click",function(){e.player.fullscreen.toggle()},"fullscreen"),n(this.player.elements.buttons.pip,"click",function(){e.player.pip="toggle"},"pip"),n(this.player.elements.buttons.airplay,"click",this.player.airplay,"airplay"),n(this.player.elements.buttons.settings,"click",function(t){g.toggleMenu.call(e.player,t)}),n(this.player.elements.settings.form,"click",function(t){t.stopPropagation();var n=function(){var t="plyr-settings-"+e.player.id+"-home";g.showTab.call(e.player,t)};if(u.matches(t.target,e.player.config.selectors.inputs.language))i(t,function(){e.player.language=t.target.value,n()},"language");else if(u.matches(t.target,e.player.config.selectors.inputs.quality))i(t,function(){e.player.quality=t.target.value,n()},"quality");else if(u.matches(t.target,e.player.config.selectors.inputs.speed))i(t,function(){e.player.speed=parseFloat(t.target.value),n()},"speed");else{var s=t.target;g.showTab.call(e.player,s.getAttribute("aria-controls"))}}),n(this.player.elements.inputs.seek,"mousedown mousemove",function(t){var i=e.player.elements.progress.getBoundingClientRect(),n=100/i.width*(t.pageX-i.left);t.currentTarget.setAttribute("seek-value",n)}),n(this.player.elements.inputs.seek,"mousedown mouseup keydown keyup touchstart touchend",function(t){var i=t.currentTarget,n=i.hasAttribute("play-on-seeked"),s=["mouseup","touchend","keyup"].includes(t.type);n&&s?(i.removeAttribute("play-on-seeked"),e.player.play()):!s&&e.player.playing&&(i.setAttribute("play-on-seeked",""),e.player.pause())}),n(this.player.elements.inputs.seek,t,function(t){var i=t.currentTarget,n=i.getAttribute("seek-value");u.is.empty(n)&&(n=i.value),i.removeAttribute("seek-value"),e.player.currentTime=n/i.max*e.player.duration},"seek"),this.player.config.toggleInvert&&!u.is.element(this.player.elements.display.duration)&&n(this.player.elements.display.currentTime,"click",function(){0!==e.player.currentTime&&(e.player.config.invertTime=!e.player.config.invertTime,g.timeUpdate.call(e.player))}),n(this.player.elements.inputs.volume,t,function(t){e.player.volume=t.target.value},"volume"),S.isWebkit&&n(u.getElements.call(this.player,'input[type="range"]'),"input",function(t){g.updateRangeFill.call(e.player,t.target)}),n(this.player.elements.progress,"mouseenter mouseleave mousemove",function(t){return g.updateSeekTooltip.call(e.player,t)}),n(this.player.elements.controls,"mouseenter mouseleave",function(t){e.player.elements.controls.hover=!e.player.touch&&"mouseenter"===t.type}),n(this.player.elements.controls,"mousedown mouseup touchstart touchend touchcancel",function(t){e.player.elements.controls.pressed=["mousedown","touchstart"].includes(t.type)}),n(this.player.elements.controls,"focusin focusout",function(t){var i=e.player,n=i.config,s=i.elements,a=i.timers;if(u.toggleClass(s.controls,n.classNames.noTransition,"focusin"===t.type),C.toggleControls.call(e.player,"focusin"===t.type),"focusin"===t.type){setTimeout(function(){u.toggleClass(s.controls,n.classNames.noTransition,!1)},0);var r=e.touch?3e3:4e3;clearTimeout(a.controls),a.controls=setTimeout(function(){return C.toggleControls.call(e.player,!1)},r)}}),n(this.player.elements.inputs.volume,"wheel",function(t){var i=t.webkitDirectionInvertedFromDevice,n=0;(t.deltaY<0||t.deltaX>0)&&(i?(e.player.decreaseVolume(.02),n=-1):(e.player.increaseVolume(.02),n=1)),(t.deltaY>0||t.deltaX<0)&&(i?(e.player.increaseVolume(.02),n=1):(e.player.decreaseVolume(.02),n=-1)),(1===n&&e.player.media.volume<1||-1===n&&e.player.media.volume>0)&&t.preventDefault()},"volume",!1)}},{key:"clear",value:function(){this.global(!1)}}]),e}();function x(e){this.media.paused===e&&(this.media.paused=!e,u.dispatchEvent.call(this,this.media,e?"play":"pause"))}var N={setup:function(){var e=this;u.toggleClass(this.elements.wrapper,this.config.classNames.embed,!0),N.setAspectRatio.call(this),u.is.object(window.Vimeo)?N.ready.call(this):u.loadScript(this.config.urls.vimeo.sdk).then(function(){N.ready.call(e)}).catch(function(t){e.debug.warn("Vimeo API failed to load",t)})},setAspectRatio:function(e){var t=u.is.string(e)?e.split(":"):this.config.ratio.split(":"),i=100/t[0]*t[1];if(this.elements.wrapper.style.paddingBottom=i+"%",this.supported.ui){var n=(240-i)/4.8;this.media.style.transform="translateY(-"+n+"%)"}},ready:function(){var e=this,t=this,i={loop:t.config.loop.active,autoplay:t.autoplay,byline:!1,portrait:!1,title:!1,speed:!0,transparent:0,gesture:"media",playsinline:!this.config.fullscreen.iosNative},n=u.buildUrlParams(i),s=t.media.getAttribute("src");u.is.empty(s)&&(s=t.media.getAttribute(t.config.attributes.embed.id));var a=u.parseVimeoId(s),r=u.createElement("iframe"),l=u.format(t.config.urls.vimeo.iframe,a,n);r.setAttribute("src",l),r.setAttribute("allowfullscreen",""),r.setAttribute("allowtransparency",""),r.setAttribute("allow","autoplay");var o=u.createElement("div",{class:t.config.classNames.embedContainer});o.appendChild(r),t.media=u.replaceElement(o,t.media),u.fetch(u.format(t.config.urls.vimeo.api,a),"json").then(function(e){if(!u.is.empty(e)){var i=new URL(e[0].thumbnail_large);i.pathname=i.pathname.split("_")[0]+".jpg",C.setPoster.call(t,i.href)}}),t.embed=new window.Vimeo.Player(r,{autopause:t.config.autopause,muted:t.muted}),t.media.paused=!0,t.media.currentTime=0,t.supported.ui&&t.embed.disableTextTrack(),t.media.play=function(){return x.call(t,!0),t.embed.play()},t.media.pause=function(){return x.call(t,!1),t.embed.pause()},t.media.stop=function(){t.pause(),t.currentTime=0};var c=t.media.currentTime;Object.defineProperty(t.media,"currentTime",{get:function(){return c},set:function(e){var i=t.embed,n=t.media,s=t.paused,a=t.volume;n.seeking=!0,u.dispatchEvent.call(t,n,"seeking"),Promise.resolve(s&&i.setVolume(0)).then(function(){return i.setCurrentTime(e)}).then(function(){return s&&i.pause()}).then(function(){return s&&i.setVolume(a)}).catch(function(){})}});var d=t.config.speed.selected;Object.defineProperty(t.media,"playbackRate",{get:function(){return d},set:function(e){t.embed.setPlaybackRate(e).then(function(){d=e,u.dispatchEvent.call(t,t.media,"ratechange")}).catch(function(e){"Error"===e.name&&g.setSpeedMenu.call(t,[])})}});var p=t.config.volume;Object.defineProperty(t.media,"volume",{get:function(){return p},set:function(e){t.embed.setVolume(e).then(function(){p=e,u.dispatchEvent.call(t,t.media,"volumechange")})}});var h=t.config.muted;Object.defineProperty(t.media,"muted",{get:function(){return h},set:function(e){var i=!!u.is.boolean(e)&&e;t.embed.setVolume(i?0:t.config.volume).then(function(){h=i,u.dispatchEvent.call(t,t.media,"volumechange")})}});var m=t.config.loop;Object.defineProperty(t.media,"loop",{get:function(){return m},set:function(e){var i=u.is.boolean(e)?e:t.config.loop.active;t.embed.setLoop(i).then(function(){m=i})}});var y=void 0;t.embed.getVideoUrl().then(function(e){y=e}).catch(function(t){e.debug.warn(t)}),Object.defineProperty(t.media,"currentSrc",{get:function(){return y}}),Object.defineProperty(t.media,"ended",{get:function(){return t.currentTime===t.duration}}),Promise.all([t.embed.getVideoWidth(),t.embed.getVideoHeight()]).then(function(t){var i=u.getAspectRatio(t[0],t[1]);N.setAspectRatio.call(e,i)}),t.embed.setAutopause(t.config.autopause).then(function(e){t.config.autopause=e}),t.embed.getVideoTitle().then(function(i){t.config.title=i,C.setTitle.call(e)}),t.embed.getCurrentTime().then(function(e){c=e,u.dispatchEvent.call(t,t.media,"timeupdate")}),t.embed.getDuration().then(function(e){t.media.duration=e,u.dispatchEvent.call(t,t.media,"durationchange")}),t.embed.getTextTracks().then(function(e){t.media.textTracks=e,f.setup.call(t)}),t.embed.on("cuechange",function(e){var i=null;e.cues.length&&(i=u.stripHTML(e.cues[0].text)),f.setText.call(t,i)}),t.embed.on("loaded",function(){u.is.element(t.embed.element)&&t.supported.ui&&t.embed.element.setAttribute("tabindex",-1)}),t.embed.on("play",function(){x.call(t,!0),u.dispatchEvent.call(t,t.media,"playing")}),t.embed.on("pause",function(){x.call(t,!1)}),t.embed.on("timeupdate",function(e){t.media.seeking=!1,c=e.seconds,u.dispatchEvent.call(t,t.media,"timeupdate")}),t.embed.on("progress",function(e){t.media.buffered=e.percent,u.dispatchEvent.call(t,t.media,"progress"),1===parseInt(e.percent,10)&&u.dispatchEvent.call(t,t.media,"canplaythrough"),t.embed.getDuration().then(function(e){e!==t.media.duration&&(t.media.duration=e,u.dispatchEvent.call(t,t.media,"durationchange"))})}),t.embed.on("seeked",function(){t.media.seeking=!1,u.dispatchEvent.call(t,t.media,"seeked")}),t.embed.on("ended",function(){t.media.paused=!0,u.dispatchEvent.call(t,t.media,"ended")}),t.embed.on("error",function(e){t.media.error=e,u.dispatchEvent.call(t,t.media,"error")}),setTimeout(function(){return C.build.call(t)},0)}};function L(e){switch(e){case"hd2160":return 2160;case 2160:return"hd2160";case"hd1440":return 1440;case 1440:return"hd1440";case"hd1080":return 1080;case 1080:return"hd1080";case"hd720":return 720;case 720:return"hd720";case"large":return 480;case 480:return"large";case"medium":return 360;case 360:return"medium";case"small":return 240;case 240:return"small";default:return"default"}}function M(e){this.media.paused===e&&(this.media.paused=!e,u.dispatchEvent.call(this,this.media,e?"play":"pause"))}var I={setup:function(){var e=this;u.toggleClass(this.elements.wrapper,this.config.classNames.embed,!0),I.setAspectRatio.call(this),u.is.object(window.YT)&&u.is.function(window.YT.Player)?I.ready.call(this):(u.loadScript(this.config.urls.youtube.sdk).catch(function(t){e.debug.warn("YouTube API failed to load",t)}),window.onYouTubeReadyCallbacks=window.onYouTubeReadyCallbacks||[],window.onYouTubeReadyCallbacks.push(function(){I.ready.call(e)}),window.onYouTubeIframeAPIReady=function(){window.onYouTubeReadyCallbacks.forEach(function(e){e()})})},getTitle:function(e){var t=this;if(u.is.function(this.embed.getVideoData)){var i=this.embed.getVideoData().title;if(u.is.empty(i))return this.config.title=i,void C.setTitle.call(this)}var n=this.config.keys.google;if(u.is.string(n)&&!u.is.empty(n)){var s=u.format(this.config.urls.youtube.api,e,n);u.fetch(s).then(function(e){u.is.object(e)&&(t.config.title=e.items[0].snippet.title,C.setTitle.call(t))}).catch(function(){})}},setAspectRatio:function(){var e=this.config.ratio.split(":");this.elements.wrapper.style.paddingBottom=100/e[0]*e[1]+"%"},ready:function(){var e=this,t=e.media.getAttribute("id");if(u.is.empty(t)||!t.startsWith("youtube-")){var i=e.media.getAttribute("src");u.is.empty(i)&&(i=e.media.getAttribute(this.config.attributes.embed.id));var n=u.parseYouTubeId(i),s=u.generateId(e.provider),a=u.createElement("div",{id:s});e.media=u.replaceElement(a,e.media);var r=function(e){return"https://img.youtube.com/vi/"+n+"/"+e+"default.jpg"};u.loadImage(r("maxres"),121).catch(function(){return u.loadImage(r("sd"),121)}).catch(function(){return u.loadImage(r("hq"))}).then(function(t){return C.setPoster.call(e,t.src)}).then(function(t){t.includes("maxres")||(e.elements.poster.style.backgroundSize="cover")}),e.embed=new window.YT.Player(s,{videoId:n,playerVars:{autoplay:e.config.autoplay?1:0,controls:e.supported.ui?0:1,rel:0,showinfo:0,iv_load_policy:3,modestbranding:1,disablekb:1,playsinline:1,widget_referrer:window?window.location.href:null,cc_load_policy:e.captions.active?1:0,cc_lang_pref:e.config.captions.language},events:{onError:function(t){if(!u.is.object(e.media.error)){var i={code:t.data};switch(t.data){case 2:i.message="The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.";break;case 5:i.message="The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.";break;case 100:i.message="The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.";break;case 101:case 150:i.message="The owner of the requested video does not allow it to be played in embedded players.";break;default:i.message="An unknown error occured"}e.media.error=i,u.dispatchEvent.call(e,e.media,"error")}},onPlaybackQualityChange:function(){u.dispatchEvent.call(e,e.media,"qualitychange",!1,{quality:e.media.quality})},onPlaybackRateChange:function(t){var i=t.target;e.media.playbackRate=i.getPlaybackRate(),u.dispatchEvent.call(e,e.media,"ratechange")},onReady:function(t){var i=t.target;I.getTitle.call(e,n),e.media.play=function(){M.call(e,!0),i.playVideo()},e.media.pause=function(){M.call(e,!1),i.pauseVideo()},e.media.stop=function(){i.stopVideo()},e.media.duration=i.getDuration(),e.media.paused=!0,e.media.currentTime=0,Object.defineProperty(e.media,"currentTime",{get:function(){return Number(i.getCurrentTime())},set:function(t){e.paused&&e.embed.mute(),e.media.seeking=!0,u.dispatchEvent.call(e,e.media,"seeking"),i.seekTo(t)}}),Object.defineProperty(e.media,"playbackRate",{get:function(){return i.getPlaybackRate()},set:function(e){i.setPlaybackRate(e)}}),Object.defineProperty(e.media,"quality",{get:function(){return L(i.getPlaybackQuality())},set:function(t){var n=t;i.setPlaybackQuality(L(n)),u.dispatchEvent.call(e,e.media,"qualityrequested",!1,{quality:n})}});var s=e.config.volume;Object.defineProperty(e.media,"volume",{get:function(){return s},set:function(t){s=t,i.setVolume(100*s),u.dispatchEvent.call(e,e.media,"volumechange")}});var a=e.config.muted;Object.defineProperty(e.media,"muted",{get:function(){return a},set:function(t){var n=u.is.boolean(t)?t:a;a=n,i[n?"mute":"unMute"](),u.dispatchEvent.call(e,e.media,"volumechange")}}),Object.defineProperty(e.media,"currentSrc",{get:function(){return i.getVideoUrl()}}),Object.defineProperty(e.media,"ended",{get:function(){return e.currentTime===e.duration}}),e.options.speed=i.getAvailablePlaybackRates(),e.supported.ui&&e.media.setAttribute("tabindex",-1),u.dispatchEvent.call(e,e.media,"timeupdate"),u.dispatchEvent.call(e,e.media,"durationchange"),clearInterval(e.timers.buffering),e.timers.buffering=setInterval(function(){e.media.buffered=i.getVideoLoadedFraction(),(null===e.media.lastBuffered||e.media.lastBuffered<e.media.buffered)&&u.dispatchEvent.call(e,e.media,"progress"),e.media.lastBuffered=e.media.buffered,1===e.media.buffered&&(clearInterval(e.timers.buffering),u.dispatchEvent.call(e,e.media,"canplaythrough"))},200),setTimeout(function(){return C.build.call(e)},50)},onStateChange:function(t){var i,n=t.target;switch(clearInterval(e.timers.playing),e.media.seeking&&[1,2].includes(t.data)&&(e.media.seeking=!1,u.dispatchEvent.call(e,e.media,"seeked")),t.data){case-1:u.dispatchEvent.call(e,e.media,"timeupdate"),e.media.buffered=n.getVideoLoadedFraction(),u.dispatchEvent.call(e,e.media,"progress");break;case 0:M.call(e,!1),e.media.loop?(n.stopVideo(),n.playVideo()):u.dispatchEvent.call(e,e.media,"ended");break;case 1:e.media.paused?e.media.pause():(M.call(e,!0),u.dispatchEvent.call(e,e.media,"playing"),e.timers.playing=setInterval(function(){u.dispatchEvent.call(e,e.media,"timeupdate")},50),e.media.duration!==n.getDuration()&&(e.media.duration=n.getDuration(),u.dispatchEvent.call(e,e.media,"durationchange")),g.setQualityMenu.call(e,(i=n.getAvailableQualityLevels(),u.is.empty(i)?i:u.dedupe(i.map(function(e){return L(e)})))));break;case 2:e.muted||e.embed.unMute(),M.call(e,!1)}u.dispatchEvent.call(e,e.elements.container,"statechange",!1,{code:t.data})}}})}}},q={setup:function(){if(this.media)if(u.toggleClass(this.elements.container,this.config.classNames.type.replace("{0}",this.type),!0),u.toggleClass(this.elements.container,this.config.classNames.provider.replace("{0}",this.provider),!0),this.isEmbed&&u.toggleClass(this.elements.container,this.config.classNames.type.replace("{0}","video"),!0),this.isVideo&&(this.elements.wrapper=u.createElement("div",{class:this.config.classNames.video}),u.wrap(this.media,this.elements.wrapper),this.elements.poster=u.createElement("div",{class:this.config.classNames.poster}),this.elements.wrapper.appendChild(this.elements.poster)),this.isEmbed)switch(this.provider){case"youtube":I.setup.call(this);break;case"vimeo":N.setup.call(this)}else this.isHTML5&&p.extend.call(this);else this.debug.warn("No media element found!")}},_=function(){function e(t){var i=this;n(this,e),this.player=t,this.publisherId=t.config.ads.publisherId,this.playing=!1,this.initialized=!1,this.elements={container:null,displayContainer:null},this.manager=null,this.loader=null,this.cuePoints=null,this.events={},this.safetyTimer=null,this.countdownTimer=null,this.managerPromise=new Promise(function(e,t){i.on("loaded",e),i.on("error",t)}),this.load()}return s(e,[{key:"load",value:function(){var e=this;this.enabled&&(u.is.object(window.google)&&u.is.object(window.google.ima)?this.ready():u.loadScript(this.player.config.urls.googleIMA.sdk).then(function(){e.ready()}).catch(function(){e.trigger("error",new Error("Google IMA SDK failed to load"))}))}},{key:"ready",value:function(){var e=this;this.startSafetyTimer(12e3,"ready()"),this.managerPromise.then(function(){e.clearSafetyTimer("onAdsManagerLoaded()")}),this.listeners(),this.setupIMA()}},{key:"setupIMA",value:function(){this.elements.container=u.createElement("div",{class:this.player.config.classNames.ads}),this.player.elements.container.appendChild(this.elements.container),google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED),google.ima.settings.setLocale(this.player.config.ads.language),this.elements.displayContainer=new google.ima.AdDisplayContainer(this.elements.container),this.requestAds()}},{key:"requestAds",value:function(){var e=this,t=this.player.elements.container;try{this.loader=new google.ima.AdsLoader(this.elements.displayContainer),this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,function(t){return e.onAdsManagerLoaded(t)},!1),this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR,function(t){return e.onAdError(t)},!1);var i=new google.ima.AdsRequest;i.adTagUrl=this.tagUrl,i.linearAdSlotWidth=t.offsetWidth,i.linearAdSlotHeight=t.offsetHeight,i.nonLinearAdSlotWidth=t.offsetWidth,i.nonLinearAdSlotHeight=t.offsetHeight,i.forceNonLinearFullSlot=!1,i.setAdWillPlayMuted(!this.player.muted),this.loader.requestAds(i)}catch(e){this.onAdError(e)}}},{key:"pollCountdown",value:function(){var e=this;if(!(arguments.length>0&&void 0!==arguments[0]&&arguments[0]))return clearInterval(this.countdownTimer),void this.elements.container.removeAttribute("data-badge-text");this.countdownTimer=setInterval(function(){var t=u.formatTime(Math.max(e.manager.getRemainingTime(),0)),i=h("advertisement",e.player.config)+" - "+t;e.elements.container.setAttribute("data-badge-text",i)},100)}},{key:"onAdsManagerLoaded",value:function(e){var t=this,i=new google.ima.AdsRenderingSettings;i.restoreCustomPlaybackStateOnAdBreakComplete=!0,i.enablePreloading=!0,this.manager=e.getAdsManager(this.player,i),this.cuePoints=this.manager.getCuePoints(),u.is.empty(this.cuePoints)||this.cuePoints.forEach(function(e){if(0!==e&&-1!==e&&e<t.player.duration){var i=t.player.elements.progress;if(u.is.element(i)){var n=100/t.player.duration*e,s=u.createElement("span",{class:t.player.config.classNames.cues});s.style.left=n.toString()+"%",i.appendChild(s)}}}),this.manager.setVolume(this.player.volume),this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR,function(e){return t.onAdError(e)}),Object.keys(google.ima.AdEvent.Type).forEach(function(e){t.manager.addEventListener(google.ima.AdEvent.Type[e],function(e){return t.onAdEvent(e)})}),this.trigger("loaded")}},{key:"onAdEvent",value:function(e){var t=this,i=this.player.elements.container,n=e.getAd(),s=function(e){var i="ads"+e.replace(/_/g,"").toLowerCase();u.dispatchEvent.call(t.player,t.player.media,i)};switch(e.type){case google.ima.AdEvent.Type.LOADED:this.trigger("loaded"),s(e.type),this.pollCountdown(!0),n.isLinear()||(n.width=i.offsetWidth,n.height=i.offsetHeight);break;case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:s(e.type),this.loadAds();break;case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:s(e.type),this.pauseContent();break;case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:s(e.type),this.pollCountdown(),this.resumeContent();break;case google.ima.AdEvent.Type.STARTED:case google.ima.AdEvent.Type.MIDPOINT:case google.ima.AdEvent.Type.COMPLETE:case google.ima.AdEvent.Type.IMPRESSION:case google.ima.AdEvent.Type.CLICK:s(e.type)}}},{key:"onAdError",value:function(e){this.cancel(),this.player.debug.warn("Ads error",e)}},{key:"listeners",value:function(){var e=this,t=this.player.elements.container,i=void 0;this.player.on("ended",function(){e.loader.contentComplete()}),this.player.on("seeking",function(){return i=e.player.currentTime}),this.player.on("seeked",function(){var t=e.player.currentTime;u.is.empty(e.cuePoints)||e.cuePoints.forEach(function(n,s){i<n&&n<t&&(e.manager.discardAdBreak(),e.cuePoints.splice(s,1))})}),window.addEventListener("resize",function(){e.manager&&e.manager.resize(t.offsetWidth,t.offsetHeight,google.ima.ViewMode.NORMAL)})}},{key:"play",value:function(){var e=this,t=this.player.elements.container;this.managerPromise||this.resumeContent(),this.managerPromise.then(function(){e.elements.displayContainer.initialize();try{e.initialized||(e.manager.init(t.offsetWidth,t.offsetHeight,google.ima.ViewMode.NORMAL),e.manager.start()),e.initialized=!0}catch(t){e.onAdError(t)}}).catch(function(){})}},{key:"resumeContent",value:function(){this.elements.container.style.zIndex="",this.playing=!1,this.player.currentTime<this.player.duration&&this.player.play()}},{key:"pauseContent",value:function(){this.elements.container.style.zIndex=3,this.playing=!0,this.player.pause()}},{key:"cancel",value:function(){this.initialized&&this.resumeContent(),this.trigger("error"),this.loadAds()}},{key:"loadAds",value:function(){var e=this;this.managerPromise.then(function(){e.manager&&e.manager.destroy(),e.managerPromise=new Promise(function(t){e.on("loaded",t),e.player.debug.log(e.manager)}),e.requestAds()}).catch(function(){})}},{key:"trigger",value:function(e){for(var t=this,i=arguments.length,n=Array(i>1?i-1:0),s=1;s<i;s++)n[s-1]=arguments[s];var a=this.events[e];u.is.array(a)&&a.forEach(function(e){u.is.function(e)&&e.apply(t,n)})}},{key:"on",value:function(e,t){return u.is.array(this.events[e])||(this.events[e]=[]),this.events[e].push(t),this}},{key:"startSafetyTimer",value:function(e,t){var i=this;this.player.debug.log("Safety timer invoked from: "+t),this.safetyTimer=setTimeout(function(){i.cancel(),i.clearSafetyTimer("startSafetyTimer()")},e)}},{key:"clearSafetyTimer",value:function(e){u.is.nullOrUndefined(this.safetyTimer)||(this.player.debug.log("Safety timer cleared from: "+e),clearTimeout(this.safetyTimer),this.safetyTimer=null)}},{key:"enabled",get:function(){return this.player.isVideo&&this.player.config.ads.enabled&&!u.is.empty(this.publisherId)}},{key:"tagUrl",get:function(){var e={AV_PUBLISHERID:"58c25bb0073ef448b1087ad6",AV_CHANNELID:"5a0458dc28a06145e4519d21",AV_URL:location.hostname,cb:Date.now(),AV_WIDTH:640,AV_HEIGHT:480,AV_CDIM2:this.publisherId};return"https://go.aniview.com/api/adserver6/vast/?"+u.buildUrlParams(e)}}]),e}(),O={insertElements:function(e,t){var i=this;u.is.string(t)?u.insertElement(e,this.media,{src:t}):u.is.array(t)&&t.forEach(function(t){u.insertElement(e,i.media,t)})},change:function(e){var t=this;u.is.object(e)&&"sources"in e&&e.sources.length?(p.cancelRequests.call(this),this.destroy.call(this,function(){switch(t.options.quality=[],u.removeElement(t.media),t.media=null,u.is.element(t.elements.container)&&t.elements.container.removeAttribute("class"),t.type=e.type,t.provider=u.is.empty(e.sources[0].provider)?o.html5:e.sources[0].provider,t.supported=d.check(t.type,t.provider,t.config.playsinline),t.provider+":"+t.type){case"html5:video":t.media=u.createElement("video");break;case"html5:audio":t.media=u.createElement("audio");break;case"youtube:video":case"vimeo:video":t.media=u.createElement("div",{src:e.sources[0].src})}t.elements.container.appendChild(t.media),u.is.boolean(e.autoplay)&&(t.config.autoplay=e.autoplay),t.isHTML5&&(t.config.crossorigin&&t.media.setAttribute("crossorigin",""),t.config.autoplay&&t.media.setAttribute("autoplay",""),u.is.empty(e.poster)||(t.poster=e.poster),t.config.loop.active&&t.media.setAttribute("loop",""),t.config.muted&&t.media.setAttribute("muted",""),t.config.playsinline&&t.media.setAttribute("playsinline","")),C.addStyleHook.call(t),t.isHTML5&&O.insertElements.call(t,"source",e.sources),t.config.title=e.title,q.setup.call(t),t.isHTML5&&("tracks"in e&&O.insertElements.call(t,"track",e.tracks),t.media.load()),(t.isHTML5||t.isEmbed&&!t.supported.ui)&&C.build.call(t),t.fullscreen.update()},!0)):this.debug.warn("Invalid source format")}},j=function(){function e(t,i){var s=this;if(n(this,e),this.timers={},this.ready=!1,this.loading=!1,this.failed=!1,this.touch=d.touch,this.media=t,u.is.string(this.media)&&(this.media=document.querySelectorAll(this.media)),(window.jQuery&&this.media instanceof jQuery||u.is.nodeList(this.media)||u.is.array(this.media))&&(this.media=this.media[0]),this.config=u.extend({},b,e.defaults,i||{},function(){try{return JSON.parse(s.media.getAttribute("data-plyr-config"))}catch(e){return{}}}()),this.elements={container:null,buttons:{},display:{},progress:{},inputs:{},settings:{menu:null,panes:{},tabs:{}},captions:null},this.captions={active:null,currentTrack:null},this.fullscreen={active:!1},this.options={speed:[],quality:[],captions:[]},this.debug=new v(this.config.debug),this.debug.log("Config",this.config),this.debug.log("Support",d),!u.is.nullOrUndefined(this.media)&&u.is.element(this.media))if(this.media.plyr)this.debug.warn("Target already setup");else if(this.config.enabled)if(d.check().api){var a=this.media.cloneNode(!0);a.autoplay=!1,this.elements.original=a;var r=this.media.tagName.toLowerCase(),p=null,h=null,m=null;switch(r){case"div":if(p=this.media.querySelector("iframe"),u.is.element(p)){if(h=p.getAttribute("src"),this.provider=u.getProviderByUrl(h),this.elements.container=this.media,this.media=p,this.elements.container.className="",m=u.getUrlParams(h),!u.is.empty(m)){var g=["1","true"];g.includes(m.autoplay)&&(this.config.autoplay=!0),g.includes(m.loop)&&(this.config.loop.active=!0),this.isYouTube?this.config.playsinline=g.includes(m.playsinline):this.config.playsinline=!0}}else this.provider=this.media.getAttribute(this.config.attributes.embed.provider),this.media.removeAttribute(this.config.attributes.embed.provider);if(u.is.empty(this.provider)||!Object.keys(o).includes(this.provider))return void this.debug.error("Setup failed: Invalid provider");this.type=c.video;break;case"video":case"audio":this.type=r,this.provider=o.html5,this.media.hasAttribute("crossorigin")&&(this.config.crossorigin=!0),this.media.hasAttribute("autoplay")&&(this.config.autoplay=!0),this.media.hasAttribute("playsinline")&&(this.config.playsinline=!0),this.media.hasAttribute("muted")&&(this.config.muted=!0),this.media.hasAttribute("loop")&&(this.config.loop.active=!0);break;default:return void this.debug.error("Setup failed: unsupported type")}this.supported=d.check(this.type,this.provider,this.config.playsinline),this.supported.api?(this.listeners=new P(this),this.storage=new l(this),this.media.plyr=this,u.is.element(this.elements.container)||(this.elements.container=u.createElement("div"),u.wrap(this.media,this.elements.container)),this.elements.container.setAttribute("tabindex",0),C.addStyleHook.call(this),q.setup.call(this),this.config.debug&&u.on(this.elements.container,this.config.events.join(" "),function(e){s.debug.log("event: "+e.type)}),(this.isHTML5||this.isEmbed&&!this.supported.ui)&&C.build.call(this),this.listeners.container(),this.listeners.global(),this.fullscreen=new T(this),this.ads=new _(this),this.config.autoplay&&this.play()):this.debug.error("Setup failed: no support")}else this.debug.error("Setup failed: no support");else this.debug.error("Setup failed: disabled by config");else this.debug.error("Setup failed: no suitable element passed")}return s(e,[{key:"play",value:function(){return u.is.function(this.media.play)?this.media.play():null}},{key:"pause",value:function(){this.playing&&u.is.function(this.media.pause)&&this.media.pause()}},{key:"togglePlay",value:function(e){(u.is.boolean(e)?e:!this.playing)?this.play():this.pause()}},{key:"stop",value:function(){this.isHTML5?(this.pause(),this.restart()):u.is.function(this.media.stop)&&this.media.stop()}},{key:"restart",value:function(){this.currentTime=0}},{key:"rewind",value:function(e){this.currentTime=this.currentTime-(u.is.number(e)?e:this.config.seekTime)}},{key:"forward",value:function(e){this.currentTime=this.currentTime+(u.is.number(e)?e:this.config.seekTime)}},{key:"increaseVolume",value:function(e){var t=this.media.muted?0:this.volume;this.volume=t+(u.is.number(e)?e:1)}},{key:"decreaseVolume",value:function(e){var t=this.media.muted?0:this.volume;this.volume=t-(u.is.number(e)?e:1)}},{key:"toggleCaptions",value:function(e){if(this.supported.ui){var t=u.is.boolean(e)?e:!this.elements.container.classList.contains(this.config.classNames.captions.active);this.captions.active!==t&&(this.captions.active=t,u.toggleState(this.elements.buttons.captions,this.captions.active),u.toggleClass(this.elements.container,this.config.classNames.captions.active,this.captions.active),u.dispatchEvent.call(this,this.media,this.captions.active?"captionsenabled":"captionsdisabled"))}}},{key:"airplay",value:function(){d.airplay&&this.media.webkitShowPlaybackTargetPicker()}},{key:"toggleControls",value:function(e){if(this.supported.ui&&!this.isAudio){var t=u.hasClass(this.elements.container,this.config.classNames.hideControls),i=void 0===e?void 0:!e,n=u.toggleClass(this.elements.container,this.config.classNames.hideControls,i);if(n&&this.config.controls.includes("settings")&&!u.is.empty(this.config.settings)&&g.toggleMenu.call(this,!1),n!==t){var s=n?"controlshidden":"controlsshown";u.dispatchEvent.call(this,this.media,s)}return!n}return!1}},{key:"on",value:function(e,t){u.on(this.elements.container,e,t)}},{key:"off",value:function(e,t){u.off(this.elements.container,e,t)}},{key:"destroy",value:function(e){var t=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(this.ready){var n=function(){document.body.style.overflow="",t.embed=null,i?(Object.keys(t.elements).length&&(u.removeElement(t.elements.buttons.play),u.removeElement(t.elements.captions),u.removeElement(t.elements.controls),u.removeElement(t.elements.wrapper),t.elements.buttons.play=null,t.elements.captions=null,t.elements.controls=null,t.elements.wrapper=null),u.is.function(e)&&e()):(t.listeners.clear(),u.replaceElement(t.elements.original,t.elements.container),u.dispatchEvent.call(t,t.elements.original,"destroyed",!0),u.is.function(e)&&e.call(t.elements.original),t.ready=!1,setTimeout(function(){t.elements=null,t.media=null},200))};switch(this.stop(),this.provider+":"+this.type){case"html5:video":case"html5:audio":clearTimeout(this.timers.loading),C.toggleNativeControls.call(this,!0),n();break;case"youtube:video":clearInterval(this.timers.buffering),clearInterval(this.timers.playing),null!==this.embed&&u.is.function(this.embed.destroy)&&this.embed.destroy(),n();break;case"vimeo:video":null!==this.embed&&this.embed.unload().then(n),setTimeout(n,200)}}}},{key:"supports",value:function(e){return d.mime.call(this,e)}},{key:"isHTML5",get:function(){return Boolean(this.provider===o.html5)}},{key:"isEmbed",get:function(){return Boolean(this.isYouTube||this.isVimeo)}},{key:"isYouTube",get:function(){return Boolean(this.provider===o.youtube)}},{key:"isVimeo",get:function(){return Boolean(this.provider===o.vimeo)}},{key:"isVideo",get:function(){return Boolean(this.type===c.video)}},{key:"isAudio",get:function(){return Boolean(this.type===c.audio)}},{key:"playing",get:function(){return Boolean(this.ready&&!this.paused&&!this.ended)}},{key:"paused",get:function(){return Boolean(this.media.paused)}},{key:"stopped",get:function(){return Boolean(this.paused&&0===this.currentTime)}},{key:"ended",get:function(){return Boolean(this.media.ended)}},{key:"currentTime",set:function(e){if(this.duration){var t=u.is.number(e)&&e>0;this.media.currentTime=t?Math.min(e,this.duration):0,this.debug.log("Seeking to "+this.currentTime+" seconds")}},get:function(){return Number(this.media.currentTime)}},{key:"buffered",get:function(){var e=this.media.buffered;return u.is.number(e)?e:e&&e.length&&this.duration>0?e.end(0)/this.duration:0}},{key:"seeking",get:function(){return Boolean(this.media.seeking)}},{key:"duration",get:function(){var e=parseFloat(this.config.duration),t=(this.media||{}).duration||0;return e||t}},{key:"volume",set:function(e){var t=e;u.is.string(t)&&(t=Number(t)),u.is.number(t)||(t=this.storage.get("volume")),u.is.number(t)||(t=this.config.volume),t>1&&(t=1),t<0&&(t=0),this.config.volume=t,this.media.volume=t,!u.is.empty(e)&&this.muted&&t>0&&(this.muted=!1)},get:function(){return Number(this.media.volume)}},{key:"muted",set:function(e){var t=e;u.is.boolean(t)||(t=this.storage.get("muted")),u.is.boolean(t)||(t=this.config.muted),this.config.muted=t,this.media.muted=t},get:function(){return Boolean(this.media.muted)}},{key:"hasAudio",get:function(){return!this.isHTML5||(!!this.isAudio||(Boolean(this.media.mozHasAudio)||Boolean(this.media.webkitAudioDecodedByteCount)||Boolean(this.media.audioTracks&&this.media.audioTracks.length)))}},{key:"speed",set:function(e){var t=null;u.is.number(e)&&(t=e),u.is.number(t)||(t=this.storage.get("speed")),u.is.number(t)||(t=this.config.speed.selected),t<.1&&(t=.1),t>2&&(t=2),this.config.speed.options.includes(t)?(this.config.speed.selected=t,this.media.playbackRate=t):this.debug.warn("Unsupported speed ("+t+")")},get:function(){return Number(this.media.playbackRate)}},{key:"quality",set:function(e){var t=null;if(u.is.empty(e)||(t=Number(e)),u.is.number(t)&&0!==t||(t=this.storage.get("quality")),u.is.number(t)||(t=this.config.quality.selected),u.is.number(t)||(t=this.config.quality.default),this.options.quality.length){if(!this.options.quality.includes(t)){var i=u.closest(this.options.quality,t);this.debug.warn("Unsupported quality option: "+t+", using "+i+" instead"),t=i}this.config.quality.selected=t,this.media.quality=t}},get:function(){return this.media.quality}},{key:"loop",set:function(e){var t=u.is.boolean(e)?e:this.config.loop.active;this.config.loop.active=t,this.media.loop=t},get:function(){return Boolean(this.media.loop)}},{key:"source",set:function(e){O.change.call(this,e)},get:function(){return this.media.currentSrc}},{key:"poster",set:function(e){this.isVideo?C.setPoster.call(this,e):this.debug.warn("Poster can only be set for video")},get:function(){return this.isVideo?this.media.getAttribute("poster"):null}},{key:"autoplay",set:function(e){var t=u.is.boolean(e)?e:this.config.autoplay;this.config.autoplay=t},get:function(){return Boolean(this.config.autoplay)}},{key:"language",set:function(e){if(u.is.string(e))if(u.is.empty(e))this.toggleCaptions(!1);else{var t=e.toLowerCase();this.options.captions.includes(t)?(this.toggleCaptions(!0),"enabled"!==t&&this.language!==t&&(this.captions.language=t,f.setText.call(this,null),f.setLanguage.call(this),u.dispatchEvent.call(this,this.media,"languagechange"))):this.debug.warn("Unsupported language option: "+t)}},get:function(){return this.captions.language}},{key:"pip",set:function(e){var t="picture-in-picture",i="inline";if(d.pip){var n=u.is.boolean(e)?e:this.pip===i;this.media.webkitSetPresentationMode(n?t:i)}},get:function(){return d.pip?this.media.webkitPresentationMode:null}}],[{key:"supported",value:function(e,t,i){return d.check(e,t,i)}},{key:"loadSprite",value:function(e,t){return u.loadSprite(e,t)}},{key:"setup",value:function(t){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=null;return u.is.string(t)?n=Array.from(document.querySelectorAll(t)):u.is.nodeList(t)?n=Array.from(t):u.is.array(t)&&(n=t.filter(function(e){return u.is.element(e)})),u.is.empty(n)?null:n.map(function(t){return new e(t,i)})}}]),e}();return j.defaults=u.cloneDeep(b),j});
	//# sourceMappingURL=plyr.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var invariant = _interopDefault(__webpack_require__(48));
	
	var INSTANCE_MAP = new Map();
	var OBSERVER_MAP = new Map();
	
	/**
	 * Monitor element, and trigger callback when element becomes visible
	 * @param element {HTMLElement}
	 * @param callback {Function} Called with inView
	 * @param options {Object} InterSection observer options
	 * @param options.threshold {Number} Number between 0 and 1, indicating how much of the element should be visible before triggering
	 * @param options.root {HTMLElement} It should have a unique id or data-intersection-id in order for the Observer to reused.
	 * @param options.rootMargin {String} The CSS margin to apply to the root element.
	 * @param rootId {String} Unique identifier for the root element, to enable reusing the IntersectionObserver
	 */
	function observe(element, callback) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    threshold: 0
	  };
	  var rootId = arguments[3];
	  var root = options.root,
	      rootMargin = options.rootMargin;
	
	  var threshold = options.threshold || 0;
	  if (!element || !callback) return;
	  var observerId = rootMargin ? threshold.toString() + "_" + rootMargin : "" + threshold.toString();
	
	  if (root) {
	    observerId = rootId ? rootId + "_" + observerId : null;
	  }
	
	  var observerInstance = observerId ? OBSERVER_MAP.get(observerId) : null;
	  if (!observerInstance) {
	    observerInstance = new IntersectionObserver(onChange, options);
	    if (observerId) OBSERVER_MAP.set(observerId, observerInstance);
	  }
	
	  var instance = {
	    callback: callback,
	    visible: false,
	    options: options,
	    observerId: observerId,
	    observer: !observerId ? observerInstance : undefined
	  };
	
	  INSTANCE_MAP.set(element, instance);
	
	  observerInstance.observe(element);
	
	  return instance;
	}
	
	/**
	 * Stop observing an element. If an element is removed from the DOM or otherwise destroyed,
	 * make sure to call this method.
	 * @param element {HTMLElement}
	 */
	function unobserve(element) {
	  if (!element) return;
	  var instance = INSTANCE_MAP.get(element);
	
	  if (instance) {
	    var _observerId = instance.observerId,
	        _observer = instance.observer;
	
	    var observerInstance = _observerId ? OBSERVER_MAP.get(_observerId) : _observer;
	
	    if (observerInstance) {
	      // $FlowFixMe - the interface in bom.js is wrong. Spec should accept the element.
	      observerInstance.unobserve(element);
	    }
	
	    // Check if we are still observing any elements with the same threshold.
	    var itemsLeft = false;
	    if (_observerId) {
	      INSTANCE_MAP.forEach(function (item, key) {
	        if (item && item.observerId === _observerId && key !== element) {
	          itemsLeft = true;
	        }
	      });
	    }
	
	    if (observerInstance && !itemsLeft) {
	      // No more elements to observe for threshold, disconnect observer
	      observerInstance.disconnect();
	      OBSERVER_MAP.delete(_observerId);
	    }
	
	    // Remove reference to element
	    INSTANCE_MAP.delete(element);
	  }
	}
	
	function onChange(changes) {
	  changes.forEach(function (intersection) {
	    var isIntersecting = intersection.isIntersecting,
	        intersectionRatio = intersection.intersectionRatio,
	        target = intersection.target;
	
	    var instance = INSTANCE_MAP.get(target);
	
	    // Firefox can report a negative intersectionRatio when scrolling.
	    if (instance && intersectionRatio >= 0) {
	      var _options = instance.options;
	
	      var _inView = false;
	
	      if (Array.isArray(_options.threshold)) {
	        // If threshold is an array, check if any of them intersects. This just triggers the onChange event multiple times.
	        _inView = _options.threshold.some(function (threshold) {
	          return instance.visible ? intersectionRatio > threshold : intersectionRatio >= threshold;
	        });
	      } else if (_options.threshold !== undefined) {
	        // Trigger on 0 ratio only when not visible. This is fallback for browsers without isIntersecting support
	        _inView = instance.visible ? intersectionRatio > _options.threshold : intersectionRatio >= _options.threshold;
	      }
	
	      if (isIntersecting !== undefined) {
	        // If isIntersecting is defined, ensure that the element is actually intersecting.
	        // Otherwise it reports a threshold of 0
	        _inView = _inView && isIntersecting;
	      }
	
	      instance.visible = _inView;
	      if (instance.callback) {
	        instance.callback(_inView);
	      }
	    }
	  });
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	/**
	 * Monitors scroll, and triggers the children function with updated props
	 *
	 <Observer>
	 {inView => (
	   <h1>{`${inView}`}</h1>
	 )}
	 </Observer>
	 */
	var Observer = function (_React$Component) {
	  inherits(Observer, _React$Component);
	
	  function Observer() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Observer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      inView: false
	    }, _this.node = null, _this.handleNode = function (node) {
	      if (_this.node) unobserve(_this.node);
	      _this.node = node;
	      _this.observeNode();
	    }, _this.handleChange = function (inView) {
	      _this.setState({ inView: inView });
	      if (_this.props.onChange) {
	        _this.props.onChange(inView);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Observer.prototype.componentDidMount = function componentDidMount() {
	    if (typeof this.props.render === 'function') {
	      invariant(this.node, 'react-intersection-observer: No DOM node found. Make sure you forward "ref" to the root DOM element you want to observe, when using render prop.');
	    }
	  };
	
	  Observer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If a IntersectionObserver option changed, reinit the observer
	    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold) {
	      unobserve(this.node);
	      this.observeNode();
	    }
	
	    if (prevState.inView !== this.state.inView) {
	      if (this.state.inView && this.props.triggerOnce) {
	        unobserve(this.node);
	        this.node = null;
	      }
	    }
	  };
	
	  Observer.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.node) {
	      unobserve(this.node);
	      this.node = null;
	    }
	  };
	
	  Observer.prototype.observeNode = function observeNode() {
	    if (!this.node) return;
	    var _props = this.props,
	        threshold = _props.threshold,
	        root = _props.root,
	        rootMargin = _props.rootMargin,
	        rootId = _props.rootId;
	
	    observe(this.node, this.handleChange, {
	      threshold: threshold,
	      root: root,
	      rootMargin: rootMargin
	    }, rootId);
	  };
	
	  Observer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        render = _props2.render,
	        tag = _props2.tag,
	        triggerOnce = _props2.triggerOnce,
	        threshold = _props2.threshold,
	        root = _props2.root,
	        rootId = _props2.rootId,
	        rootMargin = _props2.rootMargin,
	        props = objectWithoutProperties(_props2, ['children', 'render', 'tag', 'triggerOnce', 'threshold', 'root', 'rootId', 'rootMargin']);
	    var inView = this.state.inView;
	
	
	    if (typeof render === 'function') {
	      return render({ inView: inView, ref: this.handleNode });
	    }
	
	    return React.createElement(tag, _extends({}, props, {
	      ref: this.handleNode
	    }),
	    // If children is a function, render it with the current inView status.
	    // Otherwise always render children. Assume onChange is being used outside, to control the the state of children.
	    typeof children === 'function' ? children(inView) : children);
	  };
	
	  return Observer;
	}(React.Component);
	
	Observer.defaultProps = {
	  tag: 'div',
	  threshold: 0,
	  triggerOnce: false
	};
	
	module.exports = Observer;


/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function DefaultWrapper(_ref) {
	    var childProps = _ref.childProps,
	        children = _ref.children,
	        isFailed = _ref.isFailed,
	        isLoaded = _ref.isLoaded,
	        props = _objectWithoutProperties(_ref, ['childProps', 'children', 'isFailed', 'isLoaded']);
	
	    var className = 'react-lazy-wrapper' + (!isLoaded && !isFailed ? ' react-lazy-wrapper--' + (childProps ? 'loading' : 'placeholder') : '') + (isFailed ? ' react-lazy-wrapper--failed' : '') + (isLoaded ? ' react-lazy-wrapper--loaded' : '') + (props.className ? ' ' + props.className : '');
	
	    return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: className }),
	        children
	    );
	}
	
	exports.default = DefaultWrapper;

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Observer = __webpack_require__(162);
	
	var _Observer2 = _interopRequireDefault(_Observer);
	
	var _wrap = __webpack_require__(293);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Lazy = function (_React$PureComponent) {
	    _inherits(Lazy, _React$PureComponent);
	
	    function Lazy(props) {
	        _classCallCheck(this, Lazy);
	
	        var _this = _possibleConstructorReturn(this, (Lazy.__proto__ || Object.getPrototypeOf(Lazy)).call(this, props));
	
	        _this.state = { show: false };
	
	        _this.onViewport = _this.onViewport.bind(_this);
	        return _this;
	    }
	
	    _createClass(Lazy, [{
	        key: 'onViewport',
	        value: function onViewport(event, unobserve) {
	            var _props = this.props,
	                onLoad = _props.onLoad,
	                onViewport = _props.onViewport,
	                visible = _props.visible;
	
	
	            if (!visible) {
	                return;
	            }
	
	            if (!event.isIntersecting || event.defaultPrevented) {
	                return;
	            }
	
	            unobserve();
	
	            if (onViewport) {
	                onViewport(event);
	            }
	
	            this.setState({ show: true }, onLoad);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                children = _props2.children,
	                clientOnly = _props2.clientOnly,
	                component = _props2.component,
	                cushion = _props2.cushion,
	                ltIE9 = _props2.ltIE9,
	                visible = _props2.visible,
	                onLoad = _props2.onLoad,
	                onViewport = _props2.onViewport,
	                threshold = _props2.threshold,
	                viewport = _props2.viewport,
	                props = _objectWithoutProperties(_props2, ['children', 'clientOnly', 'component', 'cushion', 'ltIE9', 'visible', 'onLoad', 'onViewport', 'threshold', 'viewport']);
	
	            if (clientOnly || visible && this.state.show) {
	                return _react2.default.createElement(
	                    _Observer2.default,
	                    { cushion: cushion, onChange: this.onViewport, threshold: threshold, viewport: viewport },
	                    _react2.default.createElement(component, props, visible && this.state.show ? children : null)
	                );
	            }
	
	            // wrap all contents inside noscript
	            return _react2.default.createElement(
	                _Observer2.default,
	                { cushion: cushion, onChange: this.onViewport },
	                _react2.default.createElement(component, (0, _wrap.propsWithNoScriptRender)(children, ltIE9, props))
	            );
	        }
	    }]);
	
	    return Lazy;
	}(_react2.default.PureComponent);
	
	exports.default = Lazy;
	
	
	Lazy.defaultProps = {
	    clientOnly: false,
	    component: 'div',
	    ltIE9: false,
	    visible: true
	};

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LazyChild = function (_React$PureComponent) {
	    _inherits(LazyChild, _React$PureComponent);
	
	    function LazyChild(props) {
	        _classCallCheck(this, LazyChild);
	
	        var _this = _possibleConstructorReturn(this, (LazyChild.__proto__ || Object.getPrototypeOf(LazyChild)).call(this, props));
	
	        var _ref = props.children && (props.children.props || props.children._store && props.children._store.props) || {},
	            onError = _ref.onError,
	            onLoad = _ref.onLoad,
	            childProps = _objectWithoutProperties(_ref, ['onError', 'onLoad']);
	
	        _this.childOnError = onError;
	        _this.childOnLoad = onLoad;
	        _this.childProps = childProps;
	
	        _this.state = { isFailed: false, isLoaded: false };
	
	        _this.onError = _this.onError.bind(_this);
	        _this.onLoad = _this.onLoad.bind(_this);
	        return _this;
	    }
	
	    _createClass(LazyChild, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.children === this.props.children) {
	                return;
	            }
	
	            var _ref2 = this.props.children && (this.props.children.props || this.props.children._store && this.props.children._store.props) || {},
	                onError = _ref2.onError,
	                onLoad = _ref2.onLoad,
	                childProps = _objectWithoutProperties(_ref2, ['onError', 'onLoad']);
	
	            this.childOnError = onError;
	            this.childOnLoad = onLoad;
	            this.childProps = childProps;
	        }
	    }, {
	        key: 'onError',
	        value: function onError(event) {
	            this.setState({ isFailed: true }, this.props.callback);
	
	            if (this.childOnError) {
	                this.childOnError(event);
	            }
	        }
	    }, {
	        key: 'onLoad',
	        value: function onLoad(event) {
	            this.setState({ isLoaded: true }, this.props.callback);
	
	            if (this.childOnLoad) {
	                this.childOnLoad(event);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                callback = _props.callback,
	                children = _props.children,
	                wrapper = _props.wrapper,
	                props = _objectWithoutProperties(_props, ['callback', 'children', 'wrapper']);
	
	            var child = _react2.default.Children.only(children);
	
	            return _react2.default.createElement(wrapper, _extends({}, props, this.state, { childProps: this.childProps }), !this.state.isFailed && !this.state.isLoaded ? _react2.default.cloneElement(child, { onError: this.onError, onLoad: this.onLoad }) : child);
	        }
	    }]);
	
	    return LazyChild;
	}(_react2.default.PureComponent);
	
	exports.default = LazyChild;

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _wrap = __webpack_require__(293);
	
	var _DefaultWrapper = __webpack_require__(411);
	
	var _DefaultWrapper2 = _interopRequireDefault(_DefaultWrapper);
	
	var _Observer = __webpack_require__(162);
	
	var _Observer2 = _interopRequireDefault(_Observer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LazyGroup = function (_React$PureComponent) {
	    _inherits(LazyGroup, _React$PureComponent);
	
	    function LazyGroup(props) {
	        _classCallCheck(this, LazyGroup);
	
	        var _this = _possibleConstructorReturn(this, (LazyGroup.__proto__ || Object.getPrototypeOf(LazyGroup)).call(this, props));
	
	        _this.loadedImgTags = 0;
	        _this.state = { imgTagCount: null, loadedAt: null, viewportAt: null };
	
	        _this.onImgLoaded = _this.onImgLoaded.bind(_this);
	        _this.onViewport = _this.onViewport.bind(_this);
	        return _this;
	    }
	
	    _createClass(LazyGroup, [{
	        key: 'onImgLoaded',
	        value: function onImgLoaded() {
	            this.loadedImgTags++;
	
	            if (this.loadedImgTags === this.state.imgTagCount) {
	                this.loadedImgTags = 0;
	                this.setState({ imgTagCount: null, loadedAt: Date.now() }, this.props.onLoad);
	            }
	        }
	    }, {
	        key: 'onViewport',
	        value: function onViewport(event, unobserve) {
	            var _props = this.props,
	                children = _props.children,
	                childrenToWrap = _props.childrenToWrap,
	                onLoad = _props.onLoad,
	                onViewport = _props.onViewport,
	                visible = _props.visible;
	
	
	            if (!visible) {
	                return false;
	            }
	
	            if (!event.isIntersecting || event.defaultPrevented) {
	                return;
	            }
	
	            unobserve();
	
	            var imgTagCount = (0, _wrap.countTypesTags)(childrenToWrap, children) || null;
	            this.loadedImgTags = 0;
	            if (onViewport) {
	                onViewport(event);
	            }
	            var viewportAt = Date.now();
	            this.setState({ imgTagCount: imgTagCount, loadedAt: !imgTagCount ? viewportAt : null, viewportAt: viewportAt }, !imgTagCount ? onLoad : null);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                children = _props2.children,
	                childrenToWrap = _props2.childrenToWrap,
	                childWrapper = _props2.childWrapper,
	                clientOnly = _props2.clientOnly,
	                component = _props2.component,
	                cushion = _props2.cushion,
	                ltIE9 = _props2.ltIE9,
	                onLoad = _props2.onLoad,
	                onViewport = _props2.onViewport,
	                threshold = _props2.threshold,
	                viewport = _props2.viewport,
	                visible = _props2.visible,
	                props = _objectWithoutProperties(_props2, ['children', 'childrenToWrap', 'childWrapper', 'clientOnly', 'component', 'cushion', 'ltIE9', 'onLoad', 'onViewport', 'threshold', 'viewport', 'visible']);
	
	            return _react2.default.createElement(
	                _Observer2.default,
	                { cushion: cushion, onChange: this.onViewport, threshold: threshold, viewport: viewport },
	                _react2.default.createElement(component, props,
	                // swap render once element is visible in viewport
	                clientOnly || visible && this.state.viewportAt
	                // replace elements with LazyChild
	                ? (0, _wrap.wrapTypesToLazyChild)(childrenToWrap, children, childWrapper, this.onImgLoaded)
	                // wrap given element types to noscript and the given wrapper component
	                : (0, _wrap.wrapTypesToNoScript)(childrenToWrap, children, ltIE9, childWrapper))
	            );
	        }
	    }]);
	
	    return LazyGroup;
	}(_react2.default.PureComponent);
	
	exports.default = LazyGroup;
	
	
	LazyGroup.defaultProps = {
	    childrenToWrap: ['iframe', 'img'],
	    childWrapper: _DefaultWrapper2.default,
	    clientOnly: false,
	    component: 'div',
	    ltIE9: false,
	    visible: true
	};

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(69);
	
	var _intersectionObserver = __webpack_require__(413);
	
	var _utils = __webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // based on @researchgate/react-intersection-observer
	
	/* eslint-disable react/no-find-dom-node */
	
	
	var observerOptions = ['root', 'rootMargin', 'threshold'];
	var optToPropMapper = { root: 'viewport', rootMargin: 'cushion' };
	var observerProps = ['viewport', 'cushion', 'disabled'].concat(observerOptions);
	var objectProto = Object.prototype;
	
	var Observer = function (_React$Component) {
	    _inherits(Observer, _React$Component);
	
	    function Observer(props) {
	        _classCallCheck(this, Observer);
	
	        var _this = _possibleConstructorReturn(this, (Observer.__proto__ || Object.getPrototypeOf(Observer)).call(this, props));
	
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleNode = _this.handleNode.bind(_this);
	        _this.observe = _this.observe.bind(_this);
	        _this.unobserve = _this.unobserve.bind(_this);
	        return _this;
	    }
	
	    _createClass(Observer, [{
	        key: 'handleChange',
	        value: function handleChange(event) {
	            this.props.onChange(event, this.unobserve);
	        }
	    }, {
	        key: 'handleNode',
	        value: function handleNode(target) {
	            if (typeof this.props.children.ref === 'function') {
	                this.props.children.ref(target);
	            }
	
	            if (this.renderedTarget && target && this.renderedTarget !== target) {
	                this.unobserve();
	                this.targetChanged = true;
	            } else {
	                this.targetChanged = false;
	            }
	
	            this.target = target;
	        }
	    }, {
	        key: 'observe',
	        value: function observe() {
	            var isDOMTypeElement = _react2.default.isValidElement(this.target) && typeof this.target.type === 'string';
	
	            if (!isDOMTypeElement) {
	                this.target = (0, _reactDom.findDOMNode)(this.target);
	            }
	
	            this.observer = (0, _intersectionObserver.createObserver)(this.options);
	            (0, _intersectionObserver.observeElement)(this);
	        }
	    }, {
	        key: 'unobserve',
	        value: function unobserve() {
	            if (this.target != null) {
	                (0, _intersectionObserver.unobserveElement)(this);
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!this.props.disabled) {
	                this.observe();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var _this2 = this;
	
	            if (this.targetChanged || observerProps.some(function (option) {
	                return (0, _utils.shallowCompare)(_this2.props[option], prevProps[option]);
	            })) {
	                this.unobserve();
	
	                if (!this.props.disabled) {
	                    this.observe();
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.unobserve();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.renderedTarget = this.target;
	
	            return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), { ref: this.handleNode });
	        }
	    }, {
	        key: 'options',
	        get: function get() {
	            var props = this.props;
	
	            return observerOptions.reduce(function (options, option) {
	                var prop = optToPropMapper[option] || option;
	                // allow usage of root and rootMargin props, but prefer viewport and cushion
	                var key = objectProto.hasOwnProperty.call(props, prop) && prop || prop !== option && objectProto.hasOwnProperty.call(props, option) && option || '';
	
	                if (key) {
	                    var useQuery = option === 'root' && objectProto.toString.call(props[key]) === '[object String]';
	
	                    options[option] = useQuery ? document.querySelector(props[key]) : props[key];
	                }
	
	                return options;
	            }, {});
	        }
	    }]);
	
	    return Observer;
	}(_react2.default.Component);
	
	exports.default = Observer;

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Observer = exports.Lazy = exports.LazyGroup = undefined;
	
	var _LazyGroup2 = __webpack_require__(290);
	
	var _LazyGroup3 = _interopRequireDefault(_LazyGroup2);
	
	var _Lazy2 = __webpack_require__(289);
	
	var _Lazy3 = _interopRequireDefault(_Lazy2);
	
	var _Observer2 = __webpack_require__(162);
	
	var _Observer3 = _interopRequireDefault(_Observer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.LazyGroup = _LazyGroup3.default;
	exports.Lazy = _Lazy3.default;
	exports.Observer = _Observer3.default;

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.storage = undefined;
	exports.findObserverElement = findObserverElement;
	exports.getPooled = getPooled;
	exports.callback = callback;
	exports.createObserver = createObserver;
	exports.observeElement = observeElement;
	exports.unobserveElement = unobserveElement;
	
	var _utils = __webpack_require__(292);
	
	var storage = exports.storage = new Map(); // based on @researchgate/react-intersection-observer
	function findObserverElement(observer, entry) {
	    var observerElements = storage.get(observer);
	
	    if (observerElements) {
	        var elements = observerElements.values();
	
	        for (var element = elements.next(); !element.done; element = elements.next()) {
	            if (element.value.target === entry.target) {
	                return element.value;
	            }
	        }
	    }
	
	    return null;
	}
	
	function getPooled() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var root = options.root || null;
	    var rootMargin = (0, _utils.parseRootMargin)(options.rootMargin);
	    var threshold = Array.isArray(options.threshold) ? options.threshold : [options.threshold != null ? options.threshold : 0];
	
	    var observers = storage.keys();
	
	    for (var observer = observers.next(); !observer.done; observer = observers.next()) {
	        var unmatched = root !== observer.value.root || rootMargin !== observer.value.rootMargin || (0, _utils.shallowCompare)(threshold, observer.value.threshold);
	
	        if (!unmatched) {
	            return observer.value;
	        }
	    }
	
	    return null;
	}
	
	/**
	 * The Intersection Observer API callback that is called whenever one element,
	 * called the target, intersects either the device viewport or a specified element.
	 * Also will get called whenever the visibility of the target element changes and
	 * crosses desired amounts of intersection with the viewport element.
	 * @param {array} changes
	 * @param {IntersectionObserver} observer
	 */
	function callback(changes, observer) {
	    for (var i = 0; i < changes.length; i++) {
	        var instance = findObserverElement(observer, changes[i]);
	
	        if (instance) {
	            instance.handleChange(changes[i]);
	        }
	    }
	}
	
	function createObserver(options) {
	    return getPooled(options) || new IntersectionObserver(callback, options);
	}
	
	function observeElement(element) {
	    if (!storage.has(element.observer)) {
	        storage.set(element.observer, new Set());
	    }
	
	    storage.get(element.observer).add(element);
	    element.observer.observe(element.target);
	}
	
	function unobserveElement(element) {
	    if (storage.has(element.observer)) {
	        var targets = storage.get(element.observer);
	
	        if (targets.delete(element)) {
	            if (targets.size > 0) {
	                element.observer.unobserve(element.target);
	            } else {
	                element.observer.disconnect();
	                storage.delete(element.observer);
	            }
	        }
	    }
	}

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.parseRootMargin = parseRootMargin;
	exports.shallowCompare = shallowCompare;
	// from @researchgate/react-intersection-observer
	var marginRE = /^-?\d*\.?\d+(px|%)$/;
	
	function parseRootMargin(rootMargin) {
	    var marginString = rootMargin ? rootMargin.trim() : '0px';
	
	    var _marginString$split$m = marginString.split(/\s+/).map(function (margin) {
	        if (!marginRE.test(margin)) {
	            throw new Error('rootMargin must be a string literal containing pixels and/or percent values');
	        }
	
	        return margin;
	    }),
	        _marginString$split$m2 = _slicedToArray(_marginString$split$m, 4),
	        _marginString$split$m3 = _marginString$split$m2[0],
	        m0 = _marginString$split$m3 === undefined ? '0px' : _marginString$split$m3,
	        _marginString$split$m4 = _marginString$split$m2[1],
	        m1 = _marginString$split$m4 === undefined ? m0 : _marginString$split$m4,
	        _marginString$split$m5 = _marginString$split$m2[2],
	        m2 = _marginString$split$m5 === undefined ? m0 : _marginString$split$m5,
	        _marginString$split$m6 = _marginString$split$m2[3],
	        m3 = _marginString$split$m6 === undefined ? m1 : _marginString$split$m6;
	
	    return m0 + ' ' + m1 + ' ' + m2 + ' ' + m3;
	}
	
	function shallowCompare(next, prev) {
	    if (Array.isArray(next) && Array.isArray(prev)) {
	        if (next.length === prev.length) {
	            return next.some(function (_, index) {
	                return shallowCompare(next[index], prev[index]);
	            });
	        }
	    }
	
	    return next !== prev;
	}

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.countTypesTags = countTypesTags;
	exports.propsWithNoScriptRender = propsWithNoScriptRender;
	exports.wrapTypesToLazyChild = wrapTypesToLazyChild;
	exports.wrapTypesToNoScript = wrapTypesToNoScript;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _server = __webpack_require__(487);
	
	var _Lazy = __webpack_require__(289);
	
	var _Lazy2 = _interopRequireDefault(_Lazy);
	
	var _LazyChild = __webpack_require__(412);
	
	var _LazyChild2 = _interopRequireDefault(_LazyChild);
	
	var _LazyGroup = __webpack_require__(290);
	
	var _LazyGroup2 = _interopRequireDefault(_LazyGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function countTypesTags(types, children) {
	    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    if (!children) {
	        return count;
	    }
	
	    _react2.default.Children.forEach(children, function (child) {
	        if (!child || child.type === _Lazy2.default || child.type === _LazyGroup2.default || child.type === _LazyChild2.default) {
	            return;
	        } else if (types.includes(child.type)) {
	            count++;
	        } else {
	            var props = child.props || child._store && child._store.props || {};
	            count += countTypesTags(types, props.children);
	        }
	    });
	
	    return count;
	}
	
	function propsWithNoScriptRender(children, ltIE9) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var noscript = (0, _server.renderToStaticMarkup)(_react2.default.createElement('noscript', null, children));
	
	    var __html = !ltIE9 ? noscript : noscript.replace('<noscript>', '<!--[if IE 9]><!--><noscript><!--<![endif]-->').replace('</noscript>', '<!--[if IE 9]><!--></noscript><!--<![endif]-->');
	
	    props.dangerouslySetInnerHTML = { __html: __html };
	
	    return props;
	}
	
	function wrapTypesToLazyChild(types, children, wrapper, callback) {
	    if (!children) {
	        return children;
	    }
	
	    return _react2.default.Children.map(children, function (child) {
	        if (!child || child.type === _Lazy2.default || child.type === _LazyGroup2.default || child.type === _LazyChild2.default) {
	            return child;
	        } else if (types.includes(child.type)) {
	            return _react2.default.createElement(
	                _LazyChild2.default,
	                { callback: callback, wrapper: wrapper },
	                child
	            );
	        } else {
	            var props = child.props || child._store && child._store.props || {};
	            var _children = wrapTypesToLazyChild(types, props.children, wrapper, callback);
	
	            if (_children !== props.children) {
	                return _react2.default.cloneElement(child, null, _children);
	            } else {
	                return child;
	            }
	        }
	    });
	}
	
	function wrapTypesToNoScript(types, children, ltIE9, wrapper) {
	    if (!children) {
	        return children;
	    }
	
	    return _react2.default.Children.map(children, function (child) {
	        if (!child || child.type === _Lazy2.default || child.type === _LazyGroup2.default || child.type === _LazyChild2.default) {
	            return child;
	        } else if (types.includes(child.type)) {
	            return _react2.default.createElement(wrapper, propsWithNoScriptRender(child, ltIE9));
	        } else {
	            var props = child.props || child._store && child._store.props || {};
	            var _children2 = wrapTypesToNoScript(types, props.children, ltIE9, wrapper);
	
	            if (_children2 !== props.children) {
	                return _react2.default.cloneElement(child, null, _children2);
	            } else {
	                return child;
	            }
	        }
	    });
	}

/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

	/**
	  stickybits - Stickybits is a lightweight alternative to `position: sticky` polyfills
	  @version v3.3.2
	  @link https://github.com/dollarshaveclub/stickybits#readme
	  @author Jeff Wainwright <yowainwright@gmail.com> (https://jeffry.in)
	  @license MIT
	**/
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.stickybits = factory());
	}(this, (function () { 'use strict';
	
	  /*
	    STICKYBITS 💉
	    --------
	    > a lightweight alternative to `position: sticky` polyfills 🍬
	    --------
	    - each method is documented above it our view the readme
	    - Stickybits does not manage polymorphic functionality (position like properties)
	    * polymorphic functionality: (in the context of describing Stickybits)
	      means making things like `position: sticky` be loosely supported with position fixed.
	      It also means that features like `useStickyClasses` takes on styles like `position: fixed`.
	    --------
	    defaults 🔌
	    --------
	    - version = `package.json` version
	    - userAgent = viewer browser agent
	    - target = DOM element selector
	    - noStyles = boolean
	    - offset = number
	    - parentClass = 'string'
	    - scrollEl = window || DOM element selector
	    - stickyClass = 'string'
	    - stuckClass = 'string'
	    - useStickyClasses = boolean
	    - verticalPosition = 'string'
	    --------
	    props🔌
	    --------
	    - p = props {object}
	    --------
	    instance note
	    --------
	    - stickybits parent methods return this
	    - stickybits instance methods return an instance item
	    --------
	    nomenclature
	    --------
	    - target => el => e
	    - props => o || p
	    - instance => item => it
	    --------
	    methods
	    --------
	    - .definePosition = defines sticky or fixed
	    - .addInstance = an array of objects for each Stickybits Target
	    - .getClosestParent = gets the parent for non-window scroll
	    - .getOffsetTop = gets the element offsetTop from the top level of the DOM
	    - .computeScrollOffsets = computes scroll position
	    - .toggleClasses = older browser toggler
	    - .manageState = manages sticky state
	    - .removeClass = older browser support class remover
	    - .removeInstance = removes an instance
	    - .cleanup = removes all Stickybits instances and cleans up dom from stickybits
	  */
	  var Stickybits =
	  /*#__PURE__*/
	  function () {
	    function Stickybits(target, obj) {
	      var o = typeof obj !== 'undefined' ? obj : {};
	      this.version = '3.3.2';
	      this.userAgent = window.navigator.userAgent || 'no `userAgent` provided by the browser';
	      this.props = {
	        customStickyChangeNumber: o.customStickyChangeNumber || null,
	        noStyles: o.noStyles || false,
	        stickyBitStickyOffset: o.stickyBitStickyOffset || 0,
	        parentClass: o.parentClass || 'js-stickybit-parent',
	        scrollEl: document.querySelector(o.scrollEl) || window,
	        stickyClass: o.stickyClass || 'js-is-sticky',
	        stuckClass: o.stuckClass || 'js-is-stuck',
	        stickyChangeClass: o.stickyChangeClass || 'js-is-sticky--change',
	        useStickyClasses: o.useStickyClasses || false,
	        verticalPosition: o.verticalPosition || 'top'
	      };
	      var p = this.props;
	      /*
	        define positionVal
	        ----
	        -  uses a computed (`.definePosition()`)
	        -  defined the position
	      */
	
	      p.positionVal = this.definePosition() || 'fixed';
	      var vp = p.verticalPosition;
	      var ns = p.noStyles;
	      var pv = p.positionVal;
	      this.els = typeof target === 'string' ? document.querySelectorAll(target) : target;
	      if (!('length' in this.els)) this.els = [this.els];
	      this.instances = [];
	
	      for (var i = 0; i < this.els.length; i += 1) {
	        var el = this.els[i];
	        var styles = el.style; // set vertical position
	
	        styles[vp] = vp === 'top' && !ns ? p.stickyBitStickyOffset + "px" : '';
	        styles.position = pv !== 'fixed' ? pv : '';
	
	        if (pv === 'fixed' || p.useStickyClasses) {
	          var instance = this.addInstance(el, p); // instances are an array of objects
	
	          this.instances.push(instance);
	        }
	      }
	
	      return this;
	    }
	    /*
	      setStickyPosition ✔️
	      --------
	      —  most basic thing stickybits does
	      => checks to see if position sticky is supported
	      => defined the position to be used
	      => stickybits works accordingly
	    */
	
	
	    var _proto = Stickybits.prototype;
	
	    _proto.definePosition = function definePosition() {
	      var prefix = ['', '-o-', '-webkit-', '-moz-', '-ms-'];
	      var test = document.head.style;
	
	      for (var i = 0; i < prefix.length; i += 1) {
	        test.position = prefix[i] + "sticky";
	      }
	
	      var stickyProp = test.position ? test.position : 'fixed';
	      test.position = '';
	      return stickyProp;
	    };
	    /*
	      addInstance ✔️
	      --------
	      — manages instances of items
	      - takes in an el and props
	      - returns an item object
	      ---
	      - target = el
	      - o = {object} = props
	        - scrollEl = 'string'
	        - verticalPosition = number
	        - off = boolean
	        - parentClass = 'string'
	        - stickyClass = 'string'
	        - stuckClass = 'string'
	      ---
	      - defined later
	        - parent = dom element
	        - state = 'string'
	        - offset = number
	        - stickyStart = number
	        - stickyStop = number
	      - returns an instance object
	    */
	
	
	    _proto.addInstance = function addInstance(el, props) {
	      var _this = this;
	
	      var item = {
	        el: el,
	        parent: el.parentNode,
	        props: props
	      };
	      this.isWin = this.props.scrollEl === window;
	      var se = this.isWin ? window : this.getClosestParent(item.el, item.props.scrollEl);
	      this.computeScrollOffsets(item);
	      item.parent.className += " " + props.parentClass;
	      item.state = 'default';
	
	      item.stateContainer = function () {
	        return _this.manageState(item);
	      };
	
	      se.addEventListener('scroll', item.stateContainer);
	      return item;
	    };
	    /*
	      --------
	      getParent 👨‍
	      --------
	      - a helper function that gets the target element's parent selected el
	      - only used for non `window` scroll elements
	      - supports older browsers
	    */
	
	
	    _proto.getClosestParent = function getClosestParent(el, match) {
	      // p = parent element
	      var p = match;
	      var e = el;
	      if (e.parentElement === p) return p; // traverse up the dom tree until we get to the parent
	
	      while (e.parentElement !== p) {
	        e = e.parentElement;
	      } // return parent element
	
	
	      return p;
	    };
	    /*
	      --------
	      getOffsetTop
	      --------
	      - a helper function that gets the offsetTop of the element
	      - from the top level of the DOM
	    */
	
	
	    _proto.getOffsetTop = function getOffsetTop(el) {
	      var offsetTop = 0;
	
	      do {
	        offsetTop = el.offsetTop + offsetTop;
	      } while (el = el.offsetParent);
	
	      return offsetTop;
	    };
	    /*
	      computeScrollOffsets 📊
	      ---
	      computeScrollOffsets for Stickybits
	      - defines
	        - offset
	        - start
	        - stop
	    */
	
	
	    _proto.computeScrollOffsets = function computeScrollOffsets(item) {
	      var it = item;
	      var p = it.props;
	      var el = it.el;
	      var parent = it.parent;
	      var isCustom = !this.isWin && p.positionVal === 'fixed';
	      var isBottom = p.verticalPosition !== 'bottom';
	      var scrollElOffset = isCustom ? this.getOffsetTop(p.scrollEl) : 0;
	      var stickyStart = isCustom ? this.getOffsetTop(parent) - scrollElOffset : this.getOffsetTop(parent);
	      var stickyChangeOffset = p.customStickyChangeNumber !== null ? p.customStickyChangeNumber : el.offsetHeight;
	      it.offset = scrollElOffset + p.stickyBitStickyOffset;
	      it.stickyStart = isBottom ? stickyStart - it.offset : 0;
	      it.stickyChange = it.stickyStart + stickyChangeOffset;
	      it.stickyStop = isBottom ? stickyStart + parent.offsetHeight - (it.el.offsetHeight + it.offset) : stickyStart + parent.offsetHeight;
	      return it;
	    };
	    /*
	      toggleClasses ⚖️
	      ---
	      toggles classes (for older browser support)
	      r = removed class
	      a = added class
	    */
	
	
	    _proto.toggleClasses = function toggleClasses(el, r, a) {
	      var e = el;
	      var cArray = e.className.split(' ');
	      if (a && cArray.indexOf(a) === -1) cArray.push(a);
	      var rItem = cArray.indexOf(r);
	      if (rItem !== -1) cArray.splice(rItem, 1);
	      e.className = cArray.join(' ');
	    };
	    /*
	      manageState 📝
	      ---
	      - defines the state
	        - normal
	        - sticky
	        - stuck
	    */
	
	
	    _proto.manageState = function manageState(item) {
	      // cache object
	      var it = item;
	      var e = it.el;
	      var p = it.props;
	      var state = it.state;
	      var start = it.stickyStart;
	      var change = it.stickyChange;
	      var stop = it.stickyStop;
	      var stl = e.style; // cache props
	
	      var ns = p.noStyles;
	      var pv = p.positionVal;
	      var se = p.scrollEl;
	      var sticky = p.stickyClass;
	      var stickyChange = p.stickyChangeClass;
	      var stuck = p.stuckClass;
	      var vp = p.verticalPosition;
	      /*
	        requestAnimationFrame
	        ---
	        - use rAF
	        - or stub rAF
	      */
	
	      var rAFStub = function rAFDummy(f) {
	        f();
	      };
	
	      var rAF = !this.isWin ? rAFStub : window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || rAFStub;
	      /*
	        define scroll vars
	        ---
	        - scroll
	        - notSticky
	        - isSticky
	        - isStuck
	      */
	
	      var tC = this.toggleClasses;
	      var scroll = this.isWin ? window.scrollY || window.pageYOffset : se.scrollTop;
	      var notSticky = scroll > start && scroll < stop && (state === 'default' || state === 'stuck');
	      var isSticky = scroll <= start && state === 'sticky';
	      var isStuck = scroll >= stop && state === 'sticky';
	      /*
	        Unnamed arrow functions within this block
	        ---
	        - help wanted or discussion
	        - view test.stickybits.js
	          - `stickybits .manageState  `position: fixed` interface` for more awareness 👀
	      */
	
	      if (notSticky) {
	        it.state = 'sticky';
	        rAF(function () {
	          tC(e, stuck, sticky);
	          stl.position = pv;
	          if (ns) return;
	          stl.bottom = '';
	          stl[vp] = p.stickyBitStickyOffset + "px";
	        });
	      } else if (isSticky) {
	        it.state = 'default';
	        rAF(function () {
	          tC(e, sticky);
	          if (pv === 'fixed') stl.position = '';
	        });
	      } else if (isStuck) {
	        it.state = 'stuck';
	        rAF(function () {
	          tC(e, sticky, stuck);
	          if (pv !== 'fixed' || ns) return;
	          stl.top = '';
	          stl.bottom = '0';
	          stl.position = 'absolute';
	        });
	      }
	
	      var isStickyChange = scroll >= change && scroll <= stop;
	      var isNotStickyChange = scroll < change || scroll > stop;
	      var stub = 'stub'; // a stub css class to remove
	
	      if (isNotStickyChange) {
	        rAF(function () {
	          tC(e, stickyChange);
	        });
	      } else if (isStickyChange) {
	        rAF(function () {
	          tC(e, stub, stickyChange);
	        });
	      }
	
	      return it;
	    };
	
	    _proto.update = function update() {
	      for (var i = 0; i < this.instances.length; i += 1) {
	        var instance = this.instances[i];
	        this.computeScrollOffsets(instance);
	      }
	
	      return this;
	    };
	    /*
	      removes an instance 👋
	      --------
	      - cleanup instance
	    */
	
	
	    _proto.removeInstance = function removeInstance(instance) {
	      var e = instance.el;
	      var p = instance.props;
	      var tC = this.toggleClasses;
	      e.style.position = '';
	      e.style[p.verticalPosition] = '';
	      tC(e, p.stickyClass);
	      tC(e, p.stuckClass);
	      tC(e.parentNode, p.parentClass);
	    };
	    /*
	      cleanup 🛁
	      --------
	      - cleans up each instance
	      - clears instance
	    */
	
	
	    _proto.cleanup = function cleanup() {
	      for (var i = 0; i < this.instances.length; i += 1) {
	        var instance = this.instances[i];
	        instance.props.scrollEl.removeEventListener('scroll', instance.stateContainer);
	        this.removeInstance(instance);
	      }
	
	      this.manageState = false;
	      this.instances = [];
	    };
	
	    return Stickybits;
	  }();
	  /*
	    export
	    --------
	    exports StickBits to be used 🏁
	  */
	
	
	  function stickybits(target, o) {
	    return new Stickybits(target, o);
	  }
	
	  return stickybits;
	
	})));


/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NextSectionArrowModule = __webpack_require__(397);
	
	var _NextSectionArrowModule2 = _interopRequireDefault(_NextSectionArrowModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NextSectionArrow = function NextSectionArrow(_ref) {
	  var isLastSection = _ref.isLastSection,
	      goToNextSection = _ref.goToNextSection,
	      isPlaylistOpen = _ref.isPlaylistOpen,
	      arrowStyle = _ref.arrowStyle,
	      isLastChapter = _ref.isLastChapter,
	      isTimeline = _ref.isTimeline;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _NextSectionArrowModule2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _NextSectionArrowModule2.default.reveal },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'fadeOut js-nextSectionArrow ' + _NextSectionArrowModule2.default.downArrow + ' ' + (arrowStyle === 'white' ? _NextSectionArrowModule2.default.whiteArrow : _NextSectionArrowModule2.default.fillArrow + ' sectionFillArrow') + ' ' + (isLastSection ? _NextSectionArrowModule2.default.nextChapter : ''),
	          style: { pointerEvents: isPlaylistOpen ? 'none' : 'auto' },
	          onClick: goToNextSection
	        },
	        isTimeline ? _react2.default.createElement(
	          'span',
	          null,
	          'learn More'
	        ) : _react2.default.createElement(
	          'span',
	          null,
	          isLastChapter ? 'View Timeline' : 'Next Chapter'
	        ),
	        _react2.default.createElement(
	          'svg',
	          {
	            xmlns: 'http://www.w3.org/2000/svg',
	            width: '23',
	            height: '26',
	            viewBox: '0 0 23 26'
	          },
	          _react2.default.createElement(
	            'title',
	            null,
	            'Down Arrow'
	          ),
	          _react2.default.createElement('polygon', { points: '10.701 22.376 10.701 0 12.347 0 12.347 22.35 21.926 12.347 23.023 13.492 11.511 25.512 0 13.492 1.096 12.347' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = NextSectionArrow;
	module.exports = exports['default'];

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-chapter----NextSectionArrow-module---wrapper---3I2iR","reveal":"src-components-chapter----NextSectionArrow-module---reveal---1_cQc","fadeInUpSmall":"src-components-chapter----NextSectionArrow-module---fadeInUpSmall---1gzZh","downArrow":"src-components-chapter----NextSectionArrow-module---downArrow---3mhfw","nextChapter":"src-components-chapter----NextSectionArrow-module---nextChapter---HMZ0o","fillArrow":"src-components-chapter----NextSectionArrow-module---fillArrow---2PJH5","fadeIn":"src-components-chapter----NextSectionArrow-module---fadeIn---1j9iB","fadeInUp":"src-components-chapter----NextSectionArrow-module---fadeInUp---3o52O","fadeInUpCenter":"src-components-chapter----NextSectionArrow-module---fadeInUpCenter---3l6XC","textCoverIn":"src-components-chapter----NextSectionArrow-module---textCoverIn---3N5m2","textCoverOut":"src-components-chapter----NextSectionArrow-module---textCoverOut---_t4vQ"};

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IntroWithButton = __webpack_require__(82);
	
	var _IntroWithButton2 = _interopRequireDefault(_IntroWithButton);
	
	var _TimelineText = __webpack_require__(525);
	
	var _TimelineText2 = _interopRequireDefault(_TimelineText);
	
	var _TimelineVideo = __webpack_require__(526);
	
	var _TimelineVideo2 = _interopRequireDefault(_TimelineVideo);
	
	var _ContentGridModule = __webpack_require__(835);
	
	var _ContentGridModule2 = _interopRequireDefault(_ContentGridModule);
	
	var _SliderWithText = __webpack_require__(519);
	
	var _SliderWithText2 = _interopRequireDefault(_SliderWithText);
	
	var _reactIntersectionObserver = __webpack_require__(180);
	
	var _reactIntersectionObserver2 = _interopRequireDefault(_reactIntersectionObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentGrid = function ContentGrid(_ref) {
	  var eraInView = _ref.eraInView,
	      title = _ref.title,
	      grid_contents = _ref.grid_contents,
	      _ref$isBasicPage = _ref.isBasicPage,
	      isBasicPage = _ref$isBasicPage === undefined ? false : _ref$isBasicPage;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: isBasicPage ? _ContentGridModule2.default.basicGridWrapper : _ContentGridModule2.default.contentGridWrapper
	    },
	    title !== '<strong></strong>' && _react2.default.createElement(
	      _reactIntersectionObserver2.default,
	      { className: _ContentGridModule2.default.chapterInfoWrapper, triggerOnce: true },
	      function (inview) {
	        return _react2.default.createElement(_IntroWithButton2.default, {
	          index: 0,
	          title: title,
	          doSplitText: true,
	          startHidden: true,
	          show: inview
	        });
	      }
	    ),
	    grid_contents && _react2.default.createElement(
	      'div',
	      { className: _ContentGridModule2.default.contentGrid },
	      grid_contents.map(function (content, index) {
	        switch (content.grid_item_type) {
	          case 'slideshow':
	            return _react2.default.createElement(_SliderWithText2.default, _extends({
	              eraInView: eraInView,
	              key: content.title + '-' + index + '-slider-text'
	            }, content));
	          case 'text':
	            return _react2.default.createElement(_TimelineText2.default, _extends({
	              key: content.body + '-' + index + '-text'
	            }, content));
	          case 'video':
	            return _react2.default.createElement(_TimelineVideo2.default, _extends({
	              key: content.video_source + '-' + index + '-video'
	            }, content));
	          default:
	            return _react2.default.createElement(_SliderWithText2.default, _extends({
	              key: content.title + '-' + index + '-slider'
	            }, content));
	        }
	      })
	    )
	  );
	};
	
	exports.default = ContentGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 835:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contentGridWrapper":"src-components-global----ContentGrid-module---contentGridWrapper---2OZj6","basicGridWrapper":"src-components-global----ContentGrid-module---basicGridWrapper---3pxsJ","contentGrid":"src-components-global----ContentGrid-module---contentGrid---1nzSi","chapterInfoWrapper":"src-components-global----ContentGrid-module---chapterInfoWrapper---3phnF","fadeIn":"src-components-global----ContentGrid-module---fadeIn---eaNF7","fadeInUp":"src-components-global----ContentGrid-module---fadeInUp---Xhexk","fadeInUpCenter":"src-components-global----ContentGrid-module---fadeInUpCenter---1-KFb","fadeInUpSmall":"src-components-global----ContentGrid-module---fadeInUpSmall---YYxYQ","textCoverIn":"src-components-global----ContentGrid-module---textCoverIn---23DUH","textCoverOut":"src-components-global----ContentGrid-module---textCoverOut---3BGXE"};

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollIndicator = __webpack_require__(140);
	
	var _ScrollIndicator2 = _interopRequireDefault(_ScrollIndicator);
	
	var _RectButton = __webpack_require__(78);
	
	var _RectButton2 = _interopRequireDefault(_RectButton);
	
	var _IntroWithButtonModule = __webpack_require__(88);
	
	var _IntroWithButtonModule2 = _interopRequireDefault(_IntroWithButtonModule);
	
	var _gsap = __webpack_require__(11);
	
	var _CSSPlugin = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var plugins = [_CSSPlugin.CSSPlugin];
	var SplitText = void 0;
	
	var IntroWithButton = function (_Component) {
	  _inherits(IntroWithButton, _Component);
	
	  function IntroWithButton() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IntroWithButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.splitTextRun = false, _this.setThemeClass = function (color) {
	      switch (color) {
	        case 'blue':
	          return 'chapter-theme--blue';
	        case 'yellow':
	          return 'chapter-theme--yellow';
	        case 'green':
	          return 'chapter-theme--green';
	        default:
	          return 'chapter-theme--red';
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IntroWithButton.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      SplitText = __webpack_require__(144);
	    }
	    if (this.props.startHidden && this.props.show) {
	      _gsap.TweenLite.set(this.wrapper, { opacity: 1 });
	    }
	
	    this.runSplitText();
	
	    var header = this.wrapper.querySelectorAll('.maskDownTitle');
	    var subHeader = this.wrapper.querySelector('p');
	    var button = this.wrapper.querySelector('.js-introButton');
	    var kicker = this.wrapper.querySelector('h5');
	    var rule = this.wrapper.querySelector('.ch-inner-rule');
	    if (this.props.startHidden && !this.props.show) {
	      // console.log('transitioning, so hide slider text');
	      header && _gsap.TweenLite.set(header, { y: '100%' });
	      subHeader && _gsap.TweenLite.set(subHeader, { y: '10%', autoAlpha: 0 });
	      button && _gsap.TweenLite.set(button, { y: '100%' });
	      kicker && _gsap.TweenLite.set(kicker, { y: '100%' });
	      rule && _gsap.TweenLite.set(rule, { scaleX: 0 });
	      this.scrollIndicator && _gsap.TweenLite.set(this.scrollIndicator, { opacity: 0, y: 20 });
	    }
	  };
	
	  IntroWithButton.prototype.runSplitText = function runSplitText() {
	    // console.log(this.props.title, 'try to run splittext');
	    if (!this.props.doSplitText || this.splitTextRun) {
	      // console.log(this.props.title, 'already run, dont');
	      return;
	    }
	    // console.log(this.props.title, 'actually run it');
	    this.splitTextRun = true;
	
	    var splitWords = void 0;
	    var splitTarget = this.wrapper.querySelector('h1');
	    var splitText = new SplitText(splitTarget, {
	      type: 'words',
	      wordsClass: 'maskDownTitle'
	    });
	
	    if (typeof document !== 'undefined') {
	      splitWords = splitTarget.querySelectorAll('.maskDownTitle');
	    }
	    var wrap = function wrap(el, wrapper) {
	      el.parentNode.insertBefore(wrapper, el);
	      wrapper.appendChild(el);
	    };
	
	    splitWords.forEach(function (word) {
	      var element = void 0;
	      if (typeof document !== 'undefined') {
	        element = document.createElement('div');
	      }
	      element.className = _IntroWithButtonModule2.default.maskDownWrapper;
	      wrap(word, element);
	    });
	  };
	
	  IntroWithButton.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    // if text Changes, have to run split text again
	    if (this.props.title !== prevProps.title || this.props.subtitle !== prevProps.subtitle) {
	      // console.log('text change hide text and run split text');
	      this.splitTextRun = false;
	      this.runSplitText();
	      var header = this.wrapper.querySelectorAll('.maskDownTitle');
	      var subHeader = this.wrapper.querySelector('p');
	      var button = this.wrapper.querySelector('.js-introButton');
	      var kicker = this.wrapper.querySelector('h5');
	      var rule = this.wrapper.querySelector('.ch-inner-rule');
	      // if (this.props.textTransitioning ) {
	      // console.log('transitioning, so hide slider text');
	      _gsap.TweenLite.set(header, { y: '100%' });
	      _gsap.TweenLite.set(subHeader, { y: '10%', autoAlpha: 0 });
	      _gsap.TweenLite.set(button, { y: '100%' });
	      _gsap.TweenLite.set(kicker, { y: '100%' });
	      _gsap.TweenLite.set(rule, { scaleX: 0 });
	      // }
	
	      _gsap.TweenLite.set(this.wrapper, { opacity: 1 });
	    }
	  };
	
	  IntroWithButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    // FPO enter and exit animations for this element
	
	    if (this.props.startHidden && !this.props.show && nextProps.show) {
	      // run split text before show
	      this.runSplitText();
	      // show
	      // TweenLite.to(this.wrapper, 0.5, { opacity: 1 });
	
	      // console.log('reveal text on change of show prop, nextProps.show true');
	      var header = this.wrapper.querySelectorAll('.maskDownTitle');
	      var subHeader = this.wrapper.querySelector('p');
	      var button = this.wrapper.querySelector('.js-introButton');
	      var kicker = this.wrapper.querySelector('h5');
	      var rule = this.wrapper.querySelector('.ch-inner-rule');
	
	      _gsap.TweenLite.set(this.wrapper, { opacity: 1 });
	
	      var duration = 0.78;
	      var increment = 0.2;
	      var delay = 0.0;
	
	      var tl = new _gsap.TimelineLite();
	      if (kicker) {
	        tl.to(kicker, duration, {
	          y: '0%',
	          ease: Quad.easeInOut
	        }, delay += increment);
	      }
	
	      rule && tl.to(rule, duration, {
	        scaleX: 1,
	        ease: Quad.easeInOut
	      }, delay += increment);
	
	      header && tl.to(header, duration, {
	        y: '0%',
	        ease: Quad.easeInOut
	      }, delay += increment);
	
	      subHeader && tl.to(subHeader, duration, {
	        y: '0%',
	        autoAlpha: 1,
	        ease: Quad.easeInOut
	      }, delay += increment);
	
	      button && tl.to(button, duration, {
	        y: '0%',
	        ease: Quad.easeOut
	      }, delay);
	      this.scrollIndicator && _gsap.TweenLite.to(this.scrollIndicator, duration, {
	        opacity: 1,
	        y: 0,
	        delay: 0.5
	      });
	    }
	    if (this.props.startHidden && this.props.show && !nextProps.show) {
	      // hide
	      // console.log('hide text when next props show is false');
	      var _header = this.wrapper.querySelectorAll('.maskDownTitle');
	      var _subHeader = this.wrapper.querySelector('p');
	      var _button = this.wrapper.querySelector('.js-introButton');
	      var _kicker = this.wrapper.querySelector('h5');
	      var _rule = this.wrapper.querySelector('.ch-inner-rule');
	
	      var _duration = 0.6;
	      var _increment = 0.0;
	      var _delay = 0.0;
	
	      {
	        _kicker && _gsap.TweenLite.to(_kicker, _duration, {
	          y: '100%',
	          ease: Quad.easeIn,
	          delay: _delay,
	          onComplete: function onComplete() {
	            _gsap.TweenLite.set(_this2.wrapper, { opacity: 0 });
	          }
	        });
	        _delay += _increment;
	      }
	
	      _rule && _gsap.TweenLite.to(_rule, _duration * 0.5, {
	        scaleX: 0,
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	      _delay += _increment;
	      _header && _gsap.TweenLite.to(_header, _duration, {
	        y: '100%',
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	      _delay += _increment;
	      _subHeader && _gsap.TweenLite.to(_subHeader, _duration, {
	        y: '10%',
	        autoAlpha: 0,
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	      _delay += _increment;
	      _button && _gsap.TweenLite.to(_button, _duration, {
	        y: '100%',
	        ease: Quad.easeOut,
	        delay: _delay
	      });
	
	      this.scrollIndicator && _gsap.TweenLite.to(this.scrollIndicator, _duration, {
	        opacity: 0,
	        y: 20,
	        delay: 0.5
	      });
	    }
	
	    // text back on after chapter transition
	    if (this.props.textExit && !nextProps.textExit) {
	      // console.log('set text back on false textExit prop');
	      var resetElements = [this.wrapper.querySelector('h1'), this.wrapper.querySelector('p'), this.wrapper.querySelector('.js-introButton'), this.wrapper.querySelector('h5')];
	      resetElements.forEach(function (el) {
	        if (el) {
	          el.removeAttribute('style');
	        }
	      });
	    }
	    // text animate off for chapter click
	    if (!this.props.textExit && nextProps.textExit) {
	      // console.log('textExit so hide');
	      // chapter exit text animation
	      var _header2 = this.wrapper.querySelector('h1');
	      var _subHeader2 = this.wrapper.querySelector('p');
	      var _button2 = this.wrapper.querySelector('.js-introButton');
	      var _kicker2 = this.wrapper.querySelector('h5');
	
	      var _tl = new _gsap.TimelineLite();
	      if (_kicker2) {
	        _gsap.TweenLite.to(_kicker2, 0.8, {
	          css: {
	            color: '#FFFFFF'
	          },
	          ease: Circ.easeInOut
	        });
	      }
	
	      _tl.to(_subHeader2, 0.8, {
	        opacity: 0,
	        ease: Circ.easeInOut
	      }).to(_button2, 0.8, {
	        opacity: 0,
	        ease: Circ.easeInOut
	      }, '-=' + 0.8).to(_header2, 0.8, {
	        css: {
	          color: '#FFFFFF'
	        },
	        ease: Circ.easeInOut
	      }, '-=' + 0.8);
	    }
	  };
	
	  IntroWithButton.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        path = _props.path,
	        kicker = _props.kicker,
	        buttonText = _props.buttonText,
	        subtitle = _props.subtitle,
	        colorTheme = _props.colorTheme,
	        scrollIndicator = _props.scrollIndicator,
	        handleClick = _props.handleClick,
	        textWhite = _props.textWhite,
	        noPad = _props.noPad,
	        scrollClass = _props.scrollClass,
	        scrollOffset = _props.scrollOffset,
	        buttonCTA = _props.buttonCTA,
	        index = _props.index,
	        startHidden = _props.startHidden,
	        noMobileRule = _props.noMobileRule,
	        noButton = _props.noButton;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        ref: function ref(el) {
	          _this3.wrapper = el;
	        }
	        // chapter-info
	        , className: 'intro-text ' + _IntroWithButtonModule2.default.infoWrapper + ' ' + this.setThemeClass(colorTheme) + ' ' + (textWhite ? _IntroWithButtonModule2.default.textWhite : '') + ' ' + (noPad ? _IntroWithButtonModule2.default.noPad : '') + ' ' + (startHidden ? _IntroWithButtonModule2.default.startHidden : '') + ' ' + (noMobileRule ? _IntroWithButtonModule2.default.noMobileRule : '')
	      },
	      kicker && _react2.default.createElement(
	        'div',
	        { className: _IntroWithButtonModule2.default.maskWrap },
	        _react2.default.createElement(
	          'h5',
	          null,
	          kicker
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: '' + _IntroWithButtonModule2.default.innerWrap },
	        _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.maskWrap + ' ' + _IntroWithButtonModule2.default.ruleMask },
	          _react2.default.createElement('span', {
	            style: { transformOrigin: '0 50%' },
	            className: 'ch-inner-rule ' + _IntroWithButtonModule2.default.innerRule
	          })
	        ),
	        title && _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.titleWrapper },
	          _react2.default.createElement('h1', {
	            className: 'splitText-' + index,
	            dangerouslySetInnerHTML: { __html: title }
	          })
	        ),
	        subtitle && _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.maskWrap + ' ' + _IntroWithButtonModule2.default.subtitleWrap },
	          _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: subtitle } })
	        ),
	        path && !noButton && _react2.default.createElement(
	          'div',
	          { className: _IntroWithButtonModule2.default.maskWrap },
	          _react2.default.createElement(
	            'div',
	            { className: 'js-introButton' },
	            _react2.default.createElement(_RectButton2.default, {
	              path: path,
	              buttonText: buttonText ? buttonText : 'Explore',
	              handleClick: handleClick
	            })
	          )
	        ),
	        scrollIndicator && _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(el) {
	              _this3.scrollIndicator = el;
	            }
	          },
	          _react2.default.createElement(_ScrollIndicator2.default, {
	            scrollClass: scrollClass,
	            scrollOffset: scrollOffset
	          })
	        )
	      )
	    );
	  };
	
	  return IntroWithButton;
	}(_react.Component);
	
	exports.default = IntroWithButton;
	module.exports = exports['default'];

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"innerRule":"src-components-global----IntroWithButton-module---innerRule---2uz3M","ruleMask":"src-components-global----IntroWithButton-module---ruleMask---I10EJ","noMobileRule":"src-components-global----IntroWithButton-module---noMobileRule---1FH7b","infoWrapper":"src-components-global----IntroWithButton-module---infoWrapper---28Q5L","noPad":"src-components-global----IntroWithButton-module---noPad---uRpVp","textWhite":"src-components-global----IntroWithButton-module---textWhite---1n0fg","startHidden":"src-components-global----IntroWithButton-module---startHidden---3Ik6w","maskDownWrapper":"src-components-global----IntroWithButton-module---maskDownWrapper---1CE5R","subtitleWrap":"src-components-global----IntroWithButton-module---subtitleWrap---3V1MX","maskWrap":"src-components-global----IntroWithButton-module---maskWrap---3ssr6","fadeIn":"src-components-global----IntroWithButton-module---fadeIn---En3ul","fadeInUp":"src-components-global----IntroWithButton-module---fadeInUp---2543W","fadeInUpCenter":"src-components-global----IntroWithButton-module---fadeInUpCenter---1wd9t","fadeInUpSmall":"src-components-global----IntroWithButton-module---fadeInUpSmall---uMzc-","textCoverIn":"src-components-global----IntroWithButton-module---textCoverIn---2WfKk","textCoverOut":"src-components-global----IntroWithButton-module---textCoverOut---38T8k"};

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _introWithWatermarkModule = __webpack_require__(399);
	
	var _introWithWatermarkModule2 = _interopRequireDefault(_introWithWatermarkModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IntroWithWaterMark = function (_Component) {
	  _inherits(IntroWithWaterMark, _Component);
	
	  function IntroWithWaterMark() {
	    _classCallCheck(this, IntroWithWaterMark);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IntroWithWaterMark.prototype.render = function render() {
	    var _props = this.props,
	        watermark = _props.watermark,
	        title = _props.title,
	        label = _props.label,
	        registerTitle = _props.registerTitle,
	        registerWatermark = _props.registerWatermark;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _introWithWatermarkModule2.default.intro },
	      _react2.default.createElement(
	        'div',
	        { className: _introWithWatermarkModule2.default.introInner },
	        label && _react2.default.createElement(
	          'div',
	          { className: _introWithWatermarkModule2.default.label },
	          _react2.default.createElement(
	            'div',
	            { className: 'maskDownLabel' },
	            label
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _introWithWatermarkModule2.default.title },
	          _react2.default.createElement('h1', {
	            ref: registerTitle ? registerTitle : '',
	            className: 'maskDownTitle',
	            dangerouslySetInnerHTML: { __html: title }
	          })
	        )
	      ),
	      watermark && _react2.default.createElement(
	        'div',
	        {
	          ref: registerWatermark ? registerWatermark : '',
	          className: 'fadeOut chapter-watermark ' + _introWithWatermarkModule2.default.watermark
	        },
	        watermark
	      )
	    );
	  };
	
	  return IntroWithWaterMark;
	}(_react.Component);
	
	exports.default = IntroWithWaterMark;
	module.exports = exports['default'];

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var plyr = void 0;
	
	var PlyrComponent = function (_Component) {
	  _inherits(PlyrComponent, _Component);
	
	  function PlyrComponent() {
	    _classCallCheck(this, PlyrComponent);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PlyrComponent.prototype.componentWillMount = function componentWillMount() {
	    var id = void 0;
	    if (this.props.videoData.vimeo_id) {
	      id = this.props.videoData.vimeo_id;
	    } else if (this.props.videoData.youtube_id) {
	      id = this.props.videoData.youtube_id;
	    } else if (this.props.videoData.video_file) {
	      id = this.props.videoData.video_file.id ? this.props.videoData.video_file.id : this.props.videoData.video_file.url;
	    }
	    this.videoId = id;
	  };
	
	  PlyrComponent.prototype.componentDidMount = function componentDidMount() {
	    if (typeof document !== 'undefined') {
	      plyr = __webpack_require__(285);
	    }
	    this.plyr = plyr.setup('#player-' + this.videoId, this.props.options);
	  };
	
	  PlyrComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.isVideoOpen !== this.props.isVideoOpen) {
	      if (this.props.isVideoOpen) {
	        this.plyr[0].play();
	      } else {
	        this.plyr[0].stop();
	      }
	    }
	  };
	
	  // plyr has a bug where destroy on unmount throws an error.
	  // we'll see if we run into any issue here.
	  // componentWillUnmount() {
	  //   if (this.plyr[0] && this.plyr[0].destroy) {
	  //     this.plyr[0].stop();
	  //     this.plyr[0].destroy();
	  //   }
	  // }
	
	  PlyrComponent.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: { height: this.props.isChapter ? '100%' : '' } },
	      this.props.videoData.video_source === 'vimeo' && _react2.default.createElement(
	        'div',
	        { className: 'plyr__video-embed', id: 'player-' + this.videoId },
	        _react2.default.createElement('iframe', {
	          src: 'https://player.vimeo.com/video/' + this.videoId + '?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media',
	          allowFullScreen: true,
	          allowtransparency: 'true',
	          allow: 'autoplay'
	        })
	      ),
	      this.props.videoData.video_source === 'youtube' && _react2.default.createElement(
	        'div',
	        { className: 'plyr__video-embed', id: 'player-' + this.videoId },
	        _react2.default.createElement('iframe', {
	          src: 'https://www.youtube.com/embed/' + this.videoId + '?iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1',
	          allowFullScreen: true,
	          allowtransparency: 'true',
	          allow: 'autoplay'
	        })
	      ),
	      this.props.videoData.video_source === 'mp4_upload' && _react2.default.createElement(
	        'video',
	        {
	          poster: this.props.videoData.image.url,
	          id: 'player-' + this.videoId,
	          playsInline: true,
	          controls: true
	        },
	        _react2.default.createElement('source', {
	          src: this.props.videoData.video_file.url,
	          type: 'video/mp4'
	        })
	      )
	    );
	  };
	
	  return PlyrComponent;
	}(_react.Component);
	
	exports.default = PlyrComponent;
	module.exports = exports['default'];

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(181);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _ArrowButton = __webpack_require__(49);
	
	var _ArrowButton2 = _interopRequireDefault(_ArrowButton);
	
	var _RectButton = __webpack_require__(78);
	
	var _RectButton2 = _interopRequireDefault(_RectButton);
	
	var _SliderWithTextModule = __webpack_require__(841);
	
	var _SliderWithTextModule2 = _interopRequireDefault(_SliderWithTextModule);
	
	var _reactLazy = __webpack_require__(291);
	
	var _CSSPlugin = __webpack_require__(47);
	
	var _gsap = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var plugins = [_CSSPlugin.CSSPlugin];
	
	var LazyImage = function LazyImage(_ref) {
	  var handleOnLoad = _ref.handleOnLoad,
	      handleInView = _ref.handleInView,
	      image = _ref.image,
	      wrapperClass = _ref.wrapperClass,
	      isLoaded = _ref.isLoaded;
	
	  // console.log(Math.min(image.height / image.width, 480 / 640));
	  return _react2.default.createElement(
	    _reactLazy.Lazy,
	    {
	      onViewport: handleInView,
	      threshold: [0.66],
	      onLoad: handleOnLoad,
	      className: wrapperClass,
	      style: {
	        paddingBottom: Math.min(image.height / image.width, 480 / 640) * 100 + '%',
	        height: 0,
	        position: 'relative'
	      }
	    },
	    _react2.default.createElement('img', {
	      src: '' + (image.sizes ? image.sizes.medium_large : image.url),
	      alt: image.alt,
	      className: _SliderWithTextModule2.default.slideImage
	    })
	  );
	};
	
	var SlideShow = function SlideShow(_ref2) {
	  var images = _ref2.images,
	      options = _ref2.options,
	      handleInView = _ref2.handleInView,
	      handleOnLoad = _ref2.handleOnLoad,
	      isLoaded = _ref2.isLoaded;
	
	  return _react2.default.createElement(
	    _reactSlick2.default,
	    _extends({ className: 'timeline-slick ' + _SliderWithTextModule2.default.slideshow }, options),
	    images.map(function (image, index) {
	      if (index === 0) {
	        return _react2.default.createElement(LazyImage, {
	          key: image.title + '-' + index,
	          image: image,
	          handleOnLoad: handleOnLoad,
	          handleInView: handleInView,
	          wrapperClass: _SliderWithTextModule2.default.slideImageWrap
	        });
	      } else {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: image.title + '-' + index,
	            className: _SliderWithTextModule2.default.slideImageWrap
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                paddingBottom: Math.min(image.height / image.width, 480 / 640) * 100 + '%',
	                height: 0,
	                position: 'relative'
	              }
	            },
	            _react2.default.createElement('img', {
	              src: '' + (image.sizes ? image.sizes.medium_large : image.url),
	              alt: image.alt,
	              className: _SliderWithTextModule2.default.slideImage
	            })
	          )
	        );
	      }
	    })
	  );
	};
	
	var SliderWithText = function (_Component) {
	  _inherits(SliderWithText, _Component);
	
	  function SliderWithText() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SliderWithText);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isLoaded: false,
	      isEntered: false
	    }, _this.animateInView = function () {
	      _gsap.TweenLite.to(_this.itemRef, 1.2, {
	        autoAlpha: 1,
	        y: '0%',
	        ease: Quad.easeInOut
	      });
	    }, _this.handleInView = function (event) {
	      if (event.isIntersecting && !_this.state.isEntered && _this.itemRef && _this.props.eraInView) {
	        _this.state.isLoaded && _this.setState({ isEntered: !_this.state.isEntered }, _this.animateInView());
	      }
	    }, _this.handleOnLoad = function () {
	      _this.setState({ isLoaded: true }, _this.handleInView({ isIntersecting: true }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SliderWithText.prototype.componentDidMount = function componentDidMount() {
	    if (this.itemRef) {
	      _gsap.TweenLite.set(this.itemRef, { autoAlpha: 0, y: '5%' });
	    }
	  };
	
	  SliderWithText.prototype.render = function render() {
	    var _this2 = this;
	
	    var slickOptions = {
	      dots: true,
	      infinite: false,
	      arrows: true,
	      speed: 1000,
	      cssEase: 'cubic-bezier(.9, 0, .3, 1)',
	      nextArrow: _react2.default.createElement(_ArrowButton2.default, { direction: 'right' }),
	      prevArrow: _react2.default.createElement(_ArrowButton2.default, { direction: 'left' })
	    };
	    var _props = this.props,
	        title = _props.title,
	        body = _props.body,
	        color_toggle = _props.color_toggle,
	        images = _props.images,
	        cta = _props.cta;
	
	    if (!images[0].url) {
	      return null;
	    }
	    return _react2.default.createElement(
	      'div',
	      { ref: function ref(el) {
	          return _this2.itemRef = el;
	        }, className: _SliderWithTextModule2.default.slideshowWrapper },
	      images.length > 1 ? _react2.default.createElement(SlideShow, {
	        options: slickOptions,
	        images: images,
	        handleInView: this.handleInView,
	        handleOnLoad: this.handleOnLoad,
	        isLoaded: this.state.isLoaded
	      }) : _react2.default.createElement(LazyImage, {
	        image: images[0],
	        handleOnLoad: this.handleOnLoad,
	        handleInView: this.handleInView,
	        wrapperClass: _SliderWithTextModule2.default.imageWrap,
	        isLoaded: this.state.isLoaded
	      }),
	      title && _react2.default.createElement(
	        'div',
	        {
	          className: (color_toggle ? _SliderWithTextModule2.default.slideshowTitleRed : '') + ' ' + _SliderWithTextModule2.default.slideshowTitle
	        },
	        _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: title } })
	      ),
	      body && _react2.default.createElement('p', {
	        className: _SliderWithTextModule2.default.slideshowBody,
	        dangerouslySetInnerHTML: { __html: body }
	      }),
	      cta && _react2.default.createElement(_RectButton2.default, {
	        path: cta[0].path,
	        buttonText: cta[0].text,
	        externalLink: cta[0].externalLink
	      })
	    );
	  };
	
	  return SliderWithText;
	}(_react.Component);
	
	exports.default = SliderWithText;
	module.exports = exports['default'];

/***/ }),

/***/ 841:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"slideshowWrapper":"src-components-global----SliderWithText-module---slideshowWrapper---1O3vH","slideshow":"src-components-global----SliderWithText-module---slideshow---35qu0","imageWrap":"src-components-global----SliderWithText-module---imageWrap---32lqm","slideImageWrap":"src-components-global----SliderWithText-module---slideImageWrap---3Ac-y","slideshowInner":"src-components-global----SliderWithText-module---slideshowInner---3TsQD","slideImage":"src-components-global----SliderWithText-module---slideImage---B-drH","slideshowTitle":"src-components-global----SliderWithText-module---slideshowTitle---Dd7Uv","slideshowTitleRed":"src-components-global----SliderWithText-module---slideshowTitleRed---3V2GB","slideshowBody":"src-components-global----SliderWithText-module---slideshowBody---25Fe2","fadeIn":"src-components-global----SliderWithText-module---fadeIn---1IuI_","fadeInUp":"src-components-global----SliderWithText-module---fadeInUp---1HjtL","fadeInUpCenter":"src-components-global----SliderWithText-module---fadeInUpCenter---3Vyvu","fadeInUpSmall":"src-components-global----SliderWithText-module---fadeInUpSmall---3f2KF","textCoverIn":"src-components-global----SliderWithText-module---textCoverIn---20XJh","textCoverOut":"src-components-global----SliderWithText-module---textCoverOut---14IIW"};

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"intro":"src-components-global----introWithWatermark-module---intro---3VAGQ","introInner":"src-components-global----introWithWatermark-module---introInner---3B6Xo","label":"src-components-global----introWithWatermark-module---label---3TsuZ","title":"src-components-global----introWithWatermark-module---title---7gnH0","watermark":"src-components-global----introWithWatermark-module---watermark---JVaOR","fadeIn":"src-components-global----introWithWatermark-module---fadeIn---mB1FB","fadeInUp":"src-components-global----introWithWatermark-module---fadeInUp---JLIWT","fadeInUpCenter":"src-components-global----introWithWatermark-module---fadeInUpCenter---3B2qF","fadeInUpSmall":"src-components-global----introWithWatermark-module---fadeInUpSmall---346YL","textCoverIn":"src-components-global----introWithWatermark-module---textCoverIn---1a68m","textCoverOut":"src-components-global----introWithWatermark-module---textCoverOut---b426M"};

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stickybits = __webpack_require__(979);
	
	var _stickybits2 = _interopRequireDefault(_stickybits);
	
	var _EraHero = __webpack_require__(523);
	
	var _EraHero2 = _interopRequireDefault(_EraHero);
	
	var _ContentGrid = __webpack_require__(512);
	
	var _ContentGrid2 = _interopRequireDefault(_ContentGrid);
	
	var _QuoteBanner = __webpack_require__(524);
	
	var _QuoteBanner2 = _interopRequireDefault(_QuoteBanner);
	
	var _TimelineModule = __webpack_require__(481);
	
	var _TimelineModule2 = _interopRequireDefault(_TimelineModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Era = function (_Component) {
	  _inherits(Era, _Component);
	
	  function Era() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Era);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      inViewport: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Era.prototype.componentDidMount = function componentDidMount() {
	    (0, _stickybits2.default)('.era-watermark', {
	      stickyBitStickyOffset: 300
	    });
	    // console.log('did mount', this.props.index);
	    this.props.getIsMountedIndex(this.props.index);
	  };
	
	  Era.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.inView !== this.props.inView && this.props.inView && !this.state.inViewport) {
	      this.setState({ inViewport: true });
	      this.props.getInViewIndex(this.props.index);
	    }
	  };
	
	  Era.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        lastHeader = _props.lastHeader,
	        goToAbout = _props.goToAbout;
	
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'era-watermark ' + _TimelineModule2.default.eraWatermark },
	        this.props.data.starting_year,
	        '-',
	        this.props.data.ending_year
	      ),
	      _react2.default.createElement(_EraHero2.default, this.props.data),
	      this.props.data.era_content && this.props.data.era_content.map(function (content, i) {
	        switch (content.era_type) {
	          case 'content_grid':
	            return _react2.default.createElement(_ContentGrid2.default, _extends({
	              eraInView: _this2.props.inLoadedArray,
	              key: '' + _this2.props.data.starting_year + i
	            }, content));
	          case 'quote_banner':
	            return _react2.default.createElement(_QuoteBanner2.default, _extends({
	              eraInView: _this2.props.inLoadedArray,
	              key: '' + _this2.props.data.starting_year + i
	            }, content));
	          default:
	            return '';
	        }
	      }),
	      lastHeader !== null && _react2.default.createElement(_EraHero2.default, _extends({ last: true }, lastHeader, { goToAbout: goToAbout }))
	    );
	  };
	
	  return Era;
	}(_react.Component);
	
	exports.default = Era;
	module.exports = exports['default'];

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IntroWithWatermark = __webpack_require__(344);
	
	var _IntroWithWatermark2 = _interopRequireDefault(_IntroWithWatermark);
	
	var _NextSectionArrow = __webpack_require__(342);
	
	var _NextSectionArrow2 = _interopRequireDefault(_NextSectionArrow);
	
	var _EraHeroModule = __webpack_require__(844);
	
	var _EraHeroModule2 = _interopRequireDefault(_EraHeroModule);
	
	var _reactLazy = __webpack_require__(291);
	
	var _gsap = __webpack_require__(11);
	
	var _CSSPlugin = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var plugins = [_CSSPlugin.CSSPlugin];
	var SplitText = void 0;
	
	var EraHero = function (_Component) {
	  _inherits(EraHero, _Component);
	
	  function EraHero() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EraHero);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      entered: false
	    }, _this.registerTitle = function (el) {
	      return _this.titleRef = el;
	    }, _this.registerWatermark = function (el) {
	      return _this.watermarkRef = el;
	    }, _this.animateInView = function () {
	      var tl = new _gsap.TimelineLite({
	        onComplete: function onComplete() {}
	      });
	
	      _this.imageRef && tl.to(_this.imageRef, 5, { scale: 1, autoAlpha: 1, ease: Quad.easeOut }, 0);
	
	      _this.watermarkRef && tl.to(_this.watermarkRef, 0.85, { y: '0%', ease: Quad.easeOut }, 0);
	
	      _this.ruleRef && tl.to(_this.ruleRef, 1.15, { scaleX: 1, ease: Quad.easeOut }, 0.1);
	
	      _this.splitTitle && tl.staggerTo(_this.splitTitle.words, 0.5, { y: '0%', ease: Quad.easeOut }, 0.05, 0.75);
	
	      _this.splitDesc && tl.staggerTo(_this.splitDesc.words, 0.5, { y: '0%', ease: Quad.easeOut }, 0.05, 0.75);
	    }, _this.handleInView = function (event) {
	      if (event.isIntersecting && !_this.state.entered) {
	        _this.setState({ entered: !_this.state.entered });
	        _this.animateInView();
	      }
	    }, _this.wrap = function (splitText) {
	      splitText.forEach(function (splitElement) {
	        var element = void 0;
	        if (typeof document !== 'undefined') {
	          element = document.createElement('span');
	        }
	        if (splitElement.parentNode.tagName === 'STRONG') {
	          splitElement.parentNode.className = _EraHeroModule2.default.maskDownWrapper;
	        } else {
	          element.className = _EraHeroModule2.default.maskDownWrapper;
	          splitElement.parentNode.insertBefore(element, splitElement);
	          element.appendChild(splitElement);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  EraHero.prototype.componentDidMount = function componentDidMount() {
	    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== undefined && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
	      SplitText = __webpack_require__(144);
	    }
	    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== undefined && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
	      this.splitDesc = this.descRef && new SplitText(this.descRef, {
	        type: 'words',
	        wordsClass: 'maskDownTitle'
	      });
	
	      this.splitTitle = this.titleRef && new SplitText(this.titleRef, {
	        type: 'words',
	        wordsClass: 'maskDownTitle'
	      });
	
	      this.watermarkRef && this.wrap([this.watermarkRef]);
	      this.splitTitle && this.wrap(this.splitTitle.words);
	      this.splitDesc && this.wrap(this.splitDesc.words);
	
	      this.ruleRef && _gsap.TweenLite.set(this.ruleRef, { scaleX: 0 });
	      this.imageRef && _gsap.TweenLite.set(this.imageRef, { scale: 1.2 });
	      this.watermarkRef && _gsap.TweenLite.set(this.watermarkRef, { y: '100%' });
	      // TweenLite.set(this.descRef, { css: { maxWidth: 'initial' } });
	      this.splitDesc && _gsap.TweenLite.set(this.splitDesc.words, { y: '100%' });
	      this.splitTitle && _gsap.TweenLite.set(this.splitTitle.words, { y: '100%' });
	    }
	  };
	
	  EraHero.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        starting_year = _props.starting_year,
	        ending_year = _props.ending_year,
	        image = _props.image,
	        short_description = _props.short_description,
	        title = _props.title,
	        watermark = _props.watermark,
	        last = _props.last,
	        goToAbout = _props.goToAbout;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'timeline-start ' + _EraHeroModule2.default.eraHero + ' ' + (last ? _EraHeroModule2.default.lastHero : ''),
	        id: 'years' + starting_year
	      },
	      _react2.default.createElement('img', {
	        ref: function ref(el) {
	          return _this2.imageRef = el;
	        },
	        src: image.url,
	        alt: image.alt,
	        className: _EraHeroModule2.default.eraHeroImage
	      }),
	      _react2.default.createElement('span', { className: _EraHeroModule2.default.overlay }),
	      _react2.default.createElement(
	        _reactLazy.Observer,
	        {
	          onChange: this.handleInView,
	          threshold: [0.85],
	          triggerOnce: true
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _EraHeroModule2.default.eraHeroWrapper },
	          _react2.default.createElement(_IntroWithWatermark2.default, {
	            title: title,
	            registerTitle: this.registerTitle,
	            registerWatermark: this.props.watermark ? this.registerWatermark : false,
	            watermark: watermark
	          }),
	          _react2.default.createElement('div', { ref: function ref(el) {
	              return _this2.ruleRef = el;
	            }, className: _EraHeroModule2.default.rule }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('p', {
	              ref: function ref(el) {
	                return _this2.descRef = el;
	              },
	              className: _EraHeroModule2.default.eraDescription,
	              dangerouslySetInnerHTML: {
	                __html: short_description
	              }
	            }),
	            last && _react2.default.createElement(_NextSectionArrow2.default, {
	              isTimeline: true,
	              goToNextSection: goToAbout,
	              arrowStyle: 'white',
	              isLastSection: this.state.entered
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return EraHero;
	}(_react.Component);
	
	exports.default = EraHero;
	module.exports = exports['default'];

/***/ }),

/***/ 844:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"maskDownWrapper":"src-components-timeline----EraHero-module---maskDownWrapper---J2G-W","eraHero":"src-components-timeline----EraHero-module---eraHero---33QPN","fadeInUp":"src-components-timeline----EraHero-module---fadeInUp---3y6HE","imageContainer":"src-components-timeline----EraHero-module---imageContainer---1LcD3","eraHeroWrapper":"src-components-timeline----EraHero-module---eraHeroWrapper---1aqDO","rule":"src-components-timeline----EraHero-module---rule---1LZ0Q","eraHeroImage":"src-components-timeline----EraHero-module---eraHeroImage---2Pj26","overlay":"src-components-timeline----EraHero-module---overlay---2CHAO","eraDescription":"src-components-timeline----EraHero-module---eraDescription---1KQ78","lastHero":"src-components-timeline----EraHero-module---lastHero---2NTs-","fadeIn":"src-components-timeline----EraHero-module---fadeIn---3PaBs","fadeInUpCenter":"src-components-timeline----EraHero-module---fadeInUpCenter---3UcIE","fadeInUpSmall":"src-components-timeline----EraHero-module---fadeInUpSmall---2NGqQ","textCoverIn":"src-components-timeline----EraHero-module---textCoverIn---3Kmuv","textCoverOut":"src-components-timeline----EraHero-module---textCoverOut---2ZUI6"};

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _QuoteBannerModule = __webpack_require__(845);
	
	var _QuoteBannerModule2 = _interopRequireDefault(_QuoteBannerModule);
	
	var _QuotationMark_Red = __webpack_require__(163);
	
	var _QuotationMark_Red2 = _interopRequireDefault(_QuotationMark_Red);
	
	var _reactIntersectionObserver = __webpack_require__(180);
	
	var _reactIntersectionObserver2 = _interopRequireDefault(_reactIntersectionObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuoteBanner = function QuoteBanner(_ref) {
	  var body = _ref.body,
	      image = _ref.image,
	      attribution = _ref.attribution,
	      _ref$isQuote = _ref.isQuote,
	      isQuote = _ref$isQuote === undefined ? true : _ref$isQuote;
	
	  return _react2.default.createElement(
	    _reactIntersectionObserver2.default,
	    { className: _QuoteBannerModule2.default.quoteBanner, threshold: 0.65, triggerOnce: true },
	    function (inview) {
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        image && _react2.default.createElement('img', {
	          src: image.url,
	          alt: image.alt,
	          className: (inview ? _QuoteBannerModule2.default.fadeIn : '') + ' ' + _QuoteBannerModule2.default.quoteImage
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: (inview ? _QuoteBannerModule2.default.fadeInUp : '') + ' ' + _QuoteBannerModule2.default.quoteText },
	          body && isQuote && _react2.default.createElement(
	            'div',
	            { className: _QuoteBannerModule2.default.quoteIcon },
	            _react2.default.createElement(_QuotationMark_Red2.default, null)
	          ),
	          body && _react2.default.createElement('h4', { dangerouslySetInnerHTML: { __html: body } }),
	          attribution && isQuote && _react2.default.createElement(
	            'p',
	            null,
	            attribution
	          )
	        )
	      );
	    }
	  );
	};
	
	exports.default = QuoteBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"quoteBanner":"src-components-timeline----QuoteBanner-module---quoteBanner---1fXch","quoteText":"src-components-timeline----QuoteBanner-module---quoteText---qIJmD","quoteIcon":"src-components-timeline----QuoteBanner-module---quoteIcon---xMUOY","quoteImageWrap":"src-components-timeline----QuoteBanner-module---quoteImageWrap---3CNqG","quoteImage":"src-components-timeline----QuoteBanner-module---quoteImage---2IbC0","fadeIn":"src-components-timeline----QuoteBanner-module---fadeIn---JAFOU","fadeInUp":"src-components-timeline----QuoteBanner-module---fadeInUp---1sjNx","fadeInUpCenter":"src-components-timeline----QuoteBanner-module---fadeInUpCenter---15v2h","fadeInUpSmall":"src-components-timeline----QuoteBanner-module---fadeInUpSmall---2EWOp","textCoverIn":"src-components-timeline----QuoteBanner-module---textCoverIn---3sLei","textCoverOut":"src-components-timeline----QuoteBanner-module---textCoverOut---34WMD"};

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimelineTextModule = __webpack_require__(846);
	
	var _TimelineTextModule2 = _interopRequireDefault(_TimelineTextModule);
	
	var _reactLazy = __webpack_require__(291);
	
	var _CSSPlugin = __webpack_require__(47);
	
	var _gsap = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var plugins = [_CSSPlugin.CSSPlugin];
	
	var TimelineText = function (_Component) {
	  _inherits(TimelineText, _Component);
	
	  function TimelineText() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimelineText);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isEntered: false
	    }, _this.animateInView = function () {
	      _gsap.TweenLite.to(_this.itemRef, 1.2, {
	        autoAlpha: 1,
	        y: '0%',
	        ease: Quad.easeInOut
	      });
	    }, _this.handleInView = function (event) {
	      if (event.isIntersecting && !_this.state.isEntered) {
	        _this.setState({ isEntered: !_this.state.isEntered }, _this.animateInView());
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TimelineText.prototype.componentDidMount = function componentDidMount() {
	    _gsap.TweenLite.set(this.itemRef, { autoAlpha: 0, y: '5%' });
	  };
	
	  TimelineText.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        body = _props.body,
	        color_toggle = _props.color_toggle;
	
	    return _react2.default.createElement(
	      'div',
	      { ref: function ref(el) {
	          return _this2.itemRef = el;
	        }, className: _TimelineTextModule2.default.textWrapper },
	      _react2.default.createElement(
	        _reactLazy.Observer,
	        { onChange: this.handleInView, threshold: [0.66] },
	        _react2.default.createElement('h1', {
	          className: color_toggle ? _TimelineTextModule2.default.slideshowTitleRed : '',
	          dangerouslySetInnerHTML: { __html: body }
	        })
	      )
	    );
	  };
	
	  return TimelineText;
	}(_react.Component);
	
	exports.default = TimelineText;
	module.exports = exports['default'];

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"textWrapper":"src-components-timeline----TimelineText-module---textWrapper---1FJaN","slideshowTitleRed":"src-components-timeline----TimelineText-module---slideshowTitleRed---3G-m0","fadeIn":"src-components-timeline----TimelineText-module---fadeIn---2vKiJ","fadeInUp":"src-components-timeline----TimelineText-module---fadeInUp---SuzG1","fadeInUpCenter":"src-components-timeline----TimelineText-module---fadeInUpCenter---2S4Ui","fadeInUpSmall":"src-components-timeline----TimelineText-module---fadeInUpSmall---27Mj9","textCoverIn":"src-components-timeline----TimelineText-module---textCoverIn---3dPOm","textCoverOut":"src-components-timeline----TimelineText-module---textCoverOut---22OP2"};

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlyrComponent = __webpack_require__(183);
	
	var _PlyrComponent2 = _interopRequireDefault(_PlyrComponent);
	
	var _TimelineVideoModule = __webpack_require__(847);
	
	var _TimelineVideoModule2 = _interopRequireDefault(_TimelineVideoModule);
	
	var _reactIntersectionObserver = __webpack_require__(180);
	
	var _reactIntersectionObserver2 = _interopRequireDefault(_reactIntersectionObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimelineVideo = function TimelineVideo(props) {
	  var plyrOptions = {
	    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'fullscreen']
	  };
	
	  var hasVideo = function hasVideo() {
	    return props.video_file.url || props.youtube_id || props.vimeo_id;
	  };
	
	  return hasVideo() && _react2.default.createElement(
	    _reactIntersectionObserver2.default,
	    {
	      className: 'timeline-video ' + _TimelineVideoModule2.default.videoWrapper,
	      triggerOnce: true
	    },
	    function (inview) {
	      return _react2.default.createElement(
	        'div',
	        { className: _TimelineVideoModule2.default.wrap + ' ' + (inview ? _TimelineVideoModule2.default.fadeInUp : '') },
	        hasVideo() && _react2.default.createElement(_PlyrComponent2.default, { options: plyrOptions, videoData: props }),
	        props.title && _react2.default.createElement(
	          'div',
	          { className: _TimelineVideoModule2.default.videoTitle },
	          _react2.default.createElement(
	            'h4',
	            null,
	            props.title
	          )
	        ),
	        props.body && _react2.default.createElement('p', {
	          className: _TimelineVideoModule2.default.slideshowBody,
	          dangerouslySetInnerHTML: { __html: props.body }
	        })
	      );
	    }
	  );
	};
	
	exports.default = TimelineVideo;
	module.exports = exports['default'];

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"videoWrapper":"src-components-timeline----TimelineVideo-module---videoWrapper---QJ2IA","videoTitle":"src-components-timeline----TimelineVideo-module---videoTitle---1HjF3","wrap":"src-components-timeline----TimelineVideo-module---wrap---2vkoU","fadeInUp":"src-components-timeline----TimelineVideo-module---fadeInUp---2XKHf","slideshowBody":"src-components-timeline----TimelineVideo-module---slideshowBody---1cEXl","fadeIn":"src-components-timeline----TimelineVideo-module---fadeIn---3XeCA","fadeInUpCenter":"src-components-timeline----TimelineVideo-module---fadeInUpCenter---2RHok","fadeInUpSmall":"src-components-timeline----TimelineVideo-module---fadeInUpSmall---3gWhA","textCoverIn":"src-components-timeline----TimelineVideo-module---textCoverIn---33n2_","textCoverOut":"src-components-timeline----TimelineVideo-module---textCoverOut---2i27o"};

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30.66 24.21" },
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "title",
	      null,
	      "Quote Matks"
	    ),
	    _react2.default.createElement("path", {
	      fill: "#d6434f",
	      d: "M13.66,18.42a5.78,5.78,0,0,1-.82,3.08,5.46,5.46,0,0,1-2.2,2,6.43,6.43,0,0,1-2.91.7,7.2,7.2,0,0,1-5.26-2.64C.82,19.81,0,17.35,0,14.17A13.84,13.84,0,0,1,3.42,4.69Q6.86.8,13.15,0V3.37A14.36,14.36,0,0,0,6.57,6.21a6.52,6.52,0,0,0-2.51,5.25q0,1.8,1.29,1.8a17.94,17.94,0,0,1,3-.37A5.2,5.2,0,0,1,12,14.46,5.28,5.28,0,0,1,13.66,18.42Z"
	    }),
	    _react2.default.createElement("path", {
	      fill: "#d6434f",
	      d: "M30.66,18.42a5.78,5.78,0,0,1-.82,3.08,5.46,5.46,0,0,1-2.2,2,6.43,6.43,0,0,1-2.91.7,7.2,7.2,0,0,1-5.26-2.64C17.82,19.81,17,17.35,17,14.17a13.84,13.84,0,0,1,3.42-9.48Q23.86.8,30.15,0V3.37a14.36,14.36,0,0,0-6.58,2.84,6.52,6.52,0,0,0-2.51,5.25q0,1.8,1.29,1.8a17.94,17.94,0,0,1,3-.37A5.2,5.2,0,0,1,29,14.46,5.28,5.28,0,0,1,30.66,18.42Z"
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RectButtonModule = __webpack_require__(158);
	
	var _RectButtonModule2 = _interopRequireDefault(_RectButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// if path is passed, renders a link (which can also take a click handler)
	// If no path, it renders a button
	var RectButton = function RectButton(_ref) {
	  var path = _ref.path,
	      buttonText = _ref.buttonText,
	      externalLink = _ref.externalLink,
	      handleClick = _ref.handleClick;
	  return path ? _react2.default.createElement(
	    'a',
	    {
	      href: path,
	      className: 'chapter-button ' + _RectButtonModule2.default.rectButton,
	      target: externalLink ? '_blank' : '',
	      rel: externalLink ? 'noopener' : '',
	      onClick: handleClick ? handleClick : function () {}
	    },
	    buttonText
	  ) : _react2.default.createElement(
	    'button',
	    {
	      className: 'chapter-button ' + _RectButtonModule2.default.rectButton,
	      onClick: handleClick
	    },
	    buttonText
	  );
	};
	
	exports.default = RectButton;
	module.exports = exports['default'];

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"rectButton":"src-components-ui----RectButton-module---rectButton---kOGDP","fadeIn":"src-components-ui----RectButton-module---fadeIn---2i_MH","fadeInUp":"src-components-ui----RectButton-module---fadeInUp---1Klsv","fadeInUpCenter":"src-components-ui----RectButton-module---fadeInUpCenter---24B-G","fadeInUpSmall":"src-components-ui----RectButton-module---fadeInUpSmall---2LhD0","textCoverIn":"src-components-ui----RectButton-module---textCoverIn---1AHwq","textCoverOut":"src-components-ui----RectButton-module---textCoverOut---2lqeu"};

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jump = __webpack_require__(81);
	
	var _jump2 = _interopRequireDefault(_jump);
	
	var _ArrowButton = __webpack_require__(49);
	
	var _ArrowButton2 = _interopRequireDefault(_ArrowButton);
	
	var _ScrollIndicatorModule = __webpack_require__(159);
	
	var _ScrollIndicatorModule2 = _interopRequireDefault(_ScrollIndicatorModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Smooth scroll to content start
	var scrollClick = function scrollClick(scrollClass, scrollOffset) {
	  (0, _jump2.default)(scrollClass, {
	    offset: scrollOffset
	  });
	};
	
	var ScrollIndicator = function ScrollIndicator(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      className: _ScrollIndicatorModule2.default.scrollIndicator,
	      onClick: function onClick() {
	        scrollClick(props.scrollClass, props.scrollOffset);
	      }
	    },
	    _react2.default.createElement(_ArrowButton2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: _ScrollIndicatorModule2.default.scrollText },
	      'Scroll'
	    )
	  );
	};
	
	exports.default = ScrollIndicator;
	module.exports = exports['default'];

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"scrollIndicator":"src-components-ui----ScrollIndicator-module---scrollIndicator---3-hD6","scrollText":"src-components-ui----ScrollIndicator-module---scrollText---7KuIx","fadeIn":"src-components-ui----ScrollIndicator-module---fadeIn---2RGcS","fadeInUp":"src-components-ui----ScrollIndicator-module---fadeInUp---XKTTZ","fadeInUpCenter":"src-components-ui----ScrollIndicator-module---fadeInUpCenter---2JaVr","fadeInUpSmall":"src-components-ui----ScrollIndicator-module---fadeInUpSmall---10Khg","textCoverIn":"src-components-ui----ScrollIndicator-module---textCoverIn---MwX7O","textCoverOut":"src-components-ui----ScrollIndicator-module---textCoverOut---1_0em"};

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"timeline":"src-templates----Timeline-module---timeline---3K2qe","exiting":"src-templates----Timeline-module---exiting---39HmH","chapterInfoWrapper":"src-templates----Timeline-module---chapterInfoWrapper---3DYtS","eraGrid":"src-templates----Timeline-module---eraGrid---oeNG-","eraWatermark":"src-templates----Timeline-module---eraWatermark---T71jL","fadeIn":"src-templates----Timeline-module---fadeIn---axRNL","fadeInUp":"src-templates----Timeline-module---fadeInUp---17BUE","fadeInUpCenter":"src-templates----Timeline-module---fadeInUpCenter---28icK","fadeInUpSmall":"src-templates----Timeline-module---fadeInUpSmall---oEn8D","textCoverIn":"src-templates----Timeline-module---textCoverIn---3yzlm","textCoverOut":"src-templates----Timeline-module---textCoverOut---3yp1-"};

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.timelineQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(55);
	
	var _IntroWithButton = __webpack_require__(82);
	
	var _IntroWithButton2 = _interopRequireDefault(_IntroWithButton);
	
	var _Era = __webpack_require__(522);
	
	var _Era2 = _interopRequireDefault(_Era);
	
	var _TimelineModule = __webpack_require__(481);
	
	var _TimelineModule2 = _interopRequireDefault(_TimelineModule);
	
	var _reactIntersectionObserver = __webpack_require__(180);
	
	var _reactIntersectionObserver2 = _interopRequireDefault(_reactIntersectionObserver);
	
	var _reactHelmet = __webpack_require__(179);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _jump = __webpack_require__(81);
	
	var _jump2 = _interopRequireDefault(_jump);
	
	var _constants = __webpack_require__(410);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Timeline = function (_Component) {
	  _inherits(Timeline, _Component);
	
	  function Timeline() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Timeline);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.timelineData = _this.props.data.timeline, _this.targetIndex = -1, _this.state = {
	      reveal: false,
	      loadedEraIndices: [],
	      eraMounted: []
	    }, _this.handleOnChange = function (oberver, index) {
	      if (oberver && !_this.state.loadedEraIndices.includes(index)) {
	        _this.handleEraLoaded(index);
	      }
	    }, _this.handleEraSkipped = function () {
	      var eraSkip = _this.props.registerEraSkip();
	      console.log(eraSkip);
	    }, _this.handleEraMounted = function (index) {
	      if (_this.state.eraMounted.includes(index)) return;
	
	      _this.setState({
	        eraMounted: [].concat(_this.state.eraMounted, [index])
	      });
	
	      if (_this.targetIndex === _this.props.targetEra.index) {
	        _this.targetIndex = -1;
	        _this.props.targetEra.skipTo();
	      }
	    }, _this.handleEraLoaded = function (index) {
	      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	      var tempIndices = _this.state.loadedEraIndices;
	
	      tempIndices.push(index);
	
	      _this.setState({
	        loadedEraIndices: tempIndices
	      });
	    }, _this.handleGoToAbout = function () {
	      var path = _this.props.settingsContent.menu.filter(function (data) {
	        return data.title === 'About';
	      })[0].path;
	      (0, _gatsbyLink.navigateTo)(path);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Timeline.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.setState({ reveal: true });
	    }, 300);
	    this.props.resetDisplaySettings();
	    this.props.setHeaderTransparent(false);
	    // console.log(this.timelineData);
	  };
	
	  Timeline.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.setHeaderTransparent(true);
	  };
	
	  Timeline.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var bothNegativeOne = this.targetIndex === -1 && this.props.targetEra.index === -1;
	    if (this.targetIndex !== this.props.targetEra.index || bothNegativeOne) {
	      this.targetIndex = nextProps.targetEra.index;
	      if (this.props.targetEra.index !== nextProps.targetEra.index) {
	        if (this.state.eraMounted.includes(this.targetIndex) || this.state.loadedEraIndices.includes(this.targetIndex)) {
	          this.targetIndex = -1;
	          nextProps.targetEra.skipTo();
	        } else {
	          for (var i = 0; i <= nextProps.targetEra.index; i++) {
	            this.handleEraLoaded(i);
	          }
	        }
	      } else if (this.props.targetEra.index === nextProps.targetEra.index) {
	        this.targetIndex = -1;
	        this.props.targetEra.skipTo();
	      }
	    }
	  };
	
	  Timeline.prototype.render = function render() {
	    var _this3 = this;
	
	    var lastHeader = this.timelineData.eras.filter(function (era, index) {
	      return era.add_link_to_about_page === true;
	    });
	
	    var filteredEras = this.timelineData.eras.filter(function (era, index) {
	      return !era.add_link_to_about_page;
	    });
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _TimelineModule2.default.timeline + ' ' + (this.props.transition && this.props.transition.status === 'exiting' ? _TimelineModule2.default.exiting : '')
	      },
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Timeline | The House on Henry Street' }),
	      _react2.default.createElement(
	        'div',
	        { className: _TimelineModule2.default.chapterInfoWrapper },
	        _react2.default.createElement(_IntroWithButton2.default, {
	          title: this.timelineData.title,
	          subtitle: this.timelineData.description,
	          scrollIndicator: true,
	          scrollClass: '.timeline-start',
	          scrollOffset: -90,
	          doSplitText: true,
	          startHidden: true,
	          show: !this.props.introIsShowing && this.state.reveal
	        })
	      ),
	      this.timelineData && filteredEras.map(function (era, i) {
	        return !era.add_link_to_about_page && _react2.default.createElement(
	          _reactIntersectionObserver2.default,
	          {
	            onChange: function onChange(e) {
	              return _this3.handleOnChange(e, i);
	            },
	            key: 'era-' + i + '-' + era.starting_year,
	            className: _TimelineModule2.default.eraGrid,
	            rootMargin: '50% 0% 50% 0%'
	          },
	          _this3.state.loadedEraIndices.includes(i) ? _react2.default.createElement(_Era2.default, {
	            index: i,
	            getInViewIndex: _this3.handleEraLoaded,
	            getIsMountedIndex: _this3.handleEraMounted,
	            lastHeader: i === filteredEras.length - 1 ? lastHeader[0] : null,
	            goToAbout: _this3.handleGoToAbout,
	            inLoadedArray: _this3.state.loadedEraIndices.includes(i),
	            data: era
	          }) : _react2.default.createElement('div', {
	            id: 'years' + era.starting_year,
	            style: {
	              display: 'block',
	              height: '100vh',
	              width: '100%'
	            }
	          })
	        );
	      })
	    );
	  };
	
	  return Timeline;
	}(_react.Component);
	
	exports.default = Timeline;
	var timelineQuery = exports.timelineQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-timeline-js-a1811bbb8f138d1578bb.js